/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkshopRouteImport } from './routes/workshop'
import { Route as WhatsappRouteImport } from './routes/whatsapp'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as UtilitiesRouteImport } from './routes/utilities'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as TransactionHubRouteImport } from './routes/transaction-hub'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupplierPortalRouteImport } from './routes/supplier-portal'
import { Route as SupplierLoginRouteImport } from './routes/supplier-login'
import { Route as StockRouteImport } from './routes/stock'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SchemeRouteImport } from './routes/scheme'
import { Route as SaasAdminRouteImport } from './routes/saas-admin'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RepairRouteImport } from './routes/repair'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as OtpLoginRouteImport } from './routes/otp-login'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MtgRouteImport } from './routes/mtg'
import { Route as MeltRouteImport } from './routes/melt'
import { Route as MasterRouteImport } from './routes/master'
import { Route as ManufacturingRouteImport } from './routes/manufacturing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LedgerRouteImport } from './routes/ledger'
import { Route as KarigarPortalRouteImport } from './routes/karigar-portal'
import { Route as KarigarLoginRouteImport } from './routes/karigar-login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CustomerPortalRouteImport } from './routes/customer-portal'
import { Route as CustomerLoginRouteImport } from './routes/customer-login'
import { Route as CompanyAdminRouteImport } from './routes/company-admin'
import { Route as CommunicationsRouteImport } from './routes/communications'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as BarcodeRouteImport } from './routes/barcode'
import { Route as AttendanceRouteImport } from './routes/attendance'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as AppRouteImport } from './routes/app'
import { Route as AiCenterRouteImport } from './routes/ai-center'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkshopIndexRouteImport } from './routes/workshop.index'
import { Route as WhatsappIndexRouteImport } from './routes/whatsapp.index'
import { Route as UtilitiesIndexRouteImport } from './routes/utilities.index'
import { Route as StockIndexRouteImport } from './routes/stock.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SchemeIndexRouteImport } from './routes/scheme.index'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as RepairIndexRouteImport } from './routes/repair.index'
import { Route as RefineryIndexRouteImport } from './routes/refinery.index'
import { Route as PeopleIndexRouteImport } from './routes/people.index'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as MtgIndexRouteImport } from './routes/mtg.index'
import { Route as MobileIndexRouteImport } from './routes/mobile.index'
import { Route as MeltIndexRouteImport } from './routes/melt.index'
import { Route as ManufacturingIndexRouteImport } from './routes/manufacturing.index'
import { Route as HardwareIndexRouteImport } from './routes/hardware/index'
import { Route as ExpensesIndexRouteImport } from './routes/expenses.index'
import { Route as ConversionIndexRouteImport } from './routes/conversion.index'
import { Route as CommunicationsIndexRouteImport } from './routes/communications.index'
import { Route as CatalogIndexRouteImport } from './routes/catalog.index'
import { Route as BranchesIndexRouteImport } from './routes/branches.index'
import { Route as BillingIndexRouteImport } from './routes/billing.index'
import { Route as AttendanceIndexRouteImport } from './routes/attendance.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AccountsIndexRouteImport } from './routes/accounts.index'
import { Route as WorkshopWorkerBooksRouteImport } from './routes/workshop.worker-books'
import { Route as WorkshopVibratorRouteImport } from './routes/workshop.vibrator'
import { Route as WorkshopReconciliationRouteImport } from './routes/workshop.reconciliation'
import { Route as WorkshopPolishingBooksRouteImport } from './routes/workshop.polishing-books'
import { Route as WorkshopPolishingRouteImport } from './routes/workshop.polishing'
import { Route as WorkshopOutsideWorkerBooksRouteImport } from './routes/workshop.outside-worker-books'
import { Route as WorkshopOutsideWorkRouteImport } from './routes/workshop.outside-work'
import { Route as WorkshopKarigarBookRouteImport } from './routes/workshop.karigar-book'
import { Route as WorkshopJangadRouteImport } from './routes/workshop.jangad'
import { Route as WorkshopJamaRouteImport } from './routes/workshop.jama'
import { Route as WorkshopGoldBookRouteImport } from './routes/workshop.gold-book'
import { Route as WorkshopDhadiGroupsRouteImport } from './routes/workshop.dhadi-groups'
import { Route as WorkshopBenchCustodyRouteImport } from './routes/workshop.bench-custody'
import { Route as WorkshopBarcodeScannerRouteImport } from './routes/workshop.barcode-scanner'
import { Route as WorkshopIdRouteImport } from './routes/workshop.$id'
import { Route as UtilitiesWipeoutRouteImport } from './routes/utilities.wipeout'
import { Route as UtilitiesUrdPurchaseRouteImport } from './routes/utilities.urd-purchase'
import { Route as UtilitiesSubAccountsRouteImport } from './routes/utilities.sub-accounts'
import { Route as UtilitiesSaudaBookRouteImport } from './routes/utilities.sauda-book'
import { Route as UtilitiesPatlaStockRouteImport } from './routes/utilities.patla-stock'
import { Route as UtilitiesOpeningFineCashRouteImport } from './routes/utilities.opening-fine-cash'
import { Route as UtilitiesItemTransactionRouteImport } from './routes/utilities.item-transaction'
import { Route as UtilitiesItemMastersRouteImport } from './routes/utilities.item-masters'
import { Route as UtilitiesGstCalculatorRouteImport } from './routes/utilities.gst-calculator'
import { Route as UtilitiesCounterSettingsRouteImport } from './routes/utilities.counter-settings'
import { Route as UtilitiesCashFineTransferRouteImport } from './routes/utilities.cash-fine-transfer'
import { Route as UnsubscribeTokenRouteImport } from './routes/unsubscribe.$token'
import { Route as UiCatalogRouteImport } from './routes/ui.catalog'
import { Route as TrialStartRouteImport } from './routes/trial.start'
import { Route as TreasuryVouchersRouteImport } from './routes/treasury.vouchers'
import { Route as TreasuryCashBookRouteImport } from './routes/treasury.cash-book'
import { Route as TreasuryBankReconciliationRouteImport } from './routes/treasury.bank-reconciliation'
import { Route as StockVerificationRouteImport } from './routes/stock.verification'
import { Route as StockTransfersRouteImport } from './routes/stock.transfers'
import { Route as StockStonesRouteImport } from './routes/stock.stones'
import { Route as StockLotsRouteImport } from './routes/stock.lots'
import { Route as StockImportRouteImport } from './routes/stock.import'
import { Route as StockHallmarkRouteImport } from './routes/stock.hallmark'
import { Route as StockEntryRouteImport } from './routes/stock.entry'
import { Route as StockBoxesRouteImport } from './routes/stock.boxes'
import { Route as StockIdRouteImport } from './routes/stock.$id'
import { Route as SettlementNewRouteImport } from './routes/settlement.new'
import { Route as SettlementIdRouteImport } from './routes/settlement.$id'
import { Route as SettingsWorkflowRouteImport } from './routes/settings.workflow'
import { Route as SettingsWhatsappTemplatesRouteImport } from './routes/settings.whatsapp-templates'
import { Route as SettingsWhatsappRouteImport } from './routes/settings.whatsapp'
import { Route as SettingsSupportRouteImport } from './routes/settings.support'
import { Route as SettingsStorageDiagnosticsRouteImport } from './routes/settings.storage-diagnostics'
import { Route as SettingsSecurityCenterRouteImport } from './routes/settings.security-center'
import { Route as SettingsPrintTemplatesRouteImport } from './routes/settings.print-templates'
import { Route as SettingsLicenseRouteImport } from './routes/settings.license'
import { Route as SettingsIntegrationsHubRouteImport } from './routes/settings.integrations-hub'
import { Route as SettingsDocumentVaultRouteImport } from './routes/settings.document-vault'
import { Route as SettingsCommunicationsRouteImport } from './routes/settings.communications'
import { Route as SettingsBranchSettingsRouteImport } from './routes/settings.branch-settings'
import { Route as SettingsBackupRecoveryRouteImport } from './routes/settings.backup-recovery'
import { Route as SettingsAutomationRouteImport } from './routes/settings.automation'
import { Route as SchemeReceiptsRouteImport } from './routes/scheme.receipts'
import { Route as SchemePlansRouteImport } from './routes/scheme.plans'
import { Route as SchemeAccountsRouteImport } from './routes/scheme.accounts'
import { Route as ReportsWorkerRouteImport } from './routes/reports.worker'
import { Route as ReportsVaultReconciliationRouteImport } from './routes/reports.vault-reconciliation'
import { Route as ReportsTotalProfitRouteImport } from './routes/reports.total-profit'
import { Route as ReportsTanchHishobRouteImport } from './routes/reports.tanch-hishob'
import { Route as ReportsTallyExportRouteImport } from './routes/reports.tally-export'
import { Route as ReportsStockValuationRouteImport } from './routes/reports.stock-valuation'
import { Route as ReportsSettlementsRouteImport } from './routes/reports.settlements'
import { Route as ReportsSettlementReconciliationRouteImport } from './routes/reports.settlement-reconciliation'
import { Route as ReportsSchemeRouteImport } from './routes/reports.scheme'
import { Route as ReportsSalesRegisterRouteImport } from './routes/reports.sales-register'
import { Route as ReportsRemindersRouteImport } from './routes/reports.reminders'
import { Route as ReportsReconciliationCenterRouteImport } from './routes/reports.reconciliation-center'
import { Route as ReportsPurchaseRegisterRouteImport } from './routes/reports.purchase-register'
import { Route as ReportsOwnerDrawingsRouteImport } from './routes/reports.owner-drawings'
import { Route as ReportsOutsideWorkRouteImport } from './routes/reports.outside-work'
import { Route as ReportsMonthEndCloseRouteImport } from './routes/reports.month-end-close'
import { Route as ReportsMetalPositionRouteImport } from './routes/reports.metal-position'
import { Route as ReportsManufacturingReconciliationRouteImport } from './routes/reports.manufacturing-reconciliation'
import { Route as ReportsManufacturingRouteImport } from './routes/reports.manufacturing'
import { Route as ReportsLedgersPrintAllRouteImport } from './routes/reports.ledgers-print-all'
import { Route as ReportsLedgersRouteImport } from './routes/reports.ledgers'
import { Route as ReportsItemTransactionRouteImport } from './routes/reports.item-transaction'
import { Route as ReportsItemJamaNaveRouteImport } from './routes/reports.item-jama-nave'
import { Route as ReportsItc04RouteImport } from './routes/reports.itc04'
import { Route as ReportsInventoryAgeingRouteImport } from './routes/reports.inventory-ageing'
import { Route as ReportsHsnSummaryRouteImport } from './routes/reports.hsn-summary'
import { Route as ReportsGstReturnsRouteImport } from './routes/reports.gst-returns'
import { Route as ReportsGoldSummaryRouteImport } from './routes/reports.gold-summary'
import { Route as ReportsGoldStockRouteImport } from './routes/reports.gold-stock'
import { Route as ReportsGoldReconciliationRouteImport } from './routes/reports.gold-reconciliation'
import { Route as ReportsGoldPositionRouteImport } from './routes/reports.gold-position'
import { Route as ReportsGoldOutstandingRouteImport } from './routes/reports.gold-outstanding'
import { Route as ReportsGoldLossRouteImport } from './routes/reports.gold-loss'
import { Route as ReportsGoldLedgerRouteImport } from './routes/reports.gold-ledger'
import { Route as ReportsFineRojmelRouteImport } from './routes/reports.fine-rojmel'
import { Route as ReportsFineMarginRouteImport } from './routes/reports.fine-margin'
import { Route as ReportsFinancialStatementsRouteImport } from './routes/reports.financial-statements'
import { Route as ReportsExceptionsRouteImport } from './routes/reports.exceptions'
import { Route as ReportsErpAuditRouteImport } from './routes/reports.erp-audit'
import { Route as ReportsDiscountReportRouteImport } from './routes/reports.discount-report'
import { Route as ReportsDhadiBookRouteImport } from './routes/reports.dhadi-book'
import { Route as ReportsDeliverySummaryRouteImport } from './routes/reports.delivery-summary'
import { Route as ReportsDeletedBillsRouteImport } from './routes/reports.deleted-bills'
import { Route as ReportsDealerRouteImport } from './routes/reports.dealer'
import { Route as ReportsDayWiseRouteImport } from './routes/reports.day-wise'
import { Route as ReportsDarRojmelRouteImport } from './routes/reports.dar-rojmel'
import { Route as ReportsDailySummaryRouteImport } from './routes/reports.daily-summary'
import { Route as ReportsDailyGoldFlowRouteImport } from './routes/reports.daily-gold-flow'
import { Route as ReportsDailyCloseRouteImport } from './routes/reports.daily-close'
import { Route as ReportsCustomerStatementRouteImport } from './routes/reports.customer-statement'
import { Route as ReportsCommunicationAnalyticsRouteImport } from './routes/reports.communication-analytics'
import { Route as ReportsCityWiseRouteImport } from './routes/reports.city-wise'
import { Route as ReportsCashFlowRouteImport } from './routes/reports.cash-flow'
import { Route as ReportsCaPackRouteImport } from './routes/reports.ca-pack'
import { Route as ReportsBullionLedgerRouteImport } from './routes/reports.bullion-ledger'
import { Route as ReportsBranchRouteImport } from './routes/reports.branch'
import { Route as ReportsBarcodeStockRouteImport } from './routes/reports.barcode-stock'
import { Route as ReportsBankTransactionsRouteImport } from './routes/reports.bank-transactions'
import { Route as ReportsAuditorRouteImport } from './routes/reports.auditor'
import { Route as ReportsAuditLogRouteImport } from './routes/reports.audit-log'
import { Route as ReportsApprovalsRouteImport } from './routes/reports.approvals'
import { Route as ReportsAccountBalanceRouteImport } from './routes/reports.account-balance'
import { Route as RepairNewRouteImport } from './routes/repair.new'
import { Route as RepairIdRouteImport } from './routes/repair.$id'
import { Route as PlatformWebsiteRouteImport } from './routes/platform.website'
import { Route as PlatformTrialsRouteImport } from './routes/platform.trials'
import { Route as PlatformPlansRouteImport } from './routes/platform.plans'
import { Route as PlatformMetaWhatsappRouteImport } from './routes/platform.meta-whatsapp'
import { Route as PlatformCommunicationProvidersRouteImport } from './routes/platform.communication-providers'
import { Route as PlatformCommercialPricingRouteImport } from './routes/platform.commercial-pricing'
import { Route as PeopleImportRouteImport } from './routes/people.import'
import { Route as PeopleIdRouteImport } from './routes/people.$id'
import { Route as OrdersNewRouteImport } from './routes/orders.new'
import { Route as OrdersImportRouteImport } from './routes/orders.import'
import { Route as OrdersIdRouteImport } from './routes/orders.$id'
import { Route as MobileWorkRouteImport } from './routes/mobile.work'
import { Route as MobileTransactionsRouteImport } from './routes/mobile.transactions'
import { Route as MobileSyncRouteImport } from './routes/mobile.sync'
import { Route as MobileStockEntryRouteImport } from './routes/mobile.stock-entry'
import { Route as MobileReportsRouteImport } from './routes/mobile.reports'
import { Route as MobileMoreRouteImport } from './routes/mobile.more'
import { Route as MobileMasterRouteImport } from './routes/mobile.master'
import { Route as MobileGoldStockRouteImport } from './routes/mobile.gold-stock'
import { Route as MobileBusinessRouteImport } from './routes/mobile.business'
import { Route as MobileAssistantRouteImport } from './routes/mobile.assistant'
import { Route as ManufacturingOwnerTransactionsRouteImport } from './routes/manufacturing.owner-transactions'
import { Route as InviteAcceptRouteImport } from './routes/invite.accept'
import { Route as DocTokenRouteImport } from './routes/doc.$token'
import { Route as DashboardCeoRouteImport } from './routes/dashboard.ceo'
import { Route as CrmLeadsRouteImport } from './routes/crm.leads'
import { Route as CrmAppointmentsRouteImport } from './routes/crm.appointments'
import { Route as ControlTerminologyRouteImport } from './routes/control.terminology'
import { Route as ControlTallyExportRouteImport } from './routes/control.tally-export'
import { Route as ControlShortcutsRouteImport } from './routes/control.shortcuts'
import { Route as ControlRatesRouteImport } from './routes/control.rates'
import { Route as ControlPrintProfilesRouteImport } from './routes/control.print-profiles'
import { Route as ControlMigrationRouteImport } from './routes/control.migration'
import { Route as ControlCustomizationRouteImport } from './routes/control.customization'
import { Route as ControlAccountsRouteImport } from './routes/control.accounts'
import { Route as ComingSoonMeenaBookRouteImport } from './routes/coming-soon.meena-book'
import { Route as ComingSoonBarcodeScannerRouteImport } from './routes/coming-soon.barcode-scanner'
import { Route as ComingSoonBarcodePrintingRouteImport } from './routes/coming-soon.barcode-printing'
import { Route as CatalogTemplatesRouteImport } from './routes/catalog.templates'
import { Route as CatalogMastersRouteImport } from './routes/catalog.masters'
import { Route as CatalogDesignerRouteImport } from './routes/catalog.designer'
import { Route as CatalogIdRouteImport } from './routes/catalog.$id'
import { Route as BillingNewRouteImport } from './routes/billing.new'
import { Route as BillingCreditNoteRouteImport } from './routes/billing.credit-note'
import { Route as BillingIdRouteImport } from './routes/billing.$id'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as BillingPurchasesIndexRouteImport } from './routes/billing.purchases.index'
import { Route as BillingEstimatesIndexRouteImport } from './routes/billing.estimates.index'
import { Route as BillingDeliveryChallansIndexRouteImport } from './routes/billing.delivery-challans.index'
import { Route as BillingDebitNotesIndexRouteImport } from './routes/billing.debit-notes.index'
import { Route as BillingCreditNotesIndexRouteImport } from './routes/billing.credit-notes.index'
import { Route as WorkshopWorkerBookWorkerIdRouteImport } from './routes/workshop.worker-book.$workerId'
import { Route as WorkshopReceiveSlipIdRouteImport } from './routes/workshop.receive-slip.$id'
import { Route as WorkshopProcessTypeRouteImport } from './routes/workshop.process.$type'
import { Route as WorkshopPolishingBookPartyIdRouteImport } from './routes/workshop.polishing-book.$partyId'
import { Route as WorkshopOutsideWorkerBookPartyIdRouteImport } from './routes/workshop.outside-worker-book.$partyId'
import { Route as WorkshopJobCardOrderIdRouteImport } from './routes/workshop.job-card.$orderId'
import { Route as WorkshopGoldBookPrintWorkerIdRouteImport } from './routes/workshop.gold-book-print.$workerId'
import { Route as WorkshopFilingsSlipIdRouteImport } from './routes/workshop.filings-slip.$id'
import { Route as WorkshopBookJewellerIdRouteImport } from './routes/workshop.book.$jewellerId'
import { Route as VerifyInvoiceTokenRouteImport } from './routes/verify.invoice.$token'
import { Route as StockPrintIdRouteImport } from './routes/stock.print.$id'
import { Route as SettlementDraftPrintIdRouteImport } from './routes/settlement.draft-print.$id'
import { Route as SettingsIntegrationsWhatsappRouteImport } from './routes/settings.integrations.whatsapp'
import { Route as SettingsCommunicationsMetaCallbackRouteImport } from './routes/settings.communications.meta-callback'
import { Route as ReportsDailyclosePrintIdRouteImport } from './routes/reports.dailyclose-print.$id'
import { Route as ReportsBookPrintDocTypeRouteImport } from './routes/reports.book-print.$docType'
import { Route as ReportsAccountBalancePrintVariantRouteImport } from './routes/reports.account-balance-print.$variant'
import { Route as RepairPolishingNewRouteImport } from './routes/repair.polishing.new'
import { Route as PlatformBillingPrintIdRouteImport } from './routes/platform.billing-print.$id'
import { Route as PeoplePrintIdRouteImport } from './routes/people.print.$id'
import { Route as PeopleLedgerPrintIdRouteImport } from './routes/people.ledger-print.$id'
import { Route as ManufacturingBillIdRouteImport } from './routes/manufacturing.bill.$id'
import { Route as Crm360IdRouteImport } from './routes/crm.360.$id'
import { Route as ConversionSlipIdRouteImport } from './routes/conversion.slip.$id'
import { Route as BillingSettlementSlipIdRouteImport } from './routes/billing.settlement-slip.$id'
import { Route as BillingReceiptIdRouteImport } from './routes/billing.receipt.$id'
import { Route as BillingPurchasesReturnRouteImport } from './routes/billing.purchases.return'
import { Route as BillingPrintIdRouteImport } from './routes/billing.print.$id'
import { Route as BillingGoldSettlementPrintIdRouteImport } from './routes/billing.gold-settlement-print.$id'
import { Route as BillingEstimatesIdRouteImport } from './routes/billing.estimates.$id'
import { Route as BillingEstimateIdRouteImport } from './routes/billing.estimate.$id'
import { Route as BillingEstimatePrintIdRouteImport } from './routes/billing.estimate-print.$id'
import { Route as BillingDeliveryChallansIdRouteImport } from './routes/billing.delivery-challans.$id'
import { Route as BillingDeliveryChallanPrintIdRouteImport } from './routes/billing.delivery-challan-print.$id'
import { Route as BillingDebitNotesIdRouteImport } from './routes/billing.debit-notes.$id'
import { Route as BillingDebitNotePrintIdRouteImport } from './routes/billing.debit-note-print.$id'
import { Route as BillingCreditNotesIdRouteImport } from './routes/billing.credit-notes.$id'
import { Route as BillingCreditNotePrintIdRouteImport } from './routes/billing.credit-note-print.$id'
import { Route as WorkshopPrintJobCardOrderIdRouteImport } from './routes/workshop.print.job-card.$orderId'
import { Route as WorkshopMaterialSlipWorkerIdDateRouteImport } from './routes/workshop.material-slip.$workerId.$date'
import { Route as RepairPrintKindIdRouteImport } from './routes/repair.print.$kind.$id'
import { Route as OrdersPrintKindIdRouteImport } from './routes/orders.print.$kind.$id'
import { Route as ManufacturingBillNewJobIdRouteImport } from './routes/manufacturing.bill.new.$jobId'
import { Route as AttendancePrintKindIdRouteImport } from './routes/attendance.print.$kind.$id'

const WorkshopRoute = WorkshopRouteImport.update({
  id: '/workshop',
  path: '/workshop',
  getParentRoute: () => rootRouteImport,
} as any)
const WhatsappRoute = WhatsappRouteImport.update({
  id: '/whatsapp',
  path: '/whatsapp',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UtilitiesRoute = UtilitiesRouteImport.update({
  id: '/utilities',
  path: '/utilities',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionHubRoute = TransactionHubRouteImport.update({
  id: '/transaction-hub',
  path: '/transaction-hub',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SupplierPortalRoute = SupplierPortalRouteImport.update({
  id: '/supplier-portal',
  path: '/supplier-portal',
  getParentRoute: () => rootRouteImport,
} as any)
const SupplierLoginRoute = SupplierLoginRouteImport.update({
  id: '/supplier-login',
  path: '/supplier-login',
  getParentRoute: () => rootRouteImport,
} as any)
const StockRoute = StockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SchemeRoute = SchemeRouteImport.update({
  id: '/scheme',
  path: '/scheme',
  getParentRoute: () => rootRouteImport,
} as any)
const SaasAdminRoute = SaasAdminRouteImport.update({
  id: '/saas-admin',
  path: '/saas-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestAccessRoute = RequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const RepairRoute = RepairRouteImport.update({
  id: '/repair',
  path: '/repair',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpLoginRoute = OtpLoginRouteImport.update({
  id: '/otp-login',
  path: '/otp-login',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MtgRoute = MtgRouteImport.update({
  id: '/mtg',
  path: '/mtg',
  getParentRoute: () => rootRouteImport,
} as any)
const MeltRoute = MeltRouteImport.update({
  id: '/melt',
  path: '/melt',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterRoute = MasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => rootRouteImport,
} as any)
const ManufacturingRoute = ManufacturingRouteImport.update({
  id: '/manufacturing',
  path: '/manufacturing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LedgerRoute = LedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => rootRouteImport,
} as any)
const KarigarPortalRoute = KarigarPortalRouteImport.update({
  id: '/karigar-portal',
  path: '/karigar-portal',
  getParentRoute: () => rootRouteImport,
} as any)
const KarigarLoginRoute = KarigarLoginRouteImport.update({
  id: '/karigar-login',
  path: '/karigar-login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerPortalRoute = CustomerPortalRouteImport.update({
  id: '/customer-portal',
  path: '/customer-portal',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerLoginRoute = CustomerLoginRouteImport.update({
  id: '/customer-login',
  path: '/customer-login',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyAdminRoute = CompanyAdminRouteImport.update({
  id: '/company-admin',
  path: '/company-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsRoute = CommunicationsRouteImport.update({
  id: '/communications',
  path: '/communications',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const BarcodeRoute = BarcodeRouteImport.update({
  id: '/barcode',
  path: '/barcode',
  getParentRoute: () => rootRouteImport,
} as any)
const AttendanceRoute = AttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantRoute = AssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AiCenterRoute = AiCenterRouteImport.update({
  id: '/ai-center',
  path: '/ai-center',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkshopIndexRoute = WorkshopIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkshopRoute,
} as any)
const WhatsappIndexRoute = WhatsappIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WhatsappRoute,
} as any)
const UtilitiesIndexRoute = UtilitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UtilitiesRoute,
} as any)
const StockIndexRoute = StockIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StockRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SchemeIndexRoute = SchemeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SchemeRoute,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportsRoute,
} as any)
const RepairIndexRoute = RepairIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RepairRoute,
} as any)
const RefineryIndexRoute = RefineryIndexRouteImport.update({
  id: '/refinery/',
  path: '/refinery/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrdersRoute,
} as any)
const MtgIndexRoute = MtgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MtgRoute,
} as any)
const MobileIndexRoute = MobileIndexRouteImport.update({
  id: '/mobile/',
  path: '/mobile/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeltIndexRoute = MeltIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MeltRoute,
} as any)
const ManufacturingIndexRoute = ManufacturingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManufacturingRoute,
} as any)
const HardwareIndexRoute = HardwareIndexRouteImport.update({
  id: '/hardware/',
  path: '/hardware/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesIndexRoute = ExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversionIndexRoute = ConversionIndexRouteImport.update({
  id: '/conversion/',
  path: '/conversion/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsIndexRoute = CommunicationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommunicationsRoute,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogRoute,
} as any)
const BranchesIndexRoute = BranchesIndexRouteImport.update({
  id: '/branches/',
  path: '/branches/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingIndexRoute = BillingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BillingRoute,
} as any)
const AttendanceIndexRoute = AttendanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AttendanceRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AccountsIndexRoute = AccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkshopWorkerBooksRoute = WorkshopWorkerBooksRouteImport.update({
  id: '/worker-books',
  path: '/worker-books',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopVibratorRoute = WorkshopVibratorRouteImport.update({
  id: '/vibrator',
  path: '/vibrator',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopReconciliationRoute = WorkshopReconciliationRouteImport.update({
  id: '/reconciliation',
  path: '/reconciliation',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopPolishingBooksRoute = WorkshopPolishingBooksRouteImport.update({
  id: '/polishing-books',
  path: '/polishing-books',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopPolishingRoute = WorkshopPolishingRouteImport.update({
  id: '/polishing',
  path: '/polishing',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopOutsideWorkerBooksRoute =
  WorkshopOutsideWorkerBooksRouteImport.update({
    id: '/outside-worker-books',
    path: '/outside-worker-books',
    getParentRoute: () => WorkshopRoute,
  } as any)
const WorkshopOutsideWorkRoute = WorkshopOutsideWorkRouteImport.update({
  id: '/outside-work',
  path: '/outside-work',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopKarigarBookRoute = WorkshopKarigarBookRouteImport.update({
  id: '/karigar-book',
  path: '/karigar-book',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopJangadRoute = WorkshopJangadRouteImport.update({
  id: '/jangad',
  path: '/jangad',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopJamaRoute = WorkshopJamaRouteImport.update({
  id: '/jama',
  path: '/jama',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopGoldBookRoute = WorkshopGoldBookRouteImport.update({
  id: '/gold-book',
  path: '/gold-book',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopDhadiGroupsRoute = WorkshopDhadiGroupsRouteImport.update({
  id: '/dhadi-groups',
  path: '/dhadi-groups',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopBenchCustodyRoute = WorkshopBenchCustodyRouteImport.update({
  id: '/bench-custody',
  path: '/bench-custody',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopBarcodeScannerRoute = WorkshopBarcodeScannerRouteImport.update({
  id: '/barcode-scanner',
  path: '/barcode-scanner',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopIdRoute = WorkshopIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => WorkshopRoute,
} as any)
const UtilitiesWipeoutRoute = UtilitiesWipeoutRouteImport.update({
  id: '/wipeout',
  path: '/wipeout',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesUrdPurchaseRoute = UtilitiesUrdPurchaseRouteImport.update({
  id: '/urd-purchase',
  path: '/urd-purchase',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesSubAccountsRoute = UtilitiesSubAccountsRouteImport.update({
  id: '/sub-accounts',
  path: '/sub-accounts',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesSaudaBookRoute = UtilitiesSaudaBookRouteImport.update({
  id: '/sauda-book',
  path: '/sauda-book',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesPatlaStockRoute = UtilitiesPatlaStockRouteImport.update({
  id: '/patla-stock',
  path: '/patla-stock',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesOpeningFineCashRoute =
  UtilitiesOpeningFineCashRouteImport.update({
    id: '/opening-fine-cash',
    path: '/opening-fine-cash',
    getParentRoute: () => UtilitiesRoute,
  } as any)
const UtilitiesItemTransactionRoute =
  UtilitiesItemTransactionRouteImport.update({
    id: '/item-transaction',
    path: '/item-transaction',
    getParentRoute: () => UtilitiesRoute,
  } as any)
const UtilitiesItemMastersRoute = UtilitiesItemMastersRouteImport.update({
  id: '/item-masters',
  path: '/item-masters',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesGstCalculatorRoute = UtilitiesGstCalculatorRouteImport.update({
  id: '/gst-calculator',
  path: '/gst-calculator',
  getParentRoute: () => UtilitiesRoute,
} as any)
const UtilitiesCounterSettingsRoute =
  UtilitiesCounterSettingsRouteImport.update({
    id: '/counter-settings',
    path: '/counter-settings',
    getParentRoute: () => UtilitiesRoute,
  } as any)
const UtilitiesCashFineTransferRoute =
  UtilitiesCashFineTransferRouteImport.update({
    id: '/cash-fine-transfer',
    path: '/cash-fine-transfer',
    getParentRoute: () => UtilitiesRoute,
  } as any)
const UnsubscribeTokenRoute = UnsubscribeTokenRouteImport.update({
  id: '/unsubscribe/$token',
  path: '/unsubscribe/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const UiCatalogRoute = UiCatalogRouteImport.update({
  id: '/ui/catalog',
  path: '/ui/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialStartRoute = TrialStartRouteImport.update({
  id: '/trial/start',
  path: '/trial/start',
  getParentRoute: () => rootRouteImport,
} as any)
const TreasuryVouchersRoute = TreasuryVouchersRouteImport.update({
  id: '/treasury/vouchers',
  path: '/treasury/vouchers',
  getParentRoute: () => rootRouteImport,
} as any)
const TreasuryCashBookRoute = TreasuryCashBookRouteImport.update({
  id: '/treasury/cash-book',
  path: '/treasury/cash-book',
  getParentRoute: () => rootRouteImport,
} as any)
const TreasuryBankReconciliationRoute =
  TreasuryBankReconciliationRouteImport.update({
    id: '/treasury/bank-reconciliation',
    path: '/treasury/bank-reconciliation',
    getParentRoute: () => rootRouteImport,
  } as any)
const StockVerificationRoute = StockVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => StockRoute,
} as any)
const StockTransfersRoute = StockTransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => StockRoute,
} as any)
const StockStonesRoute = StockStonesRouteImport.update({
  id: '/stones',
  path: '/stones',
  getParentRoute: () => StockRoute,
} as any)
const StockLotsRoute = StockLotsRouteImport.update({
  id: '/lots',
  path: '/lots',
  getParentRoute: () => StockRoute,
} as any)
const StockImportRoute = StockImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => StockRoute,
} as any)
const StockHallmarkRoute = StockHallmarkRouteImport.update({
  id: '/hallmark',
  path: '/hallmark',
  getParentRoute: () => StockRoute,
} as any)
const StockEntryRoute = StockEntryRouteImport.update({
  id: '/entry',
  path: '/entry',
  getParentRoute: () => StockRoute,
} as any)
const StockBoxesRoute = StockBoxesRouteImport.update({
  id: '/boxes',
  path: '/boxes',
  getParentRoute: () => StockRoute,
} as any)
const StockIdRoute = StockIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StockRoute,
} as any)
const SettlementNewRoute = SettlementNewRouteImport.update({
  id: '/settlement/new',
  path: '/settlement/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SettlementIdRoute = SettlementIdRouteImport.update({
  id: '/settlement/$id',
  path: '/settlement/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWorkflowRoute = SettingsWorkflowRouteImport.update({
  id: '/workflow',
  path: '/workflow',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsWhatsappTemplatesRoute =
  SettingsWhatsappTemplatesRouteImport.update({
    id: '/whatsapp-templates',
    path: '/whatsapp-templates',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsWhatsappRoute = SettingsWhatsappRouteImport.update({
  id: '/whatsapp',
  path: '/whatsapp',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSupportRoute = SettingsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsStorageDiagnosticsRoute =
  SettingsStorageDiagnosticsRouteImport.update({
    id: '/storage-diagnostics',
    path: '/storage-diagnostics',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSecurityCenterRoute = SettingsSecurityCenterRouteImport.update({
  id: '/security-center',
  path: '/security-center',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPrintTemplatesRoute = SettingsPrintTemplatesRouteImport.update({
  id: '/print-templates',
  path: '/print-templates',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLicenseRoute = SettingsLicenseRouteImport.update({
  id: '/license',
  path: '/license',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsIntegrationsHubRoute = SettingsIntegrationsHubRouteImport.update({
  id: '/integrations-hub',
  path: '/integrations-hub',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDocumentVaultRoute = SettingsDocumentVaultRouteImport.update({
  id: '/document-vault',
  path: '/document-vault',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCommunicationsRoute = SettingsCommunicationsRouteImport.update({
  id: '/communications',
  path: '/communications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBranchSettingsRoute = SettingsBranchSettingsRouteImport.update({
  id: '/branch-settings',
  path: '/branch-settings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBackupRecoveryRoute = SettingsBackupRecoveryRouteImport.update({
  id: '/backup-recovery',
  path: '/backup-recovery',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAutomationRoute = SettingsAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => SettingsRoute,
} as any)
const SchemeReceiptsRoute = SchemeReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => SchemeRoute,
} as any)
const SchemePlansRoute = SchemePlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => SchemeRoute,
} as any)
const SchemeAccountsRoute = SchemeAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => SchemeRoute,
} as any)
const ReportsWorkerRoute = ReportsWorkerRouteImport.update({
  id: '/worker',
  path: '/worker',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsVaultReconciliationRoute =
  ReportsVaultReconciliationRouteImport.update({
    id: '/vault-reconciliation',
    path: '/vault-reconciliation',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsTotalProfitRoute = ReportsTotalProfitRouteImport.update({
  id: '/total-profit',
  path: '/total-profit',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsTanchHishobRoute = ReportsTanchHishobRouteImport.update({
  id: '/tanch-hishob',
  path: '/tanch-hishob',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsTallyExportRoute = ReportsTallyExportRouteImport.update({
  id: '/tally-export',
  path: '/tally-export',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsStockValuationRoute = ReportsStockValuationRouteImport.update({
  id: '/stock-valuation',
  path: '/stock-valuation',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsSettlementsRoute = ReportsSettlementsRouteImport.update({
  id: '/settlements',
  path: '/settlements',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsSettlementReconciliationRoute =
  ReportsSettlementReconciliationRouteImport.update({
    id: '/settlement-reconciliation',
    path: '/settlement-reconciliation',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsSchemeRoute = ReportsSchemeRouteImport.update({
  id: '/scheme',
  path: '/scheme',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsSalesRegisterRoute = ReportsSalesRegisterRouteImport.update({
  id: '/sales-register',
  path: '/sales-register',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsRemindersRoute = ReportsRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsReconciliationCenterRoute =
  ReportsReconciliationCenterRouteImport.update({
    id: '/reconciliation-center',
    path: '/reconciliation-center',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsPurchaseRegisterRoute = ReportsPurchaseRegisterRouteImport.update({
  id: '/purchase-register',
  path: '/purchase-register',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsOwnerDrawingsRoute = ReportsOwnerDrawingsRouteImport.update({
  id: '/owner-drawings',
  path: '/owner-drawings',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsOutsideWorkRoute = ReportsOutsideWorkRouteImport.update({
  id: '/outside-work',
  path: '/outside-work',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsMonthEndCloseRoute = ReportsMonthEndCloseRouteImport.update({
  id: '/month-end-close',
  path: '/month-end-close',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsMetalPositionRoute = ReportsMetalPositionRouteImport.update({
  id: '/metal-position',
  path: '/metal-position',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsManufacturingReconciliationRoute =
  ReportsManufacturingReconciliationRouteImport.update({
    id: '/manufacturing-reconciliation',
    path: '/manufacturing-reconciliation',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsManufacturingRoute = ReportsManufacturingRouteImport.update({
  id: '/manufacturing',
  path: '/manufacturing',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsLedgersPrintAllRoute = ReportsLedgersPrintAllRouteImport.update({
  id: '/ledgers-print-all',
  path: '/ledgers-print-all',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsLedgersRoute = ReportsLedgersRouteImport.update({
  id: '/ledgers',
  path: '/ledgers',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsItemTransactionRoute = ReportsItemTransactionRouteImport.update({
  id: '/item-transaction',
  path: '/item-transaction',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsItemJamaNaveRoute = ReportsItemJamaNaveRouteImport.update({
  id: '/item-jama-nave',
  path: '/item-jama-nave',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsItc04Route = ReportsItc04RouteImport.update({
  id: '/itc04',
  path: '/itc04',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsInventoryAgeingRoute = ReportsInventoryAgeingRouteImport.update({
  id: '/inventory-ageing',
  path: '/inventory-ageing',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsHsnSummaryRoute = ReportsHsnSummaryRouteImport.update({
  id: '/hsn-summary',
  path: '/hsn-summary',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGstReturnsRoute = ReportsGstReturnsRouteImport.update({
  id: '/gst-returns',
  path: '/gst-returns',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGoldSummaryRoute = ReportsGoldSummaryRouteImport.update({
  id: '/gold-summary',
  path: '/gold-summary',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGoldStockRoute = ReportsGoldStockRouteImport.update({
  id: '/gold-stock',
  path: '/gold-stock',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGoldReconciliationRoute =
  ReportsGoldReconciliationRouteImport.update({
    id: '/gold-reconciliation',
    path: '/gold-reconciliation',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsGoldPositionRoute = ReportsGoldPositionRouteImport.update({
  id: '/gold-position',
  path: '/gold-position',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGoldOutstandingRoute = ReportsGoldOutstandingRouteImport.update({
  id: '/gold-outstanding',
  path: '/gold-outstanding',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGoldLossRoute = ReportsGoldLossRouteImport.update({
  id: '/gold-loss',
  path: '/gold-loss',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsGoldLedgerRoute = ReportsGoldLedgerRouteImport.update({
  id: '/gold-ledger',
  path: '/gold-ledger',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsFineRojmelRoute = ReportsFineRojmelRouteImport.update({
  id: '/fine-rojmel',
  path: '/fine-rojmel',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsFineMarginRoute = ReportsFineMarginRouteImport.update({
  id: '/fine-margin',
  path: '/fine-margin',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsFinancialStatementsRoute =
  ReportsFinancialStatementsRouteImport.update({
    id: '/financial-statements',
    path: '/financial-statements',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsExceptionsRoute = ReportsExceptionsRouteImport.update({
  id: '/exceptions',
  path: '/exceptions',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsErpAuditRoute = ReportsErpAuditRouteImport.update({
  id: '/erp-audit',
  path: '/erp-audit',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDiscountReportRoute = ReportsDiscountReportRouteImport.update({
  id: '/discount-report',
  path: '/discount-report',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDhadiBookRoute = ReportsDhadiBookRouteImport.update({
  id: '/dhadi-book',
  path: '/dhadi-book',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDeliverySummaryRoute = ReportsDeliverySummaryRouteImport.update({
  id: '/delivery-summary',
  path: '/delivery-summary',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDeletedBillsRoute = ReportsDeletedBillsRouteImport.update({
  id: '/deleted-bills',
  path: '/deleted-bills',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDealerRoute = ReportsDealerRouteImport.update({
  id: '/dealer',
  path: '/dealer',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDayWiseRoute = ReportsDayWiseRouteImport.update({
  id: '/day-wise',
  path: '/day-wise',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDarRojmelRoute = ReportsDarRojmelRouteImport.update({
  id: '/dar-rojmel',
  path: '/dar-rojmel',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDailySummaryRoute = ReportsDailySummaryRouteImport.update({
  id: '/daily-summary',
  path: '/daily-summary',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDailyGoldFlowRoute = ReportsDailyGoldFlowRouteImport.update({
  id: '/daily-gold-flow',
  path: '/daily-gold-flow',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsDailyCloseRoute = ReportsDailyCloseRouteImport.update({
  id: '/daily-close',
  path: '/daily-close',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsCustomerStatementRoute =
  ReportsCustomerStatementRouteImport.update({
    id: '/customer-statement',
    path: '/customer-statement',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsCommunicationAnalyticsRoute =
  ReportsCommunicationAnalyticsRouteImport.update({
    id: '/communication-analytics',
    path: '/communication-analytics',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsCityWiseRoute = ReportsCityWiseRouteImport.update({
  id: '/city-wise',
  path: '/city-wise',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsCashFlowRoute = ReportsCashFlowRouteImport.update({
  id: '/cash-flow',
  path: '/cash-flow',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsCaPackRoute = ReportsCaPackRouteImport.update({
  id: '/ca-pack',
  path: '/ca-pack',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsBullionLedgerRoute = ReportsBullionLedgerRouteImport.update({
  id: '/bullion-ledger',
  path: '/bullion-ledger',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsBranchRoute = ReportsBranchRouteImport.update({
  id: '/branch',
  path: '/branch',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsBarcodeStockRoute = ReportsBarcodeStockRouteImport.update({
  id: '/barcode-stock',
  path: '/barcode-stock',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsBankTransactionsRoute = ReportsBankTransactionsRouteImport.update({
  id: '/bank-transactions',
  path: '/bank-transactions',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsAuditorRoute = ReportsAuditorRouteImport.update({
  id: '/auditor',
  path: '/auditor',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsAuditLogRoute = ReportsAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsApprovalsRoute = ReportsApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsAccountBalanceRoute = ReportsAccountBalanceRouteImport.update({
  id: '/account-balance',
  path: '/account-balance',
  getParentRoute: () => ReportsRoute,
} as any)
const RepairNewRoute = RepairNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => RepairRoute,
} as any)
const RepairIdRoute = RepairIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RepairRoute,
} as any)
const PlatformWebsiteRoute = PlatformWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformTrialsRoute = PlatformTrialsRouteImport.update({
  id: '/trials',
  path: '/trials',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformPlansRoute = PlatformPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformMetaWhatsappRoute = PlatformMetaWhatsappRouteImport.update({
  id: '/meta-whatsapp',
  path: '/meta-whatsapp',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformCommunicationProvidersRoute =
  PlatformCommunicationProvidersRouteImport.update({
    id: '/communication-providers',
    path: '/communication-providers',
    getParentRoute: () => PlatformRoute,
  } as any)
const PlatformCommercialPricingRoute =
  PlatformCommercialPricingRouteImport.update({
    id: '/commercial-pricing',
    path: '/commercial-pricing',
    getParentRoute: () => PlatformRoute,
  } as any)
const PeopleImportRoute = PeopleImportRouteImport.update({
  id: '/people/import',
  path: '/people/import',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIdRoute = PeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersNewRoute = OrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OrdersRoute,
} as any)
const OrdersImportRoute = OrdersImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => OrdersRoute,
} as any)
const OrdersIdRoute = OrdersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => OrdersRoute,
} as any)
const MobileWorkRoute = MobileWorkRouteImport.update({
  id: '/mobile/work',
  path: '/mobile/work',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileTransactionsRoute = MobileTransactionsRouteImport.update({
  id: '/mobile/transactions',
  path: '/mobile/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileSyncRoute = MobileSyncRouteImport.update({
  id: '/mobile/sync',
  path: '/mobile/sync',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileStockEntryRoute = MobileStockEntryRouteImport.update({
  id: '/mobile/stock-entry',
  path: '/mobile/stock-entry',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileReportsRoute = MobileReportsRouteImport.update({
  id: '/mobile/reports',
  path: '/mobile/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileMoreRoute = MobileMoreRouteImport.update({
  id: '/mobile/more',
  path: '/mobile/more',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileMasterRoute = MobileMasterRouteImport.update({
  id: '/mobile/master',
  path: '/mobile/master',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileGoldStockRoute = MobileGoldStockRouteImport.update({
  id: '/mobile/gold-stock',
  path: '/mobile/gold-stock',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileBusinessRoute = MobileBusinessRouteImport.update({
  id: '/mobile/business',
  path: '/mobile/business',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileAssistantRoute = MobileAssistantRouteImport.update({
  id: '/mobile/assistant',
  path: '/mobile/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const ManufacturingOwnerTransactionsRoute =
  ManufacturingOwnerTransactionsRouteImport.update({
    id: '/owner-transactions',
    path: '/owner-transactions',
    getParentRoute: () => ManufacturingRoute,
  } as any)
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/accept',
  path: '/accept',
  getParentRoute: () => InviteRoute,
} as any)
const DocTokenRoute = DocTokenRouteImport.update({
  id: '/doc/$token',
  path: '/doc/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardCeoRoute = DashboardCeoRouteImport.update({
  id: '/ceo',
  path: '/ceo',
  getParentRoute: () => DashboardRoute,
} as any)
const CrmLeadsRoute = CrmLeadsRouteImport.update({
  id: '/crm/leads',
  path: '/crm/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmAppointmentsRoute = CrmAppointmentsRouteImport.update({
  id: '/crm/appointments',
  path: '/crm/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlTerminologyRoute = ControlTerminologyRouteImport.update({
  id: '/control/terminology',
  path: '/control/terminology',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlTallyExportRoute = ControlTallyExportRouteImport.update({
  id: '/control/tally-export',
  path: '/control/tally-export',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlShortcutsRoute = ControlShortcutsRouteImport.update({
  id: '/control/shortcuts',
  path: '/control/shortcuts',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlRatesRoute = ControlRatesRouteImport.update({
  id: '/control/rates',
  path: '/control/rates',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlPrintProfilesRoute = ControlPrintProfilesRouteImport.update({
  id: '/control/print-profiles',
  path: '/control/print-profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlMigrationRoute = ControlMigrationRouteImport.update({
  id: '/control/migration',
  path: '/control/migration',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlCustomizationRoute = ControlCustomizationRouteImport.update({
  id: '/control/customization',
  path: '/control/customization',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlAccountsRoute = ControlAccountsRouteImport.update({
  id: '/control/accounts',
  path: '/control/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonMeenaBookRoute = ComingSoonMeenaBookRouteImport.update({
  id: '/coming-soon/meena-book',
  path: '/coming-soon/meena-book',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonBarcodeScannerRoute =
  ComingSoonBarcodeScannerRouteImport.update({
    id: '/coming-soon/barcode-scanner',
    path: '/coming-soon/barcode-scanner',
    getParentRoute: () => rootRouteImport,
  } as any)
const ComingSoonBarcodePrintingRoute =
  ComingSoonBarcodePrintingRouteImport.update({
    id: '/coming-soon/barcode-printing',
    path: '/coming-soon/barcode-printing',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogTemplatesRoute = CatalogTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogMastersRoute = CatalogMastersRouteImport.update({
  id: '/masters',
  path: '/masters',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogDesignerRoute = CatalogDesignerRouteImport.update({
  id: '/designer',
  path: '/designer',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogIdRoute = CatalogIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CatalogRoute,
} as any)
const BillingNewRoute = BillingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => BillingRoute,
} as any)
const BillingCreditNoteRoute = BillingCreditNoteRouteImport.update({
  id: '/credit-note',
  path: '/credit-note',
  getParentRoute: () => BillingRoute,
} as any)
const BillingIdRoute = BillingIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BillingRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPurchasesIndexRoute = BillingPurchasesIndexRouteImport.update({
  id: '/purchases/',
  path: '/purchases/',
  getParentRoute: () => BillingRoute,
} as any)
const BillingEstimatesIndexRoute = BillingEstimatesIndexRouteImport.update({
  id: '/estimates/',
  path: '/estimates/',
  getParentRoute: () => BillingRoute,
} as any)
const BillingDeliveryChallansIndexRoute =
  BillingDeliveryChallansIndexRouteImport.update({
    id: '/delivery-challans/',
    path: '/delivery-challans/',
    getParentRoute: () => BillingRoute,
  } as any)
const BillingDebitNotesIndexRoute = BillingDebitNotesIndexRouteImport.update({
  id: '/debit-notes/',
  path: '/debit-notes/',
  getParentRoute: () => BillingRoute,
} as any)
const BillingCreditNotesIndexRoute = BillingCreditNotesIndexRouteImport.update({
  id: '/credit-notes/',
  path: '/credit-notes/',
  getParentRoute: () => BillingRoute,
} as any)
const WorkshopWorkerBookWorkerIdRoute =
  WorkshopWorkerBookWorkerIdRouteImport.update({
    id: '/worker-book/$workerId',
    path: '/worker-book/$workerId',
    getParentRoute: () => WorkshopRoute,
  } as any)
const WorkshopReceiveSlipIdRoute = WorkshopReceiveSlipIdRouteImport.update({
  id: '/receive-slip/$id',
  path: '/receive-slip/$id',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopProcessTypeRoute = WorkshopProcessTypeRouteImport.update({
  id: '/process/$type',
  path: '/process/$type',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopPolishingBookPartyIdRoute =
  WorkshopPolishingBookPartyIdRouteImport.update({
    id: '/polishing-book/$partyId',
    path: '/polishing-book/$partyId',
    getParentRoute: () => WorkshopRoute,
  } as any)
const WorkshopOutsideWorkerBookPartyIdRoute =
  WorkshopOutsideWorkerBookPartyIdRouteImport.update({
    id: '/outside-worker-book/$partyId',
    path: '/outside-worker-book/$partyId',
    getParentRoute: () => WorkshopRoute,
  } as any)
const WorkshopJobCardOrderIdRoute = WorkshopJobCardOrderIdRouteImport.update({
  id: '/job-card/$orderId',
  path: '/job-card/$orderId',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopGoldBookPrintWorkerIdRoute =
  WorkshopGoldBookPrintWorkerIdRouteImport.update({
    id: '/gold-book-print/$workerId',
    path: '/gold-book-print/$workerId',
    getParentRoute: () => WorkshopRoute,
  } as any)
const WorkshopFilingsSlipIdRoute = WorkshopFilingsSlipIdRouteImport.update({
  id: '/filings-slip/$id',
  path: '/filings-slip/$id',
  getParentRoute: () => WorkshopRoute,
} as any)
const WorkshopBookJewellerIdRoute = WorkshopBookJewellerIdRouteImport.update({
  id: '/book/$jewellerId',
  path: '/book/$jewellerId',
  getParentRoute: () => WorkshopRoute,
} as any)
const VerifyInvoiceTokenRoute = VerifyInvoiceTokenRouteImport.update({
  id: '/invoice/$token',
  path: '/invoice/$token',
  getParentRoute: () => VerifyRoute,
} as any)
const StockPrintIdRoute = StockPrintIdRouteImport.update({
  id: '/print/$id',
  path: '/print/$id',
  getParentRoute: () => StockRoute,
} as any)
const SettlementDraftPrintIdRoute = SettlementDraftPrintIdRouteImport.update({
  id: '/settlement/draft-print/$id',
  path: '/settlement/draft-print/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIntegrationsWhatsappRoute =
  SettingsIntegrationsWhatsappRouteImport.update({
    id: '/integrations/whatsapp',
    path: '/integrations/whatsapp',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsCommunicationsMetaCallbackRoute =
  SettingsCommunicationsMetaCallbackRouteImport.update({
    id: '/meta-callback',
    path: '/meta-callback',
    getParentRoute: () => SettingsCommunicationsRoute,
  } as any)
const ReportsDailyclosePrintIdRoute =
  ReportsDailyclosePrintIdRouteImport.update({
    id: '/dailyclose-print/$id',
    path: '/dailyclose-print/$id',
    getParentRoute: () => ReportsRoute,
  } as any)
const ReportsBookPrintDocTypeRoute = ReportsBookPrintDocTypeRouteImport.update({
  id: '/book-print/$docType',
  path: '/book-print/$docType',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsAccountBalancePrintVariantRoute =
  ReportsAccountBalancePrintVariantRouteImport.update({
    id: '/account-balance-print/$variant',
    path: '/account-balance-print/$variant',
    getParentRoute: () => ReportsRoute,
  } as any)
const RepairPolishingNewRoute = RepairPolishingNewRouteImport.update({
  id: '/polishing/new',
  path: '/polishing/new',
  getParentRoute: () => RepairRoute,
} as any)
const PlatformBillingPrintIdRoute = PlatformBillingPrintIdRouteImport.update({
  id: '/billing-print/$id',
  path: '/billing-print/$id',
  getParentRoute: () => PlatformRoute,
} as any)
const PeoplePrintIdRoute = PeoplePrintIdRouteImport.update({
  id: '/people/print/$id',
  path: '/people/print/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleLedgerPrintIdRoute = PeopleLedgerPrintIdRouteImport.update({
  id: '/people/ledger-print/$id',
  path: '/people/ledger-print/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ManufacturingBillIdRoute = ManufacturingBillIdRouteImport.update({
  id: '/bill/$id',
  path: '/bill/$id',
  getParentRoute: () => ManufacturingRoute,
} as any)
const Crm360IdRoute = Crm360IdRouteImport.update({
  id: '/crm/360/$id',
  path: '/crm/360/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversionSlipIdRoute = ConversionSlipIdRouteImport.update({
  id: '/conversion/slip/$id',
  path: '/conversion/slip/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingSettlementSlipIdRoute = BillingSettlementSlipIdRouteImport.update({
  id: '/settlement-slip/$id',
  path: '/settlement-slip/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingReceiptIdRoute = BillingReceiptIdRouteImport.update({
  id: '/receipt/$id',
  path: '/receipt/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingPurchasesReturnRoute = BillingPurchasesReturnRouteImport.update({
  id: '/purchases/return',
  path: '/purchases/return',
  getParentRoute: () => BillingRoute,
} as any)
const BillingPrintIdRoute = BillingPrintIdRouteImport.update({
  id: '/print/$id',
  path: '/print/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingGoldSettlementPrintIdRoute =
  BillingGoldSettlementPrintIdRouteImport.update({
    id: '/gold-settlement-print/$id',
    path: '/gold-settlement-print/$id',
    getParentRoute: () => BillingRoute,
  } as any)
const BillingEstimatesIdRoute = BillingEstimatesIdRouteImport.update({
  id: '/estimates/$id',
  path: '/estimates/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingEstimateIdRoute = BillingEstimateIdRouteImport.update({
  id: '/estimate/$id',
  path: '/estimate/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingEstimatePrintIdRoute = BillingEstimatePrintIdRouteImport.update({
  id: '/estimate-print/$id',
  path: '/estimate-print/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingDeliveryChallansIdRoute =
  BillingDeliveryChallansIdRouteImport.update({
    id: '/delivery-challans/$id',
    path: '/delivery-challans/$id',
    getParentRoute: () => BillingRoute,
  } as any)
const BillingDeliveryChallanPrintIdRoute =
  BillingDeliveryChallanPrintIdRouteImport.update({
    id: '/delivery-challan-print/$id',
    path: '/delivery-challan-print/$id',
    getParentRoute: () => BillingRoute,
  } as any)
const BillingDebitNotesIdRoute = BillingDebitNotesIdRouteImport.update({
  id: '/debit-notes/$id',
  path: '/debit-notes/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingDebitNotePrintIdRoute = BillingDebitNotePrintIdRouteImport.update({
  id: '/debit-note-print/$id',
  path: '/debit-note-print/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingCreditNotesIdRoute = BillingCreditNotesIdRouteImport.update({
  id: '/credit-notes/$id',
  path: '/credit-notes/$id',
  getParentRoute: () => BillingRoute,
} as any)
const BillingCreditNotePrintIdRoute =
  BillingCreditNotePrintIdRouteImport.update({
    id: '/credit-note-print/$id',
    path: '/credit-note-print/$id',
    getParentRoute: () => BillingRoute,
  } as any)
const WorkshopPrintJobCardOrderIdRoute =
  WorkshopPrintJobCardOrderIdRouteImport.update({
    id: '/print/job-card/$orderId',
    path: '/print/job-card/$orderId',
    getParentRoute: () => WorkshopRoute,
  } as any)
const WorkshopMaterialSlipWorkerIdDateRoute =
  WorkshopMaterialSlipWorkerIdDateRouteImport.update({
    id: '/material-slip/$workerId/$date',
    path: '/material-slip/$workerId/$date',
    getParentRoute: () => WorkshopRoute,
  } as any)
const RepairPrintKindIdRoute = RepairPrintKindIdRouteImport.update({
  id: '/print/$kind/$id',
  path: '/print/$kind/$id',
  getParentRoute: () => RepairRoute,
} as any)
const OrdersPrintKindIdRoute = OrdersPrintKindIdRouteImport.update({
  id: '/print/$kind/$id',
  path: '/print/$kind/$id',
  getParentRoute: () => OrdersRoute,
} as any)
const ManufacturingBillNewJobIdRoute =
  ManufacturingBillNewJobIdRouteImport.update({
    id: '/bill/new/$jobId',
    path: '/bill/new/$jobId',
    getParentRoute: () => ManufacturingRoute,
  } as any)
const AttendancePrintKindIdRoute = AttendancePrintKindIdRouteImport.update({
  id: '/print/$kind/$id',
  path: '/print/$kind/$id',
  getParentRoute: () => AttendanceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/admin': typeof AdminRouteWithChildren
  '/ai-center': typeof AiCenterRoute
  '/app': typeof AppRoute
  '/assistant': typeof AssistantRoute
  '/attendance': typeof AttendanceRouteWithChildren
  '/barcode': typeof BarcodeRoute
  '/billing': typeof BillingRouteWithChildren
  '/catalog': typeof CatalogRouteWithChildren
  '/communications': typeof CommunicationsRouteWithChildren
  '/company-admin': typeof CompanyAdminRoute
  '/customer-login': typeof CustomerLoginRoute
  '/customer-portal': typeof CustomerPortalRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/help': typeof HelpRoute
  '/invite': typeof InviteRouteWithChildren
  '/karigar-login': typeof KarigarLoginRoute
  '/karigar-portal': typeof KarigarPortalRoute
  '/ledger': typeof LedgerRoute
  '/login': typeof LoginRoute
  '/manufacturing': typeof ManufacturingRouteWithChildren
  '/master': typeof MasterRoute
  '/melt': typeof MeltRouteWithChildren
  '/mtg': typeof MtgRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRouteWithChildren
  '/otp-login': typeof OtpLoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/repair': typeof RepairRouteWithChildren
  '/reports': typeof ReportsRouteWithChildren
  '/request-access': typeof RequestAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/saas-admin': typeof SaasAdminRoute
  '/scheme': typeof SchemeRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/signup': typeof SignupRoute
  '/stock': typeof StockRouteWithChildren
  '/supplier-login': typeof SupplierLoginRoute
  '/supplier-portal': typeof SupplierPortalRoute
  '/terms': typeof TermsRoute
  '/transaction-hub': typeof TransactionHubRoute
  '/transactions': typeof TransactionsRoute
  '/utilities': typeof UtilitiesRouteWithChildren
  '/verify': typeof VerifyRouteWithChildren
  '/whatsapp': typeof WhatsappRouteWithChildren
  '/workshop': typeof WorkshopRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/$id': typeof BillingIdRoute
  '/billing/credit-note': typeof BillingCreditNoteRoute
  '/billing/new': typeof BillingNewRoute
  '/catalog/$id': typeof CatalogIdRoute
  '/catalog/designer': typeof CatalogDesignerRoute
  '/catalog/masters': typeof CatalogMastersRoute
  '/catalog/templates': typeof CatalogTemplatesRoute
  '/coming-soon/barcode-printing': typeof ComingSoonBarcodePrintingRoute
  '/coming-soon/barcode-scanner': typeof ComingSoonBarcodeScannerRoute
  '/coming-soon/meena-book': typeof ComingSoonMeenaBookRoute
  '/control/accounts': typeof ControlAccountsRoute
  '/control/customization': typeof ControlCustomizationRoute
  '/control/migration': typeof ControlMigrationRoute
  '/control/print-profiles': typeof ControlPrintProfilesRoute
  '/control/rates': typeof ControlRatesRoute
  '/control/shortcuts': typeof ControlShortcutsRoute
  '/control/tally-export': typeof ControlTallyExportRoute
  '/control/terminology': typeof ControlTerminologyRoute
  '/crm/appointments': typeof CrmAppointmentsRoute
  '/crm/leads': typeof CrmLeadsRoute
  '/dashboard/ceo': typeof DashboardCeoRoute
  '/doc/$token': typeof DocTokenRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/manufacturing/owner-transactions': typeof ManufacturingOwnerTransactionsRoute
  '/mobile/assistant': typeof MobileAssistantRoute
  '/mobile/business': typeof MobileBusinessRoute
  '/mobile/gold-stock': typeof MobileGoldStockRoute
  '/mobile/master': typeof MobileMasterRoute
  '/mobile/more': typeof MobileMoreRoute
  '/mobile/reports': typeof MobileReportsRoute
  '/mobile/stock-entry': typeof MobileStockEntryRoute
  '/mobile/sync': typeof MobileSyncRoute
  '/mobile/transactions': typeof MobileTransactionsRoute
  '/mobile/work': typeof MobileWorkRoute
  '/orders/$id': typeof OrdersIdRoute
  '/orders/import': typeof OrdersImportRoute
  '/orders/new': typeof OrdersNewRoute
  '/people/$id': typeof PeopleIdRoute
  '/people/import': typeof PeopleImportRoute
  '/platform/commercial-pricing': typeof PlatformCommercialPricingRoute
  '/platform/communication-providers': typeof PlatformCommunicationProvidersRoute
  '/platform/meta-whatsapp': typeof PlatformMetaWhatsappRoute
  '/platform/plans': typeof PlatformPlansRoute
  '/platform/trials': typeof PlatformTrialsRoute
  '/platform/website': typeof PlatformWebsiteRoute
  '/repair/$id': typeof RepairIdRoute
  '/repair/new': typeof RepairNewRoute
  '/reports/account-balance': typeof ReportsAccountBalanceRoute
  '/reports/approvals': typeof ReportsApprovalsRoute
  '/reports/audit-log': typeof ReportsAuditLogRoute
  '/reports/auditor': typeof ReportsAuditorRoute
  '/reports/bank-transactions': typeof ReportsBankTransactionsRoute
  '/reports/barcode-stock': typeof ReportsBarcodeStockRoute
  '/reports/branch': typeof ReportsBranchRoute
  '/reports/bullion-ledger': typeof ReportsBullionLedgerRoute
  '/reports/ca-pack': typeof ReportsCaPackRoute
  '/reports/cash-flow': typeof ReportsCashFlowRoute
  '/reports/city-wise': typeof ReportsCityWiseRoute
  '/reports/communication-analytics': typeof ReportsCommunicationAnalyticsRoute
  '/reports/customer-statement': typeof ReportsCustomerStatementRoute
  '/reports/daily-close': typeof ReportsDailyCloseRoute
  '/reports/daily-gold-flow': typeof ReportsDailyGoldFlowRoute
  '/reports/daily-summary': typeof ReportsDailySummaryRoute
  '/reports/dar-rojmel': typeof ReportsDarRojmelRoute
  '/reports/day-wise': typeof ReportsDayWiseRoute
  '/reports/dealer': typeof ReportsDealerRoute
  '/reports/deleted-bills': typeof ReportsDeletedBillsRoute
  '/reports/delivery-summary': typeof ReportsDeliverySummaryRoute
  '/reports/dhadi-book': typeof ReportsDhadiBookRoute
  '/reports/discount-report': typeof ReportsDiscountReportRoute
  '/reports/erp-audit': typeof ReportsErpAuditRoute
  '/reports/exceptions': typeof ReportsExceptionsRoute
  '/reports/financial-statements': typeof ReportsFinancialStatementsRoute
  '/reports/fine-margin': typeof ReportsFineMarginRoute
  '/reports/fine-rojmel': typeof ReportsFineRojmelRoute
  '/reports/gold-ledger': typeof ReportsGoldLedgerRoute
  '/reports/gold-loss': typeof ReportsGoldLossRoute
  '/reports/gold-outstanding': typeof ReportsGoldOutstandingRoute
  '/reports/gold-position': typeof ReportsGoldPositionRoute
  '/reports/gold-reconciliation': typeof ReportsGoldReconciliationRoute
  '/reports/gold-stock': typeof ReportsGoldStockRoute
  '/reports/gold-summary': typeof ReportsGoldSummaryRoute
  '/reports/gst-returns': typeof ReportsGstReturnsRoute
  '/reports/hsn-summary': typeof ReportsHsnSummaryRoute
  '/reports/inventory-ageing': typeof ReportsInventoryAgeingRoute
  '/reports/itc04': typeof ReportsItc04Route
  '/reports/item-jama-nave': typeof ReportsItemJamaNaveRoute
  '/reports/item-transaction': typeof ReportsItemTransactionRoute
  '/reports/ledgers': typeof ReportsLedgersRoute
  '/reports/ledgers-print-all': typeof ReportsLedgersPrintAllRoute
  '/reports/manufacturing': typeof ReportsManufacturingRoute
  '/reports/manufacturing-reconciliation': typeof ReportsManufacturingReconciliationRoute
  '/reports/metal-position': typeof ReportsMetalPositionRoute
  '/reports/month-end-close': typeof ReportsMonthEndCloseRoute
  '/reports/outside-work': typeof ReportsOutsideWorkRoute
  '/reports/owner-drawings': typeof ReportsOwnerDrawingsRoute
  '/reports/purchase-register': typeof ReportsPurchaseRegisterRoute
  '/reports/reconciliation-center': typeof ReportsReconciliationCenterRoute
  '/reports/reminders': typeof ReportsRemindersRoute
  '/reports/sales-register': typeof ReportsSalesRegisterRoute
  '/reports/scheme': typeof ReportsSchemeRoute
  '/reports/settlement-reconciliation': typeof ReportsSettlementReconciliationRoute
  '/reports/settlements': typeof ReportsSettlementsRoute
  '/reports/stock-valuation': typeof ReportsStockValuationRoute
  '/reports/tally-export': typeof ReportsTallyExportRoute
  '/reports/tanch-hishob': typeof ReportsTanchHishobRoute
  '/reports/total-profit': typeof ReportsTotalProfitRoute
  '/reports/vault-reconciliation': typeof ReportsVaultReconciliationRoute
  '/reports/worker': typeof ReportsWorkerRoute
  '/scheme/accounts': typeof SchemeAccountsRoute
  '/scheme/plans': typeof SchemePlansRoute
  '/scheme/receipts': typeof SchemeReceiptsRoute
  '/settings/automation': typeof SettingsAutomationRoute
  '/settings/backup-recovery': typeof SettingsBackupRecoveryRoute
  '/settings/branch-settings': typeof SettingsBranchSettingsRoute
  '/settings/communications': typeof SettingsCommunicationsRouteWithChildren
  '/settings/document-vault': typeof SettingsDocumentVaultRoute
  '/settings/integrations-hub': typeof SettingsIntegrationsHubRoute
  '/settings/license': typeof SettingsLicenseRoute
  '/settings/print-templates': typeof SettingsPrintTemplatesRoute
  '/settings/security-center': typeof SettingsSecurityCenterRoute
  '/settings/storage-diagnostics': typeof SettingsStorageDiagnosticsRoute
  '/settings/support': typeof SettingsSupportRoute
  '/settings/whatsapp': typeof SettingsWhatsappRoute
  '/settings/whatsapp-templates': typeof SettingsWhatsappTemplatesRoute
  '/settings/workflow': typeof SettingsWorkflowRoute
  '/settlement/$id': typeof SettlementIdRoute
  '/settlement/new': typeof SettlementNewRoute
  '/stock/$id': typeof StockIdRoute
  '/stock/boxes': typeof StockBoxesRoute
  '/stock/entry': typeof StockEntryRoute
  '/stock/hallmark': typeof StockHallmarkRoute
  '/stock/import': typeof StockImportRoute
  '/stock/lots': typeof StockLotsRoute
  '/stock/stones': typeof StockStonesRoute
  '/stock/transfers': typeof StockTransfersRoute
  '/stock/verification': typeof StockVerificationRoute
  '/treasury/bank-reconciliation': typeof TreasuryBankReconciliationRoute
  '/treasury/cash-book': typeof TreasuryCashBookRoute
  '/treasury/vouchers': typeof TreasuryVouchersRoute
  '/trial/start': typeof TrialStartRoute
  '/ui/catalog': typeof UiCatalogRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/utilities/cash-fine-transfer': typeof UtilitiesCashFineTransferRoute
  '/utilities/counter-settings': typeof UtilitiesCounterSettingsRoute
  '/utilities/gst-calculator': typeof UtilitiesGstCalculatorRoute
  '/utilities/item-masters': typeof UtilitiesItemMastersRoute
  '/utilities/item-transaction': typeof UtilitiesItemTransactionRoute
  '/utilities/opening-fine-cash': typeof UtilitiesOpeningFineCashRoute
  '/utilities/patla-stock': typeof UtilitiesPatlaStockRoute
  '/utilities/sauda-book': typeof UtilitiesSaudaBookRoute
  '/utilities/sub-accounts': typeof UtilitiesSubAccountsRoute
  '/utilities/urd-purchase': typeof UtilitiesUrdPurchaseRoute
  '/utilities/wipeout': typeof UtilitiesWipeoutRoute
  '/workshop/$id': typeof WorkshopIdRoute
  '/workshop/barcode-scanner': typeof WorkshopBarcodeScannerRoute
  '/workshop/bench-custody': typeof WorkshopBenchCustodyRoute
  '/workshop/dhadi-groups': typeof WorkshopDhadiGroupsRoute
  '/workshop/gold-book': typeof WorkshopGoldBookRoute
  '/workshop/jama': typeof WorkshopJamaRoute
  '/workshop/jangad': typeof WorkshopJangadRoute
  '/workshop/karigar-book': typeof WorkshopKarigarBookRoute
  '/workshop/outside-work': typeof WorkshopOutsideWorkRoute
  '/workshop/outside-worker-books': typeof WorkshopOutsideWorkerBooksRoute
  '/workshop/polishing': typeof WorkshopPolishingRoute
  '/workshop/polishing-books': typeof WorkshopPolishingBooksRoute
  '/workshop/reconciliation': typeof WorkshopReconciliationRoute
  '/workshop/vibrator': typeof WorkshopVibratorRoute
  '/workshop/worker-books': typeof WorkshopWorkerBooksRoute
  '/accounts/': typeof AccountsIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/attendance/': typeof AttendanceIndexRoute
  '/billing/': typeof BillingIndexRoute
  '/branches/': typeof BranchesIndexRoute
  '/catalog/': typeof CatalogIndexRoute
  '/communications/': typeof CommunicationsIndexRoute
  '/conversion/': typeof ConversionIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/hardware/': typeof HardwareIndexRoute
  '/manufacturing/': typeof ManufacturingIndexRoute
  '/melt/': typeof MeltIndexRoute
  '/mobile/': typeof MobileIndexRoute
  '/mtg/': typeof MtgIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/refinery/': typeof RefineryIndexRoute
  '/repair/': typeof RepairIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/scheme/': typeof SchemeIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/stock/': typeof StockIndexRoute
  '/utilities/': typeof UtilitiesIndexRoute
  '/whatsapp/': typeof WhatsappIndexRoute
  '/workshop/': typeof WorkshopIndexRoute
  '/billing/credit-note-print/$id': typeof BillingCreditNotePrintIdRoute
  '/billing/credit-notes/$id': typeof BillingCreditNotesIdRoute
  '/billing/debit-note-print/$id': typeof BillingDebitNotePrintIdRoute
  '/billing/debit-notes/$id': typeof BillingDebitNotesIdRoute
  '/billing/delivery-challan-print/$id': typeof BillingDeliveryChallanPrintIdRoute
  '/billing/delivery-challans/$id': typeof BillingDeliveryChallansIdRoute
  '/billing/estimate-print/$id': typeof BillingEstimatePrintIdRoute
  '/billing/estimate/$id': typeof BillingEstimateIdRoute
  '/billing/estimates/$id': typeof BillingEstimatesIdRoute
  '/billing/gold-settlement-print/$id': typeof BillingGoldSettlementPrintIdRoute
  '/billing/print/$id': typeof BillingPrintIdRoute
  '/billing/purchases/return': typeof BillingPurchasesReturnRoute
  '/billing/receipt/$id': typeof BillingReceiptIdRoute
  '/billing/settlement-slip/$id': typeof BillingSettlementSlipIdRoute
  '/conversion/slip/$id': typeof ConversionSlipIdRoute
  '/crm/360/$id': typeof Crm360IdRoute
  '/manufacturing/bill/$id': typeof ManufacturingBillIdRoute
  '/people/ledger-print/$id': typeof PeopleLedgerPrintIdRoute
  '/people/print/$id': typeof PeoplePrintIdRoute
  '/platform/billing-print/$id': typeof PlatformBillingPrintIdRoute
  '/repair/polishing/new': typeof RepairPolishingNewRoute
  '/reports/account-balance-print/$variant': typeof ReportsAccountBalancePrintVariantRoute
  '/reports/book-print/$docType': typeof ReportsBookPrintDocTypeRoute
  '/reports/dailyclose-print/$id': typeof ReportsDailyclosePrintIdRoute
  '/settings/communications/meta-callback': typeof SettingsCommunicationsMetaCallbackRoute
  '/settings/integrations/whatsapp': typeof SettingsIntegrationsWhatsappRoute
  '/settlement/draft-print/$id': typeof SettlementDraftPrintIdRoute
  '/stock/print/$id': typeof StockPrintIdRoute
  '/verify/invoice/$token': typeof VerifyInvoiceTokenRoute
  '/workshop/book/$jewellerId': typeof WorkshopBookJewellerIdRoute
  '/workshop/filings-slip/$id': typeof WorkshopFilingsSlipIdRoute
  '/workshop/gold-book-print/$workerId': typeof WorkshopGoldBookPrintWorkerIdRoute
  '/workshop/job-card/$orderId': typeof WorkshopJobCardOrderIdRoute
  '/workshop/outside-worker-book/$partyId': typeof WorkshopOutsideWorkerBookPartyIdRoute
  '/workshop/polishing-book/$partyId': typeof WorkshopPolishingBookPartyIdRoute
  '/workshop/process/$type': typeof WorkshopProcessTypeRoute
  '/workshop/receive-slip/$id': typeof WorkshopReceiveSlipIdRoute
  '/workshop/worker-book/$workerId': typeof WorkshopWorkerBookWorkerIdRoute
  '/billing/credit-notes/': typeof BillingCreditNotesIndexRoute
  '/billing/debit-notes/': typeof BillingDebitNotesIndexRoute
  '/billing/delivery-challans/': typeof BillingDeliveryChallansIndexRoute
  '/billing/estimates/': typeof BillingEstimatesIndexRoute
  '/billing/purchases/': typeof BillingPurchasesIndexRoute
  '/attendance/print/$kind/$id': typeof AttendancePrintKindIdRoute
  '/manufacturing/bill/new/$jobId': typeof ManufacturingBillNewJobIdRoute
  '/orders/print/$kind/$id': typeof OrdersPrintKindIdRoute
  '/repair/print/$kind/$id': typeof RepairPrintKindIdRoute
  '/workshop/material-slip/$workerId/$date': typeof WorkshopMaterialSlipWorkerIdDateRoute
  '/workshop/print/job-card/$orderId': typeof WorkshopPrintJobCardOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/ai-center': typeof AiCenterRoute
  '/app': typeof AppRoute
  '/assistant': typeof AssistantRoute
  '/barcode': typeof BarcodeRoute
  '/company-admin': typeof CompanyAdminRoute
  '/customer-login': typeof CustomerLoginRoute
  '/customer-portal': typeof CustomerPortalRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/help': typeof HelpRoute
  '/invite': typeof InviteRouteWithChildren
  '/karigar-login': typeof KarigarLoginRoute
  '/karigar-portal': typeof KarigarPortalRoute
  '/ledger': typeof LedgerRoute
  '/login': typeof LoginRoute
  '/master': typeof MasterRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/otp-login': typeof OtpLoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/request-access': typeof RequestAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/saas-admin': typeof SaasAdminRoute
  '/setup': typeof SetupRoute
  '/signup': typeof SignupRoute
  '/supplier-login': typeof SupplierLoginRoute
  '/supplier-portal': typeof SupplierPortalRoute
  '/terms': typeof TermsRoute
  '/transaction-hub': typeof TransactionHubRoute
  '/transactions': typeof TransactionsRoute
  '/verify': typeof VerifyRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/$id': typeof BillingIdRoute
  '/billing/credit-note': typeof BillingCreditNoteRoute
  '/billing/new': typeof BillingNewRoute
  '/catalog/$id': typeof CatalogIdRoute
  '/catalog/designer': typeof CatalogDesignerRoute
  '/catalog/masters': typeof CatalogMastersRoute
  '/catalog/templates': typeof CatalogTemplatesRoute
  '/coming-soon/barcode-printing': typeof ComingSoonBarcodePrintingRoute
  '/coming-soon/barcode-scanner': typeof ComingSoonBarcodeScannerRoute
  '/coming-soon/meena-book': typeof ComingSoonMeenaBookRoute
  '/control/accounts': typeof ControlAccountsRoute
  '/control/customization': typeof ControlCustomizationRoute
  '/control/migration': typeof ControlMigrationRoute
  '/control/print-profiles': typeof ControlPrintProfilesRoute
  '/control/rates': typeof ControlRatesRoute
  '/control/shortcuts': typeof ControlShortcutsRoute
  '/control/tally-export': typeof ControlTallyExportRoute
  '/control/terminology': typeof ControlTerminologyRoute
  '/crm/appointments': typeof CrmAppointmentsRoute
  '/crm/leads': typeof CrmLeadsRoute
  '/dashboard/ceo': typeof DashboardCeoRoute
  '/doc/$token': typeof DocTokenRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/manufacturing/owner-transactions': typeof ManufacturingOwnerTransactionsRoute
  '/mobile/assistant': typeof MobileAssistantRoute
  '/mobile/business': typeof MobileBusinessRoute
  '/mobile/gold-stock': typeof MobileGoldStockRoute
  '/mobile/master': typeof MobileMasterRoute
  '/mobile/more': typeof MobileMoreRoute
  '/mobile/reports': typeof MobileReportsRoute
  '/mobile/stock-entry': typeof MobileStockEntryRoute
  '/mobile/sync': typeof MobileSyncRoute
  '/mobile/transactions': typeof MobileTransactionsRoute
  '/mobile/work': typeof MobileWorkRoute
  '/orders/$id': typeof OrdersIdRoute
  '/orders/import': typeof OrdersImportRoute
  '/orders/new': typeof OrdersNewRoute
  '/people/$id': typeof PeopleIdRoute
  '/people/import': typeof PeopleImportRoute
  '/platform/commercial-pricing': typeof PlatformCommercialPricingRoute
  '/platform/communication-providers': typeof PlatformCommunicationProvidersRoute
  '/platform/meta-whatsapp': typeof PlatformMetaWhatsappRoute
  '/platform/plans': typeof PlatformPlansRoute
  '/platform/trials': typeof PlatformTrialsRoute
  '/platform/website': typeof PlatformWebsiteRoute
  '/repair/$id': typeof RepairIdRoute
  '/repair/new': typeof RepairNewRoute
  '/reports/account-balance': typeof ReportsAccountBalanceRoute
  '/reports/approvals': typeof ReportsApprovalsRoute
  '/reports/audit-log': typeof ReportsAuditLogRoute
  '/reports/auditor': typeof ReportsAuditorRoute
  '/reports/bank-transactions': typeof ReportsBankTransactionsRoute
  '/reports/barcode-stock': typeof ReportsBarcodeStockRoute
  '/reports/branch': typeof ReportsBranchRoute
  '/reports/bullion-ledger': typeof ReportsBullionLedgerRoute
  '/reports/ca-pack': typeof ReportsCaPackRoute
  '/reports/cash-flow': typeof ReportsCashFlowRoute
  '/reports/city-wise': typeof ReportsCityWiseRoute
  '/reports/communication-analytics': typeof ReportsCommunicationAnalyticsRoute
  '/reports/customer-statement': typeof ReportsCustomerStatementRoute
  '/reports/daily-close': typeof ReportsDailyCloseRoute
  '/reports/daily-gold-flow': typeof ReportsDailyGoldFlowRoute
  '/reports/daily-summary': typeof ReportsDailySummaryRoute
  '/reports/dar-rojmel': typeof ReportsDarRojmelRoute
  '/reports/day-wise': typeof ReportsDayWiseRoute
  '/reports/dealer': typeof ReportsDealerRoute
  '/reports/deleted-bills': typeof ReportsDeletedBillsRoute
  '/reports/delivery-summary': typeof ReportsDeliverySummaryRoute
  '/reports/dhadi-book': typeof ReportsDhadiBookRoute
  '/reports/discount-report': typeof ReportsDiscountReportRoute
  '/reports/erp-audit': typeof ReportsErpAuditRoute
  '/reports/exceptions': typeof ReportsExceptionsRoute
  '/reports/financial-statements': typeof ReportsFinancialStatementsRoute
  '/reports/fine-margin': typeof ReportsFineMarginRoute
  '/reports/fine-rojmel': typeof ReportsFineRojmelRoute
  '/reports/gold-ledger': typeof ReportsGoldLedgerRoute
  '/reports/gold-loss': typeof ReportsGoldLossRoute
  '/reports/gold-outstanding': typeof ReportsGoldOutstandingRoute
  '/reports/gold-position': typeof ReportsGoldPositionRoute
  '/reports/gold-reconciliation': typeof ReportsGoldReconciliationRoute
  '/reports/gold-stock': typeof ReportsGoldStockRoute
  '/reports/gold-summary': typeof ReportsGoldSummaryRoute
  '/reports/gst-returns': typeof ReportsGstReturnsRoute
  '/reports/hsn-summary': typeof ReportsHsnSummaryRoute
  '/reports/inventory-ageing': typeof ReportsInventoryAgeingRoute
  '/reports/itc04': typeof ReportsItc04Route
  '/reports/item-jama-nave': typeof ReportsItemJamaNaveRoute
  '/reports/item-transaction': typeof ReportsItemTransactionRoute
  '/reports/ledgers': typeof ReportsLedgersRoute
  '/reports/ledgers-print-all': typeof ReportsLedgersPrintAllRoute
  '/reports/manufacturing': typeof ReportsManufacturingRoute
  '/reports/manufacturing-reconciliation': typeof ReportsManufacturingReconciliationRoute
  '/reports/metal-position': typeof ReportsMetalPositionRoute
  '/reports/month-end-close': typeof ReportsMonthEndCloseRoute
  '/reports/outside-work': typeof ReportsOutsideWorkRoute
  '/reports/owner-drawings': typeof ReportsOwnerDrawingsRoute
  '/reports/purchase-register': typeof ReportsPurchaseRegisterRoute
  '/reports/reconciliation-center': typeof ReportsReconciliationCenterRoute
  '/reports/reminders': typeof ReportsRemindersRoute
  '/reports/sales-register': typeof ReportsSalesRegisterRoute
  '/reports/scheme': typeof ReportsSchemeRoute
  '/reports/settlement-reconciliation': typeof ReportsSettlementReconciliationRoute
  '/reports/settlements': typeof ReportsSettlementsRoute
  '/reports/stock-valuation': typeof ReportsStockValuationRoute
  '/reports/tally-export': typeof ReportsTallyExportRoute
  '/reports/tanch-hishob': typeof ReportsTanchHishobRoute
  '/reports/total-profit': typeof ReportsTotalProfitRoute
  '/reports/vault-reconciliation': typeof ReportsVaultReconciliationRoute
  '/reports/worker': typeof ReportsWorkerRoute
  '/scheme/accounts': typeof SchemeAccountsRoute
  '/scheme/plans': typeof SchemePlansRoute
  '/scheme/receipts': typeof SchemeReceiptsRoute
  '/settings/automation': typeof SettingsAutomationRoute
  '/settings/backup-recovery': typeof SettingsBackupRecoveryRoute
  '/settings/branch-settings': typeof SettingsBranchSettingsRoute
  '/settings/communications': typeof SettingsCommunicationsRouteWithChildren
  '/settings/document-vault': typeof SettingsDocumentVaultRoute
  '/settings/integrations-hub': typeof SettingsIntegrationsHubRoute
  '/settings/license': typeof SettingsLicenseRoute
  '/settings/print-templates': typeof SettingsPrintTemplatesRoute
  '/settings/security-center': typeof SettingsSecurityCenterRoute
  '/settings/storage-diagnostics': typeof SettingsStorageDiagnosticsRoute
  '/settings/support': typeof SettingsSupportRoute
  '/settings/whatsapp': typeof SettingsWhatsappRoute
  '/settings/whatsapp-templates': typeof SettingsWhatsappTemplatesRoute
  '/settings/workflow': typeof SettingsWorkflowRoute
  '/settlement/$id': typeof SettlementIdRoute
  '/settlement/new': typeof SettlementNewRoute
  '/stock/$id': typeof StockIdRoute
  '/stock/boxes': typeof StockBoxesRoute
  '/stock/entry': typeof StockEntryRoute
  '/stock/hallmark': typeof StockHallmarkRoute
  '/stock/import': typeof StockImportRoute
  '/stock/lots': typeof StockLotsRoute
  '/stock/stones': typeof StockStonesRoute
  '/stock/transfers': typeof StockTransfersRoute
  '/stock/verification': typeof StockVerificationRoute
  '/treasury/bank-reconciliation': typeof TreasuryBankReconciliationRoute
  '/treasury/cash-book': typeof TreasuryCashBookRoute
  '/treasury/vouchers': typeof TreasuryVouchersRoute
  '/trial/start': typeof TrialStartRoute
  '/ui/catalog': typeof UiCatalogRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/utilities/cash-fine-transfer': typeof UtilitiesCashFineTransferRoute
  '/utilities/counter-settings': typeof UtilitiesCounterSettingsRoute
  '/utilities/gst-calculator': typeof UtilitiesGstCalculatorRoute
  '/utilities/item-masters': typeof UtilitiesItemMastersRoute
  '/utilities/item-transaction': typeof UtilitiesItemTransactionRoute
  '/utilities/opening-fine-cash': typeof UtilitiesOpeningFineCashRoute
  '/utilities/patla-stock': typeof UtilitiesPatlaStockRoute
  '/utilities/sauda-book': typeof UtilitiesSaudaBookRoute
  '/utilities/sub-accounts': typeof UtilitiesSubAccountsRoute
  '/utilities/urd-purchase': typeof UtilitiesUrdPurchaseRoute
  '/utilities/wipeout': typeof UtilitiesWipeoutRoute
  '/workshop/$id': typeof WorkshopIdRoute
  '/workshop/barcode-scanner': typeof WorkshopBarcodeScannerRoute
  '/workshop/bench-custody': typeof WorkshopBenchCustodyRoute
  '/workshop/dhadi-groups': typeof WorkshopDhadiGroupsRoute
  '/workshop/gold-book': typeof WorkshopGoldBookRoute
  '/workshop/jama': typeof WorkshopJamaRoute
  '/workshop/jangad': typeof WorkshopJangadRoute
  '/workshop/karigar-book': typeof WorkshopKarigarBookRoute
  '/workshop/outside-work': typeof WorkshopOutsideWorkRoute
  '/workshop/outside-worker-books': typeof WorkshopOutsideWorkerBooksRoute
  '/workshop/polishing': typeof WorkshopPolishingRoute
  '/workshop/polishing-books': typeof WorkshopPolishingBooksRoute
  '/workshop/reconciliation': typeof WorkshopReconciliationRoute
  '/workshop/vibrator': typeof WorkshopVibratorRoute
  '/workshop/worker-books': typeof WorkshopWorkerBooksRoute
  '/accounts': typeof AccountsIndexRoute
  '/admin': typeof AdminIndexRoute
  '/attendance': typeof AttendanceIndexRoute
  '/billing': typeof BillingIndexRoute
  '/branches': typeof BranchesIndexRoute
  '/catalog': typeof CatalogIndexRoute
  '/communications': typeof CommunicationsIndexRoute
  '/conversion': typeof ConversionIndexRoute
  '/expenses': typeof ExpensesIndexRoute
  '/hardware': typeof HardwareIndexRoute
  '/manufacturing': typeof ManufacturingIndexRoute
  '/melt': typeof MeltIndexRoute
  '/mobile': typeof MobileIndexRoute
  '/mtg': typeof MtgIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/people': typeof PeopleIndexRoute
  '/refinery': typeof RefineryIndexRoute
  '/repair': typeof RepairIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/scheme': typeof SchemeIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/stock': typeof StockIndexRoute
  '/utilities': typeof UtilitiesIndexRoute
  '/whatsapp': typeof WhatsappIndexRoute
  '/workshop': typeof WorkshopIndexRoute
  '/billing/credit-note-print/$id': typeof BillingCreditNotePrintIdRoute
  '/billing/credit-notes/$id': typeof BillingCreditNotesIdRoute
  '/billing/debit-note-print/$id': typeof BillingDebitNotePrintIdRoute
  '/billing/debit-notes/$id': typeof BillingDebitNotesIdRoute
  '/billing/delivery-challan-print/$id': typeof BillingDeliveryChallanPrintIdRoute
  '/billing/delivery-challans/$id': typeof BillingDeliveryChallansIdRoute
  '/billing/estimate-print/$id': typeof BillingEstimatePrintIdRoute
  '/billing/estimate/$id': typeof BillingEstimateIdRoute
  '/billing/estimates/$id': typeof BillingEstimatesIdRoute
  '/billing/gold-settlement-print/$id': typeof BillingGoldSettlementPrintIdRoute
  '/billing/print/$id': typeof BillingPrintIdRoute
  '/billing/purchases/return': typeof BillingPurchasesReturnRoute
  '/billing/receipt/$id': typeof BillingReceiptIdRoute
  '/billing/settlement-slip/$id': typeof BillingSettlementSlipIdRoute
  '/conversion/slip/$id': typeof ConversionSlipIdRoute
  '/crm/360/$id': typeof Crm360IdRoute
  '/manufacturing/bill/$id': typeof ManufacturingBillIdRoute
  '/people/ledger-print/$id': typeof PeopleLedgerPrintIdRoute
  '/people/print/$id': typeof PeoplePrintIdRoute
  '/platform/billing-print/$id': typeof PlatformBillingPrintIdRoute
  '/repair/polishing/new': typeof RepairPolishingNewRoute
  '/reports/account-balance-print/$variant': typeof ReportsAccountBalancePrintVariantRoute
  '/reports/book-print/$docType': typeof ReportsBookPrintDocTypeRoute
  '/reports/dailyclose-print/$id': typeof ReportsDailyclosePrintIdRoute
  '/settings/communications/meta-callback': typeof SettingsCommunicationsMetaCallbackRoute
  '/settings/integrations/whatsapp': typeof SettingsIntegrationsWhatsappRoute
  '/settlement/draft-print/$id': typeof SettlementDraftPrintIdRoute
  '/stock/print/$id': typeof StockPrintIdRoute
  '/verify/invoice/$token': typeof VerifyInvoiceTokenRoute
  '/workshop/book/$jewellerId': typeof WorkshopBookJewellerIdRoute
  '/workshop/filings-slip/$id': typeof WorkshopFilingsSlipIdRoute
  '/workshop/gold-book-print/$workerId': typeof WorkshopGoldBookPrintWorkerIdRoute
  '/workshop/job-card/$orderId': typeof WorkshopJobCardOrderIdRoute
  '/workshop/outside-worker-book/$partyId': typeof WorkshopOutsideWorkerBookPartyIdRoute
  '/workshop/polishing-book/$partyId': typeof WorkshopPolishingBookPartyIdRoute
  '/workshop/process/$type': typeof WorkshopProcessTypeRoute
  '/workshop/receive-slip/$id': typeof WorkshopReceiveSlipIdRoute
  '/workshop/worker-book/$workerId': typeof WorkshopWorkerBookWorkerIdRoute
  '/billing/credit-notes': typeof BillingCreditNotesIndexRoute
  '/billing/debit-notes': typeof BillingDebitNotesIndexRoute
  '/billing/delivery-challans': typeof BillingDeliveryChallansIndexRoute
  '/billing/estimates': typeof BillingEstimatesIndexRoute
  '/billing/purchases': typeof BillingPurchasesIndexRoute
  '/attendance/print/$kind/$id': typeof AttendancePrintKindIdRoute
  '/manufacturing/bill/new/$jobId': typeof ManufacturingBillNewJobIdRoute
  '/orders/print/$kind/$id': typeof OrdersPrintKindIdRoute
  '/repair/print/$kind/$id': typeof RepairPrintKindIdRoute
  '/workshop/material-slip/$workerId/$date': typeof WorkshopMaterialSlipWorkerIdDateRoute
  '/workshop/print/job-card/$orderId': typeof WorkshopPrintJobCardOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/admin': typeof AdminRouteWithChildren
  '/ai-center': typeof AiCenterRoute
  '/app': typeof AppRoute
  '/assistant': typeof AssistantRoute
  '/attendance': typeof AttendanceRouteWithChildren
  '/barcode': typeof BarcodeRoute
  '/billing': typeof BillingRouteWithChildren
  '/catalog': typeof CatalogRouteWithChildren
  '/communications': typeof CommunicationsRouteWithChildren
  '/company-admin': typeof CompanyAdminRoute
  '/customer-login': typeof CustomerLoginRoute
  '/customer-portal': typeof CustomerPortalRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/help': typeof HelpRoute
  '/invite': typeof InviteRouteWithChildren
  '/karigar-login': typeof KarigarLoginRoute
  '/karigar-portal': typeof KarigarPortalRoute
  '/ledger': typeof LedgerRoute
  '/login': typeof LoginRoute
  '/manufacturing': typeof ManufacturingRouteWithChildren
  '/master': typeof MasterRoute
  '/melt': typeof MeltRouteWithChildren
  '/mtg': typeof MtgRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRouteWithChildren
  '/otp-login': typeof OtpLoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/repair': typeof RepairRouteWithChildren
  '/reports': typeof ReportsRouteWithChildren
  '/request-access': typeof RequestAccessRoute
  '/reset-password': typeof ResetPasswordRoute
  '/saas-admin': typeof SaasAdminRoute
  '/scheme': typeof SchemeRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/signup': typeof SignupRoute
  '/stock': typeof StockRouteWithChildren
  '/supplier-login': typeof SupplierLoginRoute
  '/supplier-portal': typeof SupplierPortalRoute
  '/terms': typeof TermsRoute
  '/transaction-hub': typeof TransactionHubRoute
  '/transactions': typeof TransactionsRoute
  '/utilities': typeof UtilitiesRouteWithChildren
  '/verify': typeof VerifyRouteWithChildren
  '/whatsapp': typeof WhatsappRouteWithChildren
  '/workshop': typeof WorkshopRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/billing/$id': typeof BillingIdRoute
  '/billing/credit-note': typeof BillingCreditNoteRoute
  '/billing/new': typeof BillingNewRoute
  '/catalog/$id': typeof CatalogIdRoute
  '/catalog/designer': typeof CatalogDesignerRoute
  '/catalog/masters': typeof CatalogMastersRoute
  '/catalog/templates': typeof CatalogTemplatesRoute
  '/coming-soon/barcode-printing': typeof ComingSoonBarcodePrintingRoute
  '/coming-soon/barcode-scanner': typeof ComingSoonBarcodeScannerRoute
  '/coming-soon/meena-book': typeof ComingSoonMeenaBookRoute
  '/control/accounts': typeof ControlAccountsRoute
  '/control/customization': typeof ControlCustomizationRoute
  '/control/migration': typeof ControlMigrationRoute
  '/control/print-profiles': typeof ControlPrintProfilesRoute
  '/control/rates': typeof ControlRatesRoute
  '/control/shortcuts': typeof ControlShortcutsRoute
  '/control/tally-export': typeof ControlTallyExportRoute
  '/control/terminology': typeof ControlTerminologyRoute
  '/crm/appointments': typeof CrmAppointmentsRoute
  '/crm/leads': typeof CrmLeadsRoute
  '/dashboard/ceo': typeof DashboardCeoRoute
  '/doc/$token': typeof DocTokenRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/manufacturing/owner-transactions': typeof ManufacturingOwnerTransactionsRoute
  '/mobile/assistant': typeof MobileAssistantRoute
  '/mobile/business': typeof MobileBusinessRoute
  '/mobile/gold-stock': typeof MobileGoldStockRoute
  '/mobile/master': typeof MobileMasterRoute
  '/mobile/more': typeof MobileMoreRoute
  '/mobile/reports': typeof MobileReportsRoute
  '/mobile/stock-entry': typeof MobileStockEntryRoute
  '/mobile/sync': typeof MobileSyncRoute
  '/mobile/transactions': typeof MobileTransactionsRoute
  '/mobile/work': typeof MobileWorkRoute
  '/orders/$id': typeof OrdersIdRoute
  '/orders/import': typeof OrdersImportRoute
  '/orders/new': typeof OrdersNewRoute
  '/people/$id': typeof PeopleIdRoute
  '/people/import': typeof PeopleImportRoute
  '/platform/commercial-pricing': typeof PlatformCommercialPricingRoute
  '/platform/communication-providers': typeof PlatformCommunicationProvidersRoute
  '/platform/meta-whatsapp': typeof PlatformMetaWhatsappRoute
  '/platform/plans': typeof PlatformPlansRoute
  '/platform/trials': typeof PlatformTrialsRoute
  '/platform/website': typeof PlatformWebsiteRoute
  '/repair/$id': typeof RepairIdRoute
  '/repair/new': typeof RepairNewRoute
  '/reports/account-balance': typeof ReportsAccountBalanceRoute
  '/reports/approvals': typeof ReportsApprovalsRoute
  '/reports/audit-log': typeof ReportsAuditLogRoute
  '/reports/auditor': typeof ReportsAuditorRoute
  '/reports/bank-transactions': typeof ReportsBankTransactionsRoute
  '/reports/barcode-stock': typeof ReportsBarcodeStockRoute
  '/reports/branch': typeof ReportsBranchRoute
  '/reports/bullion-ledger': typeof ReportsBullionLedgerRoute
  '/reports/ca-pack': typeof ReportsCaPackRoute
  '/reports/cash-flow': typeof ReportsCashFlowRoute
  '/reports/city-wise': typeof ReportsCityWiseRoute
  '/reports/communication-analytics': typeof ReportsCommunicationAnalyticsRoute
  '/reports/customer-statement': typeof ReportsCustomerStatementRoute
  '/reports/daily-close': typeof ReportsDailyCloseRoute
  '/reports/daily-gold-flow': typeof ReportsDailyGoldFlowRoute
  '/reports/daily-summary': typeof ReportsDailySummaryRoute
  '/reports/dar-rojmel': typeof ReportsDarRojmelRoute
  '/reports/day-wise': typeof ReportsDayWiseRoute
  '/reports/dealer': typeof ReportsDealerRoute
  '/reports/deleted-bills': typeof ReportsDeletedBillsRoute
  '/reports/delivery-summary': typeof ReportsDeliverySummaryRoute
  '/reports/dhadi-book': typeof ReportsDhadiBookRoute
  '/reports/discount-report': typeof ReportsDiscountReportRoute
  '/reports/erp-audit': typeof ReportsErpAuditRoute
  '/reports/exceptions': typeof ReportsExceptionsRoute
  '/reports/financial-statements': typeof ReportsFinancialStatementsRoute
  '/reports/fine-margin': typeof ReportsFineMarginRoute
  '/reports/fine-rojmel': typeof ReportsFineRojmelRoute
  '/reports/gold-ledger': typeof ReportsGoldLedgerRoute
  '/reports/gold-loss': typeof ReportsGoldLossRoute
  '/reports/gold-outstanding': typeof ReportsGoldOutstandingRoute
  '/reports/gold-position': typeof ReportsGoldPositionRoute
  '/reports/gold-reconciliation': typeof ReportsGoldReconciliationRoute
  '/reports/gold-stock': typeof ReportsGoldStockRoute
  '/reports/gold-summary': typeof ReportsGoldSummaryRoute
  '/reports/gst-returns': typeof ReportsGstReturnsRoute
  '/reports/hsn-summary': typeof ReportsHsnSummaryRoute
  '/reports/inventory-ageing': typeof ReportsInventoryAgeingRoute
  '/reports/itc04': typeof ReportsItc04Route
  '/reports/item-jama-nave': typeof ReportsItemJamaNaveRoute
  '/reports/item-transaction': typeof ReportsItemTransactionRoute
  '/reports/ledgers': typeof ReportsLedgersRoute
  '/reports/ledgers-print-all': typeof ReportsLedgersPrintAllRoute
  '/reports/manufacturing': typeof ReportsManufacturingRoute
  '/reports/manufacturing-reconciliation': typeof ReportsManufacturingReconciliationRoute
  '/reports/metal-position': typeof ReportsMetalPositionRoute
  '/reports/month-end-close': typeof ReportsMonthEndCloseRoute
  '/reports/outside-work': typeof ReportsOutsideWorkRoute
  '/reports/owner-drawings': typeof ReportsOwnerDrawingsRoute
  '/reports/purchase-register': typeof ReportsPurchaseRegisterRoute
  '/reports/reconciliation-center': typeof ReportsReconciliationCenterRoute
  '/reports/reminders': typeof ReportsRemindersRoute
  '/reports/sales-register': typeof ReportsSalesRegisterRoute
  '/reports/scheme': typeof ReportsSchemeRoute
  '/reports/settlement-reconciliation': typeof ReportsSettlementReconciliationRoute
  '/reports/settlements': typeof ReportsSettlementsRoute
  '/reports/stock-valuation': typeof ReportsStockValuationRoute
  '/reports/tally-export': typeof ReportsTallyExportRoute
  '/reports/tanch-hishob': typeof ReportsTanchHishobRoute
  '/reports/total-profit': typeof ReportsTotalProfitRoute
  '/reports/vault-reconciliation': typeof ReportsVaultReconciliationRoute
  '/reports/worker': typeof ReportsWorkerRoute
  '/scheme/accounts': typeof SchemeAccountsRoute
  '/scheme/plans': typeof SchemePlansRoute
  '/scheme/receipts': typeof SchemeReceiptsRoute
  '/settings/automation': typeof SettingsAutomationRoute
  '/settings/backup-recovery': typeof SettingsBackupRecoveryRoute
  '/settings/branch-settings': typeof SettingsBranchSettingsRoute
  '/settings/communications': typeof SettingsCommunicationsRouteWithChildren
  '/settings/document-vault': typeof SettingsDocumentVaultRoute
  '/settings/integrations-hub': typeof SettingsIntegrationsHubRoute
  '/settings/license': typeof SettingsLicenseRoute
  '/settings/print-templates': typeof SettingsPrintTemplatesRoute
  '/settings/security-center': typeof SettingsSecurityCenterRoute
  '/settings/storage-diagnostics': typeof SettingsStorageDiagnosticsRoute
  '/settings/support': typeof SettingsSupportRoute
  '/settings/whatsapp': typeof SettingsWhatsappRoute
  '/settings/whatsapp-templates': typeof SettingsWhatsappTemplatesRoute
  '/settings/workflow': typeof SettingsWorkflowRoute
  '/settlement/$id': typeof SettlementIdRoute
  '/settlement/new': typeof SettlementNewRoute
  '/stock/$id': typeof StockIdRoute
  '/stock/boxes': typeof StockBoxesRoute
  '/stock/entry': typeof StockEntryRoute
  '/stock/hallmark': typeof StockHallmarkRoute
  '/stock/import': typeof StockImportRoute
  '/stock/lots': typeof StockLotsRoute
  '/stock/stones': typeof StockStonesRoute
  '/stock/transfers': typeof StockTransfersRoute
  '/stock/verification': typeof StockVerificationRoute
  '/treasury/bank-reconciliation': typeof TreasuryBankReconciliationRoute
  '/treasury/cash-book': typeof TreasuryCashBookRoute
  '/treasury/vouchers': typeof TreasuryVouchersRoute
  '/trial/start': typeof TrialStartRoute
  '/ui/catalog': typeof UiCatalogRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/utilities/cash-fine-transfer': typeof UtilitiesCashFineTransferRoute
  '/utilities/counter-settings': typeof UtilitiesCounterSettingsRoute
  '/utilities/gst-calculator': typeof UtilitiesGstCalculatorRoute
  '/utilities/item-masters': typeof UtilitiesItemMastersRoute
  '/utilities/item-transaction': typeof UtilitiesItemTransactionRoute
  '/utilities/opening-fine-cash': typeof UtilitiesOpeningFineCashRoute
  '/utilities/patla-stock': typeof UtilitiesPatlaStockRoute
  '/utilities/sauda-book': typeof UtilitiesSaudaBookRoute
  '/utilities/sub-accounts': typeof UtilitiesSubAccountsRoute
  '/utilities/urd-purchase': typeof UtilitiesUrdPurchaseRoute
  '/utilities/wipeout': typeof UtilitiesWipeoutRoute
  '/workshop/$id': typeof WorkshopIdRoute
  '/workshop/barcode-scanner': typeof WorkshopBarcodeScannerRoute
  '/workshop/bench-custody': typeof WorkshopBenchCustodyRoute
  '/workshop/dhadi-groups': typeof WorkshopDhadiGroupsRoute
  '/workshop/gold-book': typeof WorkshopGoldBookRoute
  '/workshop/jama': typeof WorkshopJamaRoute
  '/workshop/jangad': typeof WorkshopJangadRoute
  '/workshop/karigar-book': typeof WorkshopKarigarBookRoute
  '/workshop/outside-work': typeof WorkshopOutsideWorkRoute
  '/workshop/outside-worker-books': typeof WorkshopOutsideWorkerBooksRoute
  '/workshop/polishing': typeof WorkshopPolishingRoute
  '/workshop/polishing-books': typeof WorkshopPolishingBooksRoute
  '/workshop/reconciliation': typeof WorkshopReconciliationRoute
  '/workshop/vibrator': typeof WorkshopVibratorRoute
  '/workshop/worker-books': typeof WorkshopWorkerBooksRoute
  '/accounts/': typeof AccountsIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/attendance/': typeof AttendanceIndexRoute
  '/billing/': typeof BillingIndexRoute
  '/branches/': typeof BranchesIndexRoute
  '/catalog/': typeof CatalogIndexRoute
  '/communications/': typeof CommunicationsIndexRoute
  '/conversion/': typeof ConversionIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/hardware/': typeof HardwareIndexRoute
  '/manufacturing/': typeof ManufacturingIndexRoute
  '/melt/': typeof MeltIndexRoute
  '/mobile/': typeof MobileIndexRoute
  '/mtg/': typeof MtgIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/refinery/': typeof RefineryIndexRoute
  '/repair/': typeof RepairIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/scheme/': typeof SchemeIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/stock/': typeof StockIndexRoute
  '/utilities/': typeof UtilitiesIndexRoute
  '/whatsapp/': typeof WhatsappIndexRoute
  '/workshop/': typeof WorkshopIndexRoute
  '/billing/credit-note-print/$id': typeof BillingCreditNotePrintIdRoute
  '/billing/credit-notes/$id': typeof BillingCreditNotesIdRoute
  '/billing/debit-note-print/$id': typeof BillingDebitNotePrintIdRoute
  '/billing/debit-notes/$id': typeof BillingDebitNotesIdRoute
  '/billing/delivery-challan-print/$id': typeof BillingDeliveryChallanPrintIdRoute
  '/billing/delivery-challans/$id': typeof BillingDeliveryChallansIdRoute
  '/billing/estimate-print/$id': typeof BillingEstimatePrintIdRoute
  '/billing/estimate/$id': typeof BillingEstimateIdRoute
  '/billing/estimates/$id': typeof BillingEstimatesIdRoute
  '/billing/gold-settlement-print/$id': typeof BillingGoldSettlementPrintIdRoute
  '/billing/print/$id': typeof BillingPrintIdRoute
  '/billing/purchases/return': typeof BillingPurchasesReturnRoute
  '/billing/receipt/$id': typeof BillingReceiptIdRoute
  '/billing/settlement-slip/$id': typeof BillingSettlementSlipIdRoute
  '/conversion/slip/$id': typeof ConversionSlipIdRoute
  '/crm/360/$id': typeof Crm360IdRoute
  '/manufacturing/bill/$id': typeof ManufacturingBillIdRoute
  '/people/ledger-print/$id': typeof PeopleLedgerPrintIdRoute
  '/people/print/$id': typeof PeoplePrintIdRoute
  '/platform/billing-print/$id': typeof PlatformBillingPrintIdRoute
  '/repair/polishing/new': typeof RepairPolishingNewRoute
  '/reports/account-balance-print/$variant': typeof ReportsAccountBalancePrintVariantRoute
  '/reports/book-print/$docType': typeof ReportsBookPrintDocTypeRoute
  '/reports/dailyclose-print/$id': typeof ReportsDailyclosePrintIdRoute
  '/settings/communications/meta-callback': typeof SettingsCommunicationsMetaCallbackRoute
  '/settings/integrations/whatsapp': typeof SettingsIntegrationsWhatsappRoute
  '/settlement/draft-print/$id': typeof SettlementDraftPrintIdRoute
  '/stock/print/$id': typeof StockPrintIdRoute
  '/verify/invoice/$token': typeof VerifyInvoiceTokenRoute
  '/workshop/book/$jewellerId': typeof WorkshopBookJewellerIdRoute
  '/workshop/filings-slip/$id': typeof WorkshopFilingsSlipIdRoute
  '/workshop/gold-book-print/$workerId': typeof WorkshopGoldBookPrintWorkerIdRoute
  '/workshop/job-card/$orderId': typeof WorkshopJobCardOrderIdRoute
  '/workshop/outside-worker-book/$partyId': typeof WorkshopOutsideWorkerBookPartyIdRoute
  '/workshop/polishing-book/$partyId': typeof WorkshopPolishingBookPartyIdRoute
  '/workshop/process/$type': typeof WorkshopProcessTypeRoute
  '/workshop/receive-slip/$id': typeof WorkshopReceiveSlipIdRoute
  '/workshop/worker-book/$workerId': typeof WorkshopWorkerBookWorkerIdRoute
  '/billing/credit-notes/': typeof BillingCreditNotesIndexRoute
  '/billing/debit-notes/': typeof BillingDebitNotesIndexRoute
  '/billing/delivery-challans/': typeof BillingDeliveryChallansIndexRoute
  '/billing/estimates/': typeof BillingEstimatesIndexRoute
  '/billing/purchases/': typeof BillingPurchasesIndexRoute
  '/attendance/print/$kind/$id': typeof AttendancePrintKindIdRoute
  '/manufacturing/bill/new/$jobId': typeof ManufacturingBillNewJobIdRoute
  '/orders/print/$kind/$id': typeof OrdersPrintKindIdRoute
  '/repair/print/$kind/$id': typeof RepairPrintKindIdRoute
  '/workshop/material-slip/$workerId/$date': typeof WorkshopMaterialSlipWorkerIdDateRoute
  '/workshop/print/job-card/$orderId': typeof WorkshopPrintJobCardOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/admin'
    | '/ai-center'
    | '/app'
    | '/assistant'
    | '/attendance'
    | '/barcode'
    | '/billing'
    | '/catalog'
    | '/communications'
    | '/company-admin'
    | '/customer-login'
    | '/customer-portal'
    | '/dashboard'
    | '/forgot-password'
    | '/help'
    | '/invite'
    | '/karigar-login'
    | '/karigar-portal'
    | '/ledger'
    | '/login'
    | '/manufacturing'
    | '/master'
    | '/melt'
    | '/mtg'
    | '/notifications'
    | '/onboarding'
    | '/orders'
    | '/otp-login'
    | '/platform'
    | '/privacy'
    | '/repair'
    | '/reports'
    | '/request-access'
    | '/reset-password'
    | '/saas-admin'
    | '/scheme'
    | '/settings'
    | '/setup'
    | '/signup'
    | '/stock'
    | '/supplier-login'
    | '/supplier-portal'
    | '/terms'
    | '/transaction-hub'
    | '/transactions'
    | '/utilities'
    | '/verify'
    | '/whatsapp'
    | '/workshop'
    | '/auth/callback'
    | '/billing/$id'
    | '/billing/credit-note'
    | '/billing/new'
    | '/catalog/$id'
    | '/catalog/designer'
    | '/catalog/masters'
    | '/catalog/templates'
    | '/coming-soon/barcode-printing'
    | '/coming-soon/barcode-scanner'
    | '/coming-soon/meena-book'
    | '/control/accounts'
    | '/control/customization'
    | '/control/migration'
    | '/control/print-profiles'
    | '/control/rates'
    | '/control/shortcuts'
    | '/control/tally-export'
    | '/control/terminology'
    | '/crm/appointments'
    | '/crm/leads'
    | '/dashboard/ceo'
    | '/doc/$token'
    | '/invite/accept'
    | '/manufacturing/owner-transactions'
    | '/mobile/assistant'
    | '/mobile/business'
    | '/mobile/gold-stock'
    | '/mobile/master'
    | '/mobile/more'
    | '/mobile/reports'
    | '/mobile/stock-entry'
    | '/mobile/sync'
    | '/mobile/transactions'
    | '/mobile/work'
    | '/orders/$id'
    | '/orders/import'
    | '/orders/new'
    | '/people/$id'
    | '/people/import'
    | '/platform/commercial-pricing'
    | '/platform/communication-providers'
    | '/platform/meta-whatsapp'
    | '/platform/plans'
    | '/platform/trials'
    | '/platform/website'
    | '/repair/$id'
    | '/repair/new'
    | '/reports/account-balance'
    | '/reports/approvals'
    | '/reports/audit-log'
    | '/reports/auditor'
    | '/reports/bank-transactions'
    | '/reports/barcode-stock'
    | '/reports/branch'
    | '/reports/bullion-ledger'
    | '/reports/ca-pack'
    | '/reports/cash-flow'
    | '/reports/city-wise'
    | '/reports/communication-analytics'
    | '/reports/customer-statement'
    | '/reports/daily-close'
    | '/reports/daily-gold-flow'
    | '/reports/daily-summary'
    | '/reports/dar-rojmel'
    | '/reports/day-wise'
    | '/reports/dealer'
    | '/reports/deleted-bills'
    | '/reports/delivery-summary'
    | '/reports/dhadi-book'
    | '/reports/discount-report'
    | '/reports/erp-audit'
    | '/reports/exceptions'
    | '/reports/financial-statements'
    | '/reports/fine-margin'
    | '/reports/fine-rojmel'
    | '/reports/gold-ledger'
    | '/reports/gold-loss'
    | '/reports/gold-outstanding'
    | '/reports/gold-position'
    | '/reports/gold-reconciliation'
    | '/reports/gold-stock'
    | '/reports/gold-summary'
    | '/reports/gst-returns'
    | '/reports/hsn-summary'
    | '/reports/inventory-ageing'
    | '/reports/itc04'
    | '/reports/item-jama-nave'
    | '/reports/item-transaction'
    | '/reports/ledgers'
    | '/reports/ledgers-print-all'
    | '/reports/manufacturing'
    | '/reports/manufacturing-reconciliation'
    | '/reports/metal-position'
    | '/reports/month-end-close'
    | '/reports/outside-work'
    | '/reports/owner-drawings'
    | '/reports/purchase-register'
    | '/reports/reconciliation-center'
    | '/reports/reminders'
    | '/reports/sales-register'
    | '/reports/scheme'
    | '/reports/settlement-reconciliation'
    | '/reports/settlements'
    | '/reports/stock-valuation'
    | '/reports/tally-export'
    | '/reports/tanch-hishob'
    | '/reports/total-profit'
    | '/reports/vault-reconciliation'
    | '/reports/worker'
    | '/scheme/accounts'
    | '/scheme/plans'
    | '/scheme/receipts'
    | '/settings/automation'
    | '/settings/backup-recovery'
    | '/settings/branch-settings'
    | '/settings/communications'
    | '/settings/document-vault'
    | '/settings/integrations-hub'
    | '/settings/license'
    | '/settings/print-templates'
    | '/settings/security-center'
    | '/settings/storage-diagnostics'
    | '/settings/support'
    | '/settings/whatsapp'
    | '/settings/whatsapp-templates'
    | '/settings/workflow'
    | '/settlement/$id'
    | '/settlement/new'
    | '/stock/$id'
    | '/stock/boxes'
    | '/stock/entry'
    | '/stock/hallmark'
    | '/stock/import'
    | '/stock/lots'
    | '/stock/stones'
    | '/stock/transfers'
    | '/stock/verification'
    | '/treasury/bank-reconciliation'
    | '/treasury/cash-book'
    | '/treasury/vouchers'
    | '/trial/start'
    | '/ui/catalog'
    | '/unsubscribe/$token'
    | '/utilities/cash-fine-transfer'
    | '/utilities/counter-settings'
    | '/utilities/gst-calculator'
    | '/utilities/item-masters'
    | '/utilities/item-transaction'
    | '/utilities/opening-fine-cash'
    | '/utilities/patla-stock'
    | '/utilities/sauda-book'
    | '/utilities/sub-accounts'
    | '/utilities/urd-purchase'
    | '/utilities/wipeout'
    | '/workshop/$id'
    | '/workshop/barcode-scanner'
    | '/workshop/bench-custody'
    | '/workshop/dhadi-groups'
    | '/workshop/gold-book'
    | '/workshop/jama'
    | '/workshop/jangad'
    | '/workshop/karigar-book'
    | '/workshop/outside-work'
    | '/workshop/outside-worker-books'
    | '/workshop/polishing'
    | '/workshop/polishing-books'
    | '/workshop/reconciliation'
    | '/workshop/vibrator'
    | '/workshop/worker-books'
    | '/accounts/'
    | '/admin/'
    | '/attendance/'
    | '/billing/'
    | '/branches/'
    | '/catalog/'
    | '/communications/'
    | '/conversion/'
    | '/expenses/'
    | '/hardware/'
    | '/manufacturing/'
    | '/melt/'
    | '/mobile/'
    | '/mtg/'
    | '/orders/'
    | '/people/'
    | '/refinery/'
    | '/repair/'
    | '/reports/'
    | '/scheme/'
    | '/settings/'
    | '/stock/'
    | '/utilities/'
    | '/whatsapp/'
    | '/workshop/'
    | '/billing/credit-note-print/$id'
    | '/billing/credit-notes/$id'
    | '/billing/debit-note-print/$id'
    | '/billing/debit-notes/$id'
    | '/billing/delivery-challan-print/$id'
    | '/billing/delivery-challans/$id'
    | '/billing/estimate-print/$id'
    | '/billing/estimate/$id'
    | '/billing/estimates/$id'
    | '/billing/gold-settlement-print/$id'
    | '/billing/print/$id'
    | '/billing/purchases/return'
    | '/billing/receipt/$id'
    | '/billing/settlement-slip/$id'
    | '/conversion/slip/$id'
    | '/crm/360/$id'
    | '/manufacturing/bill/$id'
    | '/people/ledger-print/$id'
    | '/people/print/$id'
    | '/platform/billing-print/$id'
    | '/repair/polishing/new'
    | '/reports/account-balance-print/$variant'
    | '/reports/book-print/$docType'
    | '/reports/dailyclose-print/$id'
    | '/settings/communications/meta-callback'
    | '/settings/integrations/whatsapp'
    | '/settlement/draft-print/$id'
    | '/stock/print/$id'
    | '/verify/invoice/$token'
    | '/workshop/book/$jewellerId'
    | '/workshop/filings-slip/$id'
    | '/workshop/gold-book-print/$workerId'
    | '/workshop/job-card/$orderId'
    | '/workshop/outside-worker-book/$partyId'
    | '/workshop/polishing-book/$partyId'
    | '/workshop/process/$type'
    | '/workshop/receive-slip/$id'
    | '/workshop/worker-book/$workerId'
    | '/billing/credit-notes/'
    | '/billing/debit-notes/'
    | '/billing/delivery-challans/'
    | '/billing/estimates/'
    | '/billing/purchases/'
    | '/attendance/print/$kind/$id'
    | '/manufacturing/bill/new/$jobId'
    | '/orders/print/$kind/$id'
    | '/repair/print/$kind/$id'
    | '/workshop/material-slip/$workerId/$date'
    | '/workshop/print/job-card/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/ai-center'
    | '/app'
    | '/assistant'
    | '/barcode'
    | '/company-admin'
    | '/customer-login'
    | '/customer-portal'
    | '/dashboard'
    | '/forgot-password'
    | '/help'
    | '/invite'
    | '/karigar-login'
    | '/karigar-portal'
    | '/ledger'
    | '/login'
    | '/master'
    | '/notifications'
    | '/onboarding'
    | '/otp-login'
    | '/platform'
    | '/privacy'
    | '/request-access'
    | '/reset-password'
    | '/saas-admin'
    | '/setup'
    | '/signup'
    | '/supplier-login'
    | '/supplier-portal'
    | '/terms'
    | '/transaction-hub'
    | '/transactions'
    | '/verify'
    | '/auth/callback'
    | '/billing/$id'
    | '/billing/credit-note'
    | '/billing/new'
    | '/catalog/$id'
    | '/catalog/designer'
    | '/catalog/masters'
    | '/catalog/templates'
    | '/coming-soon/barcode-printing'
    | '/coming-soon/barcode-scanner'
    | '/coming-soon/meena-book'
    | '/control/accounts'
    | '/control/customization'
    | '/control/migration'
    | '/control/print-profiles'
    | '/control/rates'
    | '/control/shortcuts'
    | '/control/tally-export'
    | '/control/terminology'
    | '/crm/appointments'
    | '/crm/leads'
    | '/dashboard/ceo'
    | '/doc/$token'
    | '/invite/accept'
    | '/manufacturing/owner-transactions'
    | '/mobile/assistant'
    | '/mobile/business'
    | '/mobile/gold-stock'
    | '/mobile/master'
    | '/mobile/more'
    | '/mobile/reports'
    | '/mobile/stock-entry'
    | '/mobile/sync'
    | '/mobile/transactions'
    | '/mobile/work'
    | '/orders/$id'
    | '/orders/import'
    | '/orders/new'
    | '/people/$id'
    | '/people/import'
    | '/platform/commercial-pricing'
    | '/platform/communication-providers'
    | '/platform/meta-whatsapp'
    | '/platform/plans'
    | '/platform/trials'
    | '/platform/website'
    | '/repair/$id'
    | '/repair/new'
    | '/reports/account-balance'
    | '/reports/approvals'
    | '/reports/audit-log'
    | '/reports/auditor'
    | '/reports/bank-transactions'
    | '/reports/barcode-stock'
    | '/reports/branch'
    | '/reports/bullion-ledger'
    | '/reports/ca-pack'
    | '/reports/cash-flow'
    | '/reports/city-wise'
    | '/reports/communication-analytics'
    | '/reports/customer-statement'
    | '/reports/daily-close'
    | '/reports/daily-gold-flow'
    | '/reports/daily-summary'
    | '/reports/dar-rojmel'
    | '/reports/day-wise'
    | '/reports/dealer'
    | '/reports/deleted-bills'
    | '/reports/delivery-summary'
    | '/reports/dhadi-book'
    | '/reports/discount-report'
    | '/reports/erp-audit'
    | '/reports/exceptions'
    | '/reports/financial-statements'
    | '/reports/fine-margin'
    | '/reports/fine-rojmel'
    | '/reports/gold-ledger'
    | '/reports/gold-loss'
    | '/reports/gold-outstanding'
    | '/reports/gold-position'
    | '/reports/gold-reconciliation'
    | '/reports/gold-stock'
    | '/reports/gold-summary'
    | '/reports/gst-returns'
    | '/reports/hsn-summary'
    | '/reports/inventory-ageing'
    | '/reports/itc04'
    | '/reports/item-jama-nave'
    | '/reports/item-transaction'
    | '/reports/ledgers'
    | '/reports/ledgers-print-all'
    | '/reports/manufacturing'
    | '/reports/manufacturing-reconciliation'
    | '/reports/metal-position'
    | '/reports/month-end-close'
    | '/reports/outside-work'
    | '/reports/owner-drawings'
    | '/reports/purchase-register'
    | '/reports/reconciliation-center'
    | '/reports/reminders'
    | '/reports/sales-register'
    | '/reports/scheme'
    | '/reports/settlement-reconciliation'
    | '/reports/settlements'
    | '/reports/stock-valuation'
    | '/reports/tally-export'
    | '/reports/tanch-hishob'
    | '/reports/total-profit'
    | '/reports/vault-reconciliation'
    | '/reports/worker'
    | '/scheme/accounts'
    | '/scheme/plans'
    | '/scheme/receipts'
    | '/settings/automation'
    | '/settings/backup-recovery'
    | '/settings/branch-settings'
    | '/settings/communications'
    | '/settings/document-vault'
    | '/settings/integrations-hub'
    | '/settings/license'
    | '/settings/print-templates'
    | '/settings/security-center'
    | '/settings/storage-diagnostics'
    | '/settings/support'
    | '/settings/whatsapp'
    | '/settings/whatsapp-templates'
    | '/settings/workflow'
    | '/settlement/$id'
    | '/settlement/new'
    | '/stock/$id'
    | '/stock/boxes'
    | '/stock/entry'
    | '/stock/hallmark'
    | '/stock/import'
    | '/stock/lots'
    | '/stock/stones'
    | '/stock/transfers'
    | '/stock/verification'
    | '/treasury/bank-reconciliation'
    | '/treasury/cash-book'
    | '/treasury/vouchers'
    | '/trial/start'
    | '/ui/catalog'
    | '/unsubscribe/$token'
    | '/utilities/cash-fine-transfer'
    | '/utilities/counter-settings'
    | '/utilities/gst-calculator'
    | '/utilities/item-masters'
    | '/utilities/item-transaction'
    | '/utilities/opening-fine-cash'
    | '/utilities/patla-stock'
    | '/utilities/sauda-book'
    | '/utilities/sub-accounts'
    | '/utilities/urd-purchase'
    | '/utilities/wipeout'
    | '/workshop/$id'
    | '/workshop/barcode-scanner'
    | '/workshop/bench-custody'
    | '/workshop/dhadi-groups'
    | '/workshop/gold-book'
    | '/workshop/jama'
    | '/workshop/jangad'
    | '/workshop/karigar-book'
    | '/workshop/outside-work'
    | '/workshop/outside-worker-books'
    | '/workshop/polishing'
    | '/workshop/polishing-books'
    | '/workshop/reconciliation'
    | '/workshop/vibrator'
    | '/workshop/worker-books'
    | '/accounts'
    | '/admin'
    | '/attendance'
    | '/billing'
    | '/branches'
    | '/catalog'
    | '/communications'
    | '/conversion'
    | '/expenses'
    | '/hardware'
    | '/manufacturing'
    | '/melt'
    | '/mobile'
    | '/mtg'
    | '/orders'
    | '/people'
    | '/refinery'
    | '/repair'
    | '/reports'
    | '/scheme'
    | '/settings'
    | '/stock'
    | '/utilities'
    | '/whatsapp'
    | '/workshop'
    | '/billing/credit-note-print/$id'
    | '/billing/credit-notes/$id'
    | '/billing/debit-note-print/$id'
    | '/billing/debit-notes/$id'
    | '/billing/delivery-challan-print/$id'
    | '/billing/delivery-challans/$id'
    | '/billing/estimate-print/$id'
    | '/billing/estimate/$id'
    | '/billing/estimates/$id'
    | '/billing/gold-settlement-print/$id'
    | '/billing/print/$id'
    | '/billing/purchases/return'
    | '/billing/receipt/$id'
    | '/billing/settlement-slip/$id'
    | '/conversion/slip/$id'
    | '/crm/360/$id'
    | '/manufacturing/bill/$id'
    | '/people/ledger-print/$id'
    | '/people/print/$id'
    | '/platform/billing-print/$id'
    | '/repair/polishing/new'
    | '/reports/account-balance-print/$variant'
    | '/reports/book-print/$docType'
    | '/reports/dailyclose-print/$id'
    | '/settings/communications/meta-callback'
    | '/settings/integrations/whatsapp'
    | '/settlement/draft-print/$id'
    | '/stock/print/$id'
    | '/verify/invoice/$token'
    | '/workshop/book/$jewellerId'
    | '/workshop/filings-slip/$id'
    | '/workshop/gold-book-print/$workerId'
    | '/workshop/job-card/$orderId'
    | '/workshop/outside-worker-book/$partyId'
    | '/workshop/polishing-book/$partyId'
    | '/workshop/process/$type'
    | '/workshop/receive-slip/$id'
    | '/workshop/worker-book/$workerId'
    | '/billing/credit-notes'
    | '/billing/debit-notes'
    | '/billing/delivery-challans'
    | '/billing/estimates'
    | '/billing/purchases'
    | '/attendance/print/$kind/$id'
    | '/manufacturing/bill/new/$jobId'
    | '/orders/print/$kind/$id'
    | '/repair/print/$kind/$id'
    | '/workshop/material-slip/$workerId/$date'
    | '/workshop/print/job-card/$orderId'
  id:
    | '__root__'
    | '/'
    | '/accept-invitation'
    | '/admin'
    | '/ai-center'
    | '/app'
    | '/assistant'
    | '/attendance'
    | '/barcode'
    | '/billing'
    | '/catalog'
    | '/communications'
    | '/company-admin'
    | '/customer-login'
    | '/customer-portal'
    | '/dashboard'
    | '/forgot-password'
    | '/help'
    | '/invite'
    | '/karigar-login'
    | '/karigar-portal'
    | '/ledger'
    | '/login'
    | '/manufacturing'
    | '/master'
    | '/melt'
    | '/mtg'
    | '/notifications'
    | '/onboarding'
    | '/orders'
    | '/otp-login'
    | '/platform'
    | '/privacy'
    | '/repair'
    | '/reports'
    | '/request-access'
    | '/reset-password'
    | '/saas-admin'
    | '/scheme'
    | '/settings'
    | '/setup'
    | '/signup'
    | '/stock'
    | '/supplier-login'
    | '/supplier-portal'
    | '/terms'
    | '/transaction-hub'
    | '/transactions'
    | '/utilities'
    | '/verify'
    | '/whatsapp'
    | '/workshop'
    | '/auth/callback'
    | '/billing/$id'
    | '/billing/credit-note'
    | '/billing/new'
    | '/catalog/$id'
    | '/catalog/designer'
    | '/catalog/masters'
    | '/catalog/templates'
    | '/coming-soon/barcode-printing'
    | '/coming-soon/barcode-scanner'
    | '/coming-soon/meena-book'
    | '/control/accounts'
    | '/control/customization'
    | '/control/migration'
    | '/control/print-profiles'
    | '/control/rates'
    | '/control/shortcuts'
    | '/control/tally-export'
    | '/control/terminology'
    | '/crm/appointments'
    | '/crm/leads'
    | '/dashboard/ceo'
    | '/doc/$token'
    | '/invite/accept'
    | '/manufacturing/owner-transactions'
    | '/mobile/assistant'
    | '/mobile/business'
    | '/mobile/gold-stock'
    | '/mobile/master'
    | '/mobile/more'
    | '/mobile/reports'
    | '/mobile/stock-entry'
    | '/mobile/sync'
    | '/mobile/transactions'
    | '/mobile/work'
    | '/orders/$id'
    | '/orders/import'
    | '/orders/new'
    | '/people/$id'
    | '/people/import'
    | '/platform/commercial-pricing'
    | '/platform/communication-providers'
    | '/platform/meta-whatsapp'
    | '/platform/plans'
    | '/platform/trials'
    | '/platform/website'
    | '/repair/$id'
    | '/repair/new'
    | '/reports/account-balance'
    | '/reports/approvals'
    | '/reports/audit-log'
    | '/reports/auditor'
    | '/reports/bank-transactions'
    | '/reports/barcode-stock'
    | '/reports/branch'
    | '/reports/bullion-ledger'
    | '/reports/ca-pack'
    | '/reports/cash-flow'
    | '/reports/city-wise'
    | '/reports/communication-analytics'
    | '/reports/customer-statement'
    | '/reports/daily-close'
    | '/reports/daily-gold-flow'
    | '/reports/daily-summary'
    | '/reports/dar-rojmel'
    | '/reports/day-wise'
    | '/reports/dealer'
    | '/reports/deleted-bills'
    | '/reports/delivery-summary'
    | '/reports/dhadi-book'
    | '/reports/discount-report'
    | '/reports/erp-audit'
    | '/reports/exceptions'
    | '/reports/financial-statements'
    | '/reports/fine-margin'
    | '/reports/fine-rojmel'
    | '/reports/gold-ledger'
    | '/reports/gold-loss'
    | '/reports/gold-outstanding'
    | '/reports/gold-position'
    | '/reports/gold-reconciliation'
    | '/reports/gold-stock'
    | '/reports/gold-summary'
    | '/reports/gst-returns'
    | '/reports/hsn-summary'
    | '/reports/inventory-ageing'
    | '/reports/itc04'
    | '/reports/item-jama-nave'
    | '/reports/item-transaction'
    | '/reports/ledgers'
    | '/reports/ledgers-print-all'
    | '/reports/manufacturing'
    | '/reports/manufacturing-reconciliation'
    | '/reports/metal-position'
    | '/reports/month-end-close'
    | '/reports/outside-work'
    | '/reports/owner-drawings'
    | '/reports/purchase-register'
    | '/reports/reconciliation-center'
    | '/reports/reminders'
    | '/reports/sales-register'
    | '/reports/scheme'
    | '/reports/settlement-reconciliation'
    | '/reports/settlements'
    | '/reports/stock-valuation'
    | '/reports/tally-export'
    | '/reports/tanch-hishob'
    | '/reports/total-profit'
    | '/reports/vault-reconciliation'
    | '/reports/worker'
    | '/scheme/accounts'
    | '/scheme/plans'
    | '/scheme/receipts'
    | '/settings/automation'
    | '/settings/backup-recovery'
    | '/settings/branch-settings'
    | '/settings/communications'
    | '/settings/document-vault'
    | '/settings/integrations-hub'
    | '/settings/license'
    | '/settings/print-templates'
    | '/settings/security-center'
    | '/settings/storage-diagnostics'
    | '/settings/support'
    | '/settings/whatsapp'
    | '/settings/whatsapp-templates'
    | '/settings/workflow'
    | '/settlement/$id'
    | '/settlement/new'
    | '/stock/$id'
    | '/stock/boxes'
    | '/stock/entry'
    | '/stock/hallmark'
    | '/stock/import'
    | '/stock/lots'
    | '/stock/stones'
    | '/stock/transfers'
    | '/stock/verification'
    | '/treasury/bank-reconciliation'
    | '/treasury/cash-book'
    | '/treasury/vouchers'
    | '/trial/start'
    | '/ui/catalog'
    | '/unsubscribe/$token'
    | '/utilities/cash-fine-transfer'
    | '/utilities/counter-settings'
    | '/utilities/gst-calculator'
    | '/utilities/item-masters'
    | '/utilities/item-transaction'
    | '/utilities/opening-fine-cash'
    | '/utilities/patla-stock'
    | '/utilities/sauda-book'
    | '/utilities/sub-accounts'
    | '/utilities/urd-purchase'
    | '/utilities/wipeout'
    | '/workshop/$id'
    | '/workshop/barcode-scanner'
    | '/workshop/bench-custody'
    | '/workshop/dhadi-groups'
    | '/workshop/gold-book'
    | '/workshop/jama'
    | '/workshop/jangad'
    | '/workshop/karigar-book'
    | '/workshop/outside-work'
    | '/workshop/outside-worker-books'
    | '/workshop/polishing'
    | '/workshop/polishing-books'
    | '/workshop/reconciliation'
    | '/workshop/vibrator'
    | '/workshop/worker-books'
    | '/accounts/'
    | '/admin/'
    | '/attendance/'
    | '/billing/'
    | '/branches/'
    | '/catalog/'
    | '/communications/'
    | '/conversion/'
    | '/expenses/'
    | '/hardware/'
    | '/manufacturing/'
    | '/melt/'
    | '/mobile/'
    | '/mtg/'
    | '/orders/'
    | '/people/'
    | '/refinery/'
    | '/repair/'
    | '/reports/'
    | '/scheme/'
    | '/settings/'
    | '/stock/'
    | '/utilities/'
    | '/whatsapp/'
    | '/workshop/'
    | '/billing/credit-note-print/$id'
    | '/billing/credit-notes/$id'
    | '/billing/debit-note-print/$id'
    | '/billing/debit-notes/$id'
    | '/billing/delivery-challan-print/$id'
    | '/billing/delivery-challans/$id'
    | '/billing/estimate-print/$id'
    | '/billing/estimate/$id'
    | '/billing/estimates/$id'
    | '/billing/gold-settlement-print/$id'
    | '/billing/print/$id'
    | '/billing/purchases/return'
    | '/billing/receipt/$id'
    | '/billing/settlement-slip/$id'
    | '/conversion/slip/$id'
    | '/crm/360/$id'
    | '/manufacturing/bill/$id'
    | '/people/ledger-print/$id'
    | '/people/print/$id'
    | '/platform/billing-print/$id'
    | '/repair/polishing/new'
    | '/reports/account-balance-print/$variant'
    | '/reports/book-print/$docType'
    | '/reports/dailyclose-print/$id'
    | '/settings/communications/meta-callback'
    | '/settings/integrations/whatsapp'
    | '/settlement/draft-print/$id'
    | '/stock/print/$id'
    | '/verify/invoice/$token'
    | '/workshop/book/$jewellerId'
    | '/workshop/filings-slip/$id'
    | '/workshop/gold-book-print/$workerId'
    | '/workshop/job-card/$orderId'
    | '/workshop/outside-worker-book/$partyId'
    | '/workshop/polishing-book/$partyId'
    | '/workshop/process/$type'
    | '/workshop/receive-slip/$id'
    | '/workshop/worker-book/$workerId'
    | '/billing/credit-notes/'
    | '/billing/debit-notes/'
    | '/billing/delivery-challans/'
    | '/billing/estimates/'
    | '/billing/purchases/'
    | '/attendance/print/$kind/$id'
    | '/manufacturing/bill/new/$jobId'
    | '/orders/print/$kind/$id'
    | '/repair/print/$kind/$id'
    | '/workshop/material-slip/$workerId/$date'
    | '/workshop/print/job-card/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  AdminRoute: typeof AdminRouteWithChildren
  AiCenterRoute: typeof AiCenterRoute
  AppRoute: typeof AppRoute
  AssistantRoute: typeof AssistantRoute
  AttendanceRoute: typeof AttendanceRouteWithChildren
  BarcodeRoute: typeof BarcodeRoute
  BillingRoute: typeof BillingRouteWithChildren
  CatalogRoute: typeof CatalogRouteWithChildren
  CommunicationsRoute: typeof CommunicationsRouteWithChildren
  CompanyAdminRoute: typeof CompanyAdminRoute
  CustomerLoginRoute: typeof CustomerLoginRoute
  CustomerPortalRoute: typeof CustomerPortalRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HelpRoute: typeof HelpRoute
  InviteRoute: typeof InviteRouteWithChildren
  KarigarLoginRoute: typeof KarigarLoginRoute
  KarigarPortalRoute: typeof KarigarPortalRoute
  LedgerRoute: typeof LedgerRoute
  LoginRoute: typeof LoginRoute
  ManufacturingRoute: typeof ManufacturingRouteWithChildren
  MasterRoute: typeof MasterRoute
  MeltRoute: typeof MeltRouteWithChildren
  MtgRoute: typeof MtgRouteWithChildren
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  OtpLoginRoute: typeof OtpLoginRoute
  PlatformRoute: typeof PlatformRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  RepairRoute: typeof RepairRouteWithChildren
  ReportsRoute: typeof ReportsRouteWithChildren
  RequestAccessRoute: typeof RequestAccessRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SaasAdminRoute: typeof SaasAdminRoute
  SchemeRoute: typeof SchemeRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  SetupRoute: typeof SetupRoute
  SignupRoute: typeof SignupRoute
  StockRoute: typeof StockRouteWithChildren
  SupplierLoginRoute: typeof SupplierLoginRoute
  SupplierPortalRoute: typeof SupplierPortalRoute
  TermsRoute: typeof TermsRoute
  TransactionHubRoute: typeof TransactionHubRoute
  TransactionsRoute: typeof TransactionsRoute
  UtilitiesRoute: typeof UtilitiesRouteWithChildren
  VerifyRoute: typeof VerifyRouteWithChildren
  WhatsappRoute: typeof WhatsappRouteWithChildren
  WorkshopRoute: typeof WorkshopRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  ComingSoonBarcodePrintingRoute: typeof ComingSoonBarcodePrintingRoute
  ComingSoonBarcodeScannerRoute: typeof ComingSoonBarcodeScannerRoute
  ComingSoonMeenaBookRoute: typeof ComingSoonMeenaBookRoute
  ControlAccountsRoute: typeof ControlAccountsRoute
  ControlCustomizationRoute: typeof ControlCustomizationRoute
  ControlMigrationRoute: typeof ControlMigrationRoute
  ControlPrintProfilesRoute: typeof ControlPrintProfilesRoute
  ControlRatesRoute: typeof ControlRatesRoute
  ControlShortcutsRoute: typeof ControlShortcutsRoute
  ControlTallyExportRoute: typeof ControlTallyExportRoute
  ControlTerminologyRoute: typeof ControlTerminologyRoute
  CrmAppointmentsRoute: typeof CrmAppointmentsRoute
  CrmLeadsRoute: typeof CrmLeadsRoute
  DocTokenRoute: typeof DocTokenRoute
  MobileAssistantRoute: typeof MobileAssistantRoute
  MobileBusinessRoute: typeof MobileBusinessRoute
  MobileGoldStockRoute: typeof MobileGoldStockRoute
  MobileMasterRoute: typeof MobileMasterRoute
  MobileMoreRoute: typeof MobileMoreRoute
  MobileReportsRoute: typeof MobileReportsRoute
  MobileStockEntryRoute: typeof MobileStockEntryRoute
  MobileSyncRoute: typeof MobileSyncRoute
  MobileTransactionsRoute: typeof MobileTransactionsRoute
  MobileWorkRoute: typeof MobileWorkRoute
  PeopleIdRoute: typeof PeopleIdRoute
  PeopleImportRoute: typeof PeopleImportRoute
  SettlementIdRoute: typeof SettlementIdRoute
  SettlementNewRoute: typeof SettlementNewRoute
  TreasuryBankReconciliationRoute: typeof TreasuryBankReconciliationRoute
  TreasuryCashBookRoute: typeof TreasuryCashBookRoute
  TreasuryVouchersRoute: typeof TreasuryVouchersRoute
  TrialStartRoute: typeof TrialStartRoute
  UiCatalogRoute: typeof UiCatalogRoute
  UnsubscribeTokenRoute: typeof UnsubscribeTokenRoute
  AccountsIndexRoute: typeof AccountsIndexRoute
  BranchesIndexRoute: typeof BranchesIndexRoute
  ConversionIndexRoute: typeof ConversionIndexRoute
  ExpensesIndexRoute: typeof ExpensesIndexRoute
  HardwareIndexRoute: typeof HardwareIndexRoute
  MobileIndexRoute: typeof MobileIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  RefineryIndexRoute: typeof RefineryIndexRoute
  ConversionSlipIdRoute: typeof ConversionSlipIdRoute
  Crm360IdRoute: typeof Crm360IdRoute
  PeopleLedgerPrintIdRoute: typeof PeopleLedgerPrintIdRoute
  PeoplePrintIdRoute: typeof PeoplePrintIdRoute
  SettlementDraftPrintIdRoute: typeof SettlementDraftPrintIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workshop': {
      id: '/workshop'
      path: '/workshop'
      fullPath: '/workshop'
      preLoaderRoute: typeof WorkshopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/whatsapp': {
      id: '/whatsapp'
      path: '/whatsapp'
      fullPath: '/whatsapp'
      preLoaderRoute: typeof WhatsappRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/utilities': {
      id: '/utilities'
      path: '/utilities'
      fullPath: '/utilities'
      preLoaderRoute: typeof UtilitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-hub': {
      id: '/transaction-hub'
      path: '/transaction-hub'
      fullPath: '/transaction-hub'
      preLoaderRoute: typeof TransactionHubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supplier-portal': {
      id: '/supplier-portal'
      path: '/supplier-portal'
      fullPath: '/supplier-portal'
      preLoaderRoute: typeof SupplierPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supplier-login': {
      id: '/supplier-login'
      path: '/supplier-login'
      fullPath: '/supplier-login'
      preLoaderRoute: typeof SupplierLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stock': {
      id: '/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof StockRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheme': {
      id: '/scheme'
      path: '/scheme'
      fullPath: '/scheme'
      preLoaderRoute: typeof SchemeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/saas-admin': {
      id: '/saas-admin'
      path: '/saas-admin'
      fullPath: '/saas-admin'
      preLoaderRoute: typeof SaasAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-access': {
      id: '/request-access'
      path: '/request-access'
      fullPath: '/request-access'
      preLoaderRoute: typeof RequestAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/repair': {
      id: '/repair'
      path: '/repair'
      fullPath: '/repair'
      preLoaderRoute: typeof RepairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp-login': {
      id: '/otp-login'
      path: '/otp-login'
      fullPath: '/otp-login'
      preLoaderRoute: typeof OtpLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mtg': {
      id: '/mtg'
      path: '/mtg'
      fullPath: '/mtg'
      preLoaderRoute: typeof MtgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/melt': {
      id: '/melt'
      path: '/melt'
      fullPath: '/melt'
      preLoaderRoute: typeof MeltRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master': {
      id: '/master'
      path: '/master'
      fullPath: '/master'
      preLoaderRoute: typeof MasterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manufacturing': {
      id: '/manufacturing'
      path: '/manufacturing'
      fullPath: '/manufacturing'
      preLoaderRoute: typeof ManufacturingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ledger': {
      id: '/ledger'
      path: '/ledger'
      fullPath: '/ledger'
      preLoaderRoute: typeof LedgerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/karigar-portal': {
      id: '/karigar-portal'
      path: '/karigar-portal'
      fullPath: '/karigar-portal'
      preLoaderRoute: typeof KarigarPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/karigar-login': {
      id: '/karigar-login'
      path: '/karigar-login'
      fullPath: '/karigar-login'
      preLoaderRoute: typeof KarigarLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-portal': {
      id: '/customer-portal'
      path: '/customer-portal'
      fullPath: '/customer-portal'
      preLoaderRoute: typeof CustomerPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-login': {
      id: '/customer-login'
      path: '/customer-login'
      fullPath: '/customer-login'
      preLoaderRoute: typeof CustomerLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company-admin': {
      id: '/company-admin'
      path: '/company-admin'
      fullPath: '/company-admin'
      preLoaderRoute: typeof CompanyAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications': {
      id: '/communications'
      path: '/communications'
      fullPath: '/communications'
      preLoaderRoute: typeof CommunicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/barcode': {
      id: '/barcode'
      path: '/barcode'
      fullPath: '/barcode'
      preLoaderRoute: typeof BarcodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attendance': {
      id: '/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AttendanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant': {
      id: '/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-center': {
      id: '/ai-center'
      path: '/ai-center'
      fullPath: '/ai-center'
      preLoaderRoute: typeof AiCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workshop/': {
      id: '/workshop/'
      path: '/'
      fullPath: '/workshop/'
      preLoaderRoute: typeof WorkshopIndexRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/whatsapp/': {
      id: '/whatsapp/'
      path: '/'
      fullPath: '/whatsapp/'
      preLoaderRoute: typeof WhatsappIndexRouteImport
      parentRoute: typeof WhatsappRoute
    }
    '/utilities/': {
      id: '/utilities/'
      path: '/'
      fullPath: '/utilities/'
      preLoaderRoute: typeof UtilitiesIndexRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/stock/': {
      id: '/stock/'
      path: '/'
      fullPath: '/stock/'
      preLoaderRoute: typeof StockIndexRouteImport
      parentRoute: typeof StockRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/scheme/': {
      id: '/scheme/'
      path: '/'
      fullPath: '/scheme/'
      preLoaderRoute: typeof SchemeIndexRouteImport
      parentRoute: typeof SchemeRoute
    }
    '/reports/': {
      id: '/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/repair/': {
      id: '/repair/'
      path: '/'
      fullPath: '/repair/'
      preLoaderRoute: typeof RepairIndexRouteImport
      parentRoute: typeof RepairRoute
    }
    '/refinery/': {
      id: '/refinery/'
      path: '/refinery'
      fullPath: '/refinery/'
      preLoaderRoute: typeof RefineryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/mtg/': {
      id: '/mtg/'
      path: '/'
      fullPath: '/mtg/'
      preLoaderRoute: typeof MtgIndexRouteImport
      parentRoute: typeof MtgRoute
    }
    '/mobile/': {
      id: '/mobile/'
      path: '/mobile'
      fullPath: '/mobile/'
      preLoaderRoute: typeof MobileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/melt/': {
      id: '/melt/'
      path: '/'
      fullPath: '/melt/'
      preLoaderRoute: typeof MeltIndexRouteImport
      parentRoute: typeof MeltRoute
    }
    '/manufacturing/': {
      id: '/manufacturing/'
      path: '/'
      fullPath: '/manufacturing/'
      preLoaderRoute: typeof ManufacturingIndexRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/hardware/': {
      id: '/hardware/'
      path: '/hardware'
      fullPath: '/hardware/'
      preLoaderRoute: typeof HardwareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/': {
      id: '/expenses/'
      path: '/expenses'
      fullPath: '/expenses/'
      preLoaderRoute: typeof ExpensesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversion/': {
      id: '/conversion/'
      path: '/conversion'
      fullPath: '/conversion/'
      preLoaderRoute: typeof ConversionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/': {
      id: '/communications/'
      path: '/'
      fullPath: '/communications/'
      preLoaderRoute: typeof CommunicationsIndexRouteImport
      parentRoute: typeof CommunicationsRoute
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/branches/': {
      id: '/branches/'
      path: '/branches'
      fullPath: '/branches/'
      preLoaderRoute: typeof BranchesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/': {
      id: '/billing/'
      path: '/'
      fullPath: '/billing/'
      preLoaderRoute: typeof BillingIndexRouteImport
      parentRoute: typeof BillingRoute
    }
    '/attendance/': {
      id: '/attendance/'
      path: '/'
      fullPath: '/attendance/'
      preLoaderRoute: typeof AttendanceIndexRouteImport
      parentRoute: typeof AttendanceRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/accounts/': {
      id: '/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workshop/worker-books': {
      id: '/workshop/worker-books'
      path: '/worker-books'
      fullPath: '/workshop/worker-books'
      preLoaderRoute: typeof WorkshopWorkerBooksRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/vibrator': {
      id: '/workshop/vibrator'
      path: '/vibrator'
      fullPath: '/workshop/vibrator'
      preLoaderRoute: typeof WorkshopVibratorRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/reconciliation': {
      id: '/workshop/reconciliation'
      path: '/reconciliation'
      fullPath: '/workshop/reconciliation'
      preLoaderRoute: typeof WorkshopReconciliationRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/polishing-books': {
      id: '/workshop/polishing-books'
      path: '/polishing-books'
      fullPath: '/workshop/polishing-books'
      preLoaderRoute: typeof WorkshopPolishingBooksRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/polishing': {
      id: '/workshop/polishing'
      path: '/polishing'
      fullPath: '/workshop/polishing'
      preLoaderRoute: typeof WorkshopPolishingRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/outside-worker-books': {
      id: '/workshop/outside-worker-books'
      path: '/outside-worker-books'
      fullPath: '/workshop/outside-worker-books'
      preLoaderRoute: typeof WorkshopOutsideWorkerBooksRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/outside-work': {
      id: '/workshop/outside-work'
      path: '/outside-work'
      fullPath: '/workshop/outside-work'
      preLoaderRoute: typeof WorkshopOutsideWorkRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/karigar-book': {
      id: '/workshop/karigar-book'
      path: '/karigar-book'
      fullPath: '/workshop/karigar-book'
      preLoaderRoute: typeof WorkshopKarigarBookRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/jangad': {
      id: '/workshop/jangad'
      path: '/jangad'
      fullPath: '/workshop/jangad'
      preLoaderRoute: typeof WorkshopJangadRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/jama': {
      id: '/workshop/jama'
      path: '/jama'
      fullPath: '/workshop/jama'
      preLoaderRoute: typeof WorkshopJamaRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/gold-book': {
      id: '/workshop/gold-book'
      path: '/gold-book'
      fullPath: '/workshop/gold-book'
      preLoaderRoute: typeof WorkshopGoldBookRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/dhadi-groups': {
      id: '/workshop/dhadi-groups'
      path: '/dhadi-groups'
      fullPath: '/workshop/dhadi-groups'
      preLoaderRoute: typeof WorkshopDhadiGroupsRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/bench-custody': {
      id: '/workshop/bench-custody'
      path: '/bench-custody'
      fullPath: '/workshop/bench-custody'
      preLoaderRoute: typeof WorkshopBenchCustodyRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/barcode-scanner': {
      id: '/workshop/barcode-scanner'
      path: '/barcode-scanner'
      fullPath: '/workshop/barcode-scanner'
      preLoaderRoute: typeof WorkshopBarcodeScannerRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/$id': {
      id: '/workshop/$id'
      path: '/$id'
      fullPath: '/workshop/$id'
      preLoaderRoute: typeof WorkshopIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/utilities/wipeout': {
      id: '/utilities/wipeout'
      path: '/wipeout'
      fullPath: '/utilities/wipeout'
      preLoaderRoute: typeof UtilitiesWipeoutRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/urd-purchase': {
      id: '/utilities/urd-purchase'
      path: '/urd-purchase'
      fullPath: '/utilities/urd-purchase'
      preLoaderRoute: typeof UtilitiesUrdPurchaseRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/sub-accounts': {
      id: '/utilities/sub-accounts'
      path: '/sub-accounts'
      fullPath: '/utilities/sub-accounts'
      preLoaderRoute: typeof UtilitiesSubAccountsRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/sauda-book': {
      id: '/utilities/sauda-book'
      path: '/sauda-book'
      fullPath: '/utilities/sauda-book'
      preLoaderRoute: typeof UtilitiesSaudaBookRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/patla-stock': {
      id: '/utilities/patla-stock'
      path: '/patla-stock'
      fullPath: '/utilities/patla-stock'
      preLoaderRoute: typeof UtilitiesPatlaStockRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/opening-fine-cash': {
      id: '/utilities/opening-fine-cash'
      path: '/opening-fine-cash'
      fullPath: '/utilities/opening-fine-cash'
      preLoaderRoute: typeof UtilitiesOpeningFineCashRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/item-transaction': {
      id: '/utilities/item-transaction'
      path: '/item-transaction'
      fullPath: '/utilities/item-transaction'
      preLoaderRoute: typeof UtilitiesItemTransactionRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/item-masters': {
      id: '/utilities/item-masters'
      path: '/item-masters'
      fullPath: '/utilities/item-masters'
      preLoaderRoute: typeof UtilitiesItemMastersRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/gst-calculator': {
      id: '/utilities/gst-calculator'
      path: '/gst-calculator'
      fullPath: '/utilities/gst-calculator'
      preLoaderRoute: typeof UtilitiesGstCalculatorRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/counter-settings': {
      id: '/utilities/counter-settings'
      path: '/counter-settings'
      fullPath: '/utilities/counter-settings'
      preLoaderRoute: typeof UtilitiesCounterSettingsRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/utilities/cash-fine-transfer': {
      id: '/utilities/cash-fine-transfer'
      path: '/cash-fine-transfer'
      fullPath: '/utilities/cash-fine-transfer'
      preLoaderRoute: typeof UtilitiesCashFineTransferRouteImport
      parentRoute: typeof UtilitiesRoute
    }
    '/unsubscribe/$token': {
      id: '/unsubscribe/$token'
      path: '/unsubscribe/$token'
      fullPath: '/unsubscribe/$token'
      preLoaderRoute: typeof UnsubscribeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui/catalog': {
      id: '/ui/catalog'
      path: '/ui/catalog'
      fullPath: '/ui/catalog'
      preLoaderRoute: typeof UiCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trial/start': {
      id: '/trial/start'
      path: '/trial/start'
      fullPath: '/trial/start'
      preLoaderRoute: typeof TrialStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treasury/vouchers': {
      id: '/treasury/vouchers'
      path: '/treasury/vouchers'
      fullPath: '/treasury/vouchers'
      preLoaderRoute: typeof TreasuryVouchersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treasury/cash-book': {
      id: '/treasury/cash-book'
      path: '/treasury/cash-book'
      fullPath: '/treasury/cash-book'
      preLoaderRoute: typeof TreasuryCashBookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treasury/bank-reconciliation': {
      id: '/treasury/bank-reconciliation'
      path: '/treasury/bank-reconciliation'
      fullPath: '/treasury/bank-reconciliation'
      preLoaderRoute: typeof TreasuryBankReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stock/verification': {
      id: '/stock/verification'
      path: '/verification'
      fullPath: '/stock/verification'
      preLoaderRoute: typeof StockVerificationRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/transfers': {
      id: '/stock/transfers'
      path: '/transfers'
      fullPath: '/stock/transfers'
      preLoaderRoute: typeof StockTransfersRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/stones': {
      id: '/stock/stones'
      path: '/stones'
      fullPath: '/stock/stones'
      preLoaderRoute: typeof StockStonesRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/lots': {
      id: '/stock/lots'
      path: '/lots'
      fullPath: '/stock/lots'
      preLoaderRoute: typeof StockLotsRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/import': {
      id: '/stock/import'
      path: '/import'
      fullPath: '/stock/import'
      preLoaderRoute: typeof StockImportRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/hallmark': {
      id: '/stock/hallmark'
      path: '/hallmark'
      fullPath: '/stock/hallmark'
      preLoaderRoute: typeof StockHallmarkRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/entry': {
      id: '/stock/entry'
      path: '/entry'
      fullPath: '/stock/entry'
      preLoaderRoute: typeof StockEntryRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/boxes': {
      id: '/stock/boxes'
      path: '/boxes'
      fullPath: '/stock/boxes'
      preLoaderRoute: typeof StockBoxesRouteImport
      parentRoute: typeof StockRoute
    }
    '/stock/$id': {
      id: '/stock/$id'
      path: '/$id'
      fullPath: '/stock/$id'
      preLoaderRoute: typeof StockIdRouteImport
      parentRoute: typeof StockRoute
    }
    '/settlement/new': {
      id: '/settlement/new'
      path: '/settlement/new'
      fullPath: '/settlement/new'
      preLoaderRoute: typeof SettlementNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settlement/$id': {
      id: '/settlement/$id'
      path: '/settlement/$id'
      fullPath: '/settlement/$id'
      preLoaderRoute: typeof SettlementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/workflow': {
      id: '/settings/workflow'
      path: '/workflow'
      fullPath: '/settings/workflow'
      preLoaderRoute: typeof SettingsWorkflowRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/whatsapp-templates': {
      id: '/settings/whatsapp-templates'
      path: '/whatsapp-templates'
      fullPath: '/settings/whatsapp-templates'
      preLoaderRoute: typeof SettingsWhatsappTemplatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/whatsapp': {
      id: '/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/settings/whatsapp'
      preLoaderRoute: typeof SettingsWhatsappRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/support': {
      id: '/settings/support'
      path: '/support'
      fullPath: '/settings/support'
      preLoaderRoute: typeof SettingsSupportRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/storage-diagnostics': {
      id: '/settings/storage-diagnostics'
      path: '/storage-diagnostics'
      fullPath: '/settings/storage-diagnostics'
      preLoaderRoute: typeof SettingsStorageDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/security-center': {
      id: '/settings/security-center'
      path: '/security-center'
      fullPath: '/settings/security-center'
      preLoaderRoute: typeof SettingsSecurityCenterRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/print-templates': {
      id: '/settings/print-templates'
      path: '/print-templates'
      fullPath: '/settings/print-templates'
      preLoaderRoute: typeof SettingsPrintTemplatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/license': {
      id: '/settings/license'
      path: '/license'
      fullPath: '/settings/license'
      preLoaderRoute: typeof SettingsLicenseRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/integrations-hub': {
      id: '/settings/integrations-hub'
      path: '/integrations-hub'
      fullPath: '/settings/integrations-hub'
      preLoaderRoute: typeof SettingsIntegrationsHubRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/document-vault': {
      id: '/settings/document-vault'
      path: '/document-vault'
      fullPath: '/settings/document-vault'
      preLoaderRoute: typeof SettingsDocumentVaultRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/communications': {
      id: '/settings/communications'
      path: '/communications'
      fullPath: '/settings/communications'
      preLoaderRoute: typeof SettingsCommunicationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/branch-settings': {
      id: '/settings/branch-settings'
      path: '/branch-settings'
      fullPath: '/settings/branch-settings'
      preLoaderRoute: typeof SettingsBranchSettingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/backup-recovery': {
      id: '/settings/backup-recovery'
      path: '/backup-recovery'
      fullPath: '/settings/backup-recovery'
      preLoaderRoute: typeof SettingsBackupRecoveryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/automation': {
      id: '/settings/automation'
      path: '/automation'
      fullPath: '/settings/automation'
      preLoaderRoute: typeof SettingsAutomationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/scheme/receipts': {
      id: '/scheme/receipts'
      path: '/receipts'
      fullPath: '/scheme/receipts'
      preLoaderRoute: typeof SchemeReceiptsRouteImport
      parentRoute: typeof SchemeRoute
    }
    '/scheme/plans': {
      id: '/scheme/plans'
      path: '/plans'
      fullPath: '/scheme/plans'
      preLoaderRoute: typeof SchemePlansRouteImport
      parentRoute: typeof SchemeRoute
    }
    '/scheme/accounts': {
      id: '/scheme/accounts'
      path: '/accounts'
      fullPath: '/scheme/accounts'
      preLoaderRoute: typeof SchemeAccountsRouteImport
      parentRoute: typeof SchemeRoute
    }
    '/reports/worker': {
      id: '/reports/worker'
      path: '/worker'
      fullPath: '/reports/worker'
      preLoaderRoute: typeof ReportsWorkerRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/vault-reconciliation': {
      id: '/reports/vault-reconciliation'
      path: '/vault-reconciliation'
      fullPath: '/reports/vault-reconciliation'
      preLoaderRoute: typeof ReportsVaultReconciliationRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/total-profit': {
      id: '/reports/total-profit'
      path: '/total-profit'
      fullPath: '/reports/total-profit'
      preLoaderRoute: typeof ReportsTotalProfitRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/tanch-hishob': {
      id: '/reports/tanch-hishob'
      path: '/tanch-hishob'
      fullPath: '/reports/tanch-hishob'
      preLoaderRoute: typeof ReportsTanchHishobRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/tally-export': {
      id: '/reports/tally-export'
      path: '/tally-export'
      fullPath: '/reports/tally-export'
      preLoaderRoute: typeof ReportsTallyExportRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/stock-valuation': {
      id: '/reports/stock-valuation'
      path: '/stock-valuation'
      fullPath: '/reports/stock-valuation'
      preLoaderRoute: typeof ReportsStockValuationRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/settlements': {
      id: '/reports/settlements'
      path: '/settlements'
      fullPath: '/reports/settlements'
      preLoaderRoute: typeof ReportsSettlementsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/settlement-reconciliation': {
      id: '/reports/settlement-reconciliation'
      path: '/settlement-reconciliation'
      fullPath: '/reports/settlement-reconciliation'
      preLoaderRoute: typeof ReportsSettlementReconciliationRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/scheme': {
      id: '/reports/scheme'
      path: '/scheme'
      fullPath: '/reports/scheme'
      preLoaderRoute: typeof ReportsSchemeRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/sales-register': {
      id: '/reports/sales-register'
      path: '/sales-register'
      fullPath: '/reports/sales-register'
      preLoaderRoute: typeof ReportsSalesRegisterRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/reminders': {
      id: '/reports/reminders'
      path: '/reminders'
      fullPath: '/reports/reminders'
      preLoaderRoute: typeof ReportsRemindersRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/reconciliation-center': {
      id: '/reports/reconciliation-center'
      path: '/reconciliation-center'
      fullPath: '/reports/reconciliation-center'
      preLoaderRoute: typeof ReportsReconciliationCenterRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/purchase-register': {
      id: '/reports/purchase-register'
      path: '/purchase-register'
      fullPath: '/reports/purchase-register'
      preLoaderRoute: typeof ReportsPurchaseRegisterRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/owner-drawings': {
      id: '/reports/owner-drawings'
      path: '/owner-drawings'
      fullPath: '/reports/owner-drawings'
      preLoaderRoute: typeof ReportsOwnerDrawingsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/outside-work': {
      id: '/reports/outside-work'
      path: '/outside-work'
      fullPath: '/reports/outside-work'
      preLoaderRoute: typeof ReportsOutsideWorkRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/month-end-close': {
      id: '/reports/month-end-close'
      path: '/month-end-close'
      fullPath: '/reports/month-end-close'
      preLoaderRoute: typeof ReportsMonthEndCloseRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/metal-position': {
      id: '/reports/metal-position'
      path: '/metal-position'
      fullPath: '/reports/metal-position'
      preLoaderRoute: typeof ReportsMetalPositionRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/manufacturing-reconciliation': {
      id: '/reports/manufacturing-reconciliation'
      path: '/manufacturing-reconciliation'
      fullPath: '/reports/manufacturing-reconciliation'
      preLoaderRoute: typeof ReportsManufacturingReconciliationRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/manufacturing': {
      id: '/reports/manufacturing'
      path: '/manufacturing'
      fullPath: '/reports/manufacturing'
      preLoaderRoute: typeof ReportsManufacturingRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/ledgers-print-all': {
      id: '/reports/ledgers-print-all'
      path: '/ledgers-print-all'
      fullPath: '/reports/ledgers-print-all'
      preLoaderRoute: typeof ReportsLedgersPrintAllRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/ledgers': {
      id: '/reports/ledgers'
      path: '/ledgers'
      fullPath: '/reports/ledgers'
      preLoaderRoute: typeof ReportsLedgersRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/item-transaction': {
      id: '/reports/item-transaction'
      path: '/item-transaction'
      fullPath: '/reports/item-transaction'
      preLoaderRoute: typeof ReportsItemTransactionRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/item-jama-nave': {
      id: '/reports/item-jama-nave'
      path: '/item-jama-nave'
      fullPath: '/reports/item-jama-nave'
      preLoaderRoute: typeof ReportsItemJamaNaveRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/itc04': {
      id: '/reports/itc04'
      path: '/itc04'
      fullPath: '/reports/itc04'
      preLoaderRoute: typeof ReportsItc04RouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/inventory-ageing': {
      id: '/reports/inventory-ageing'
      path: '/inventory-ageing'
      fullPath: '/reports/inventory-ageing'
      preLoaderRoute: typeof ReportsInventoryAgeingRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/hsn-summary': {
      id: '/reports/hsn-summary'
      path: '/hsn-summary'
      fullPath: '/reports/hsn-summary'
      preLoaderRoute: typeof ReportsHsnSummaryRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gst-returns': {
      id: '/reports/gst-returns'
      path: '/gst-returns'
      fullPath: '/reports/gst-returns'
      preLoaderRoute: typeof ReportsGstReturnsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-summary': {
      id: '/reports/gold-summary'
      path: '/gold-summary'
      fullPath: '/reports/gold-summary'
      preLoaderRoute: typeof ReportsGoldSummaryRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-stock': {
      id: '/reports/gold-stock'
      path: '/gold-stock'
      fullPath: '/reports/gold-stock'
      preLoaderRoute: typeof ReportsGoldStockRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-reconciliation': {
      id: '/reports/gold-reconciliation'
      path: '/gold-reconciliation'
      fullPath: '/reports/gold-reconciliation'
      preLoaderRoute: typeof ReportsGoldReconciliationRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-position': {
      id: '/reports/gold-position'
      path: '/gold-position'
      fullPath: '/reports/gold-position'
      preLoaderRoute: typeof ReportsGoldPositionRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-outstanding': {
      id: '/reports/gold-outstanding'
      path: '/gold-outstanding'
      fullPath: '/reports/gold-outstanding'
      preLoaderRoute: typeof ReportsGoldOutstandingRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-loss': {
      id: '/reports/gold-loss'
      path: '/gold-loss'
      fullPath: '/reports/gold-loss'
      preLoaderRoute: typeof ReportsGoldLossRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/gold-ledger': {
      id: '/reports/gold-ledger'
      path: '/gold-ledger'
      fullPath: '/reports/gold-ledger'
      preLoaderRoute: typeof ReportsGoldLedgerRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/fine-rojmel': {
      id: '/reports/fine-rojmel'
      path: '/fine-rojmel'
      fullPath: '/reports/fine-rojmel'
      preLoaderRoute: typeof ReportsFineRojmelRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/fine-margin': {
      id: '/reports/fine-margin'
      path: '/fine-margin'
      fullPath: '/reports/fine-margin'
      preLoaderRoute: typeof ReportsFineMarginRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/financial-statements': {
      id: '/reports/financial-statements'
      path: '/financial-statements'
      fullPath: '/reports/financial-statements'
      preLoaderRoute: typeof ReportsFinancialStatementsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/exceptions': {
      id: '/reports/exceptions'
      path: '/exceptions'
      fullPath: '/reports/exceptions'
      preLoaderRoute: typeof ReportsExceptionsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/erp-audit': {
      id: '/reports/erp-audit'
      path: '/erp-audit'
      fullPath: '/reports/erp-audit'
      preLoaderRoute: typeof ReportsErpAuditRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/discount-report': {
      id: '/reports/discount-report'
      path: '/discount-report'
      fullPath: '/reports/discount-report'
      preLoaderRoute: typeof ReportsDiscountReportRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/dhadi-book': {
      id: '/reports/dhadi-book'
      path: '/dhadi-book'
      fullPath: '/reports/dhadi-book'
      preLoaderRoute: typeof ReportsDhadiBookRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/delivery-summary': {
      id: '/reports/delivery-summary'
      path: '/delivery-summary'
      fullPath: '/reports/delivery-summary'
      preLoaderRoute: typeof ReportsDeliverySummaryRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/deleted-bills': {
      id: '/reports/deleted-bills'
      path: '/deleted-bills'
      fullPath: '/reports/deleted-bills'
      preLoaderRoute: typeof ReportsDeletedBillsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/dealer': {
      id: '/reports/dealer'
      path: '/dealer'
      fullPath: '/reports/dealer'
      preLoaderRoute: typeof ReportsDealerRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/day-wise': {
      id: '/reports/day-wise'
      path: '/day-wise'
      fullPath: '/reports/day-wise'
      preLoaderRoute: typeof ReportsDayWiseRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/dar-rojmel': {
      id: '/reports/dar-rojmel'
      path: '/dar-rojmel'
      fullPath: '/reports/dar-rojmel'
      preLoaderRoute: typeof ReportsDarRojmelRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/daily-summary': {
      id: '/reports/daily-summary'
      path: '/daily-summary'
      fullPath: '/reports/daily-summary'
      preLoaderRoute: typeof ReportsDailySummaryRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/daily-gold-flow': {
      id: '/reports/daily-gold-flow'
      path: '/daily-gold-flow'
      fullPath: '/reports/daily-gold-flow'
      preLoaderRoute: typeof ReportsDailyGoldFlowRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/daily-close': {
      id: '/reports/daily-close'
      path: '/daily-close'
      fullPath: '/reports/daily-close'
      preLoaderRoute: typeof ReportsDailyCloseRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/customer-statement': {
      id: '/reports/customer-statement'
      path: '/customer-statement'
      fullPath: '/reports/customer-statement'
      preLoaderRoute: typeof ReportsCustomerStatementRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/communication-analytics': {
      id: '/reports/communication-analytics'
      path: '/communication-analytics'
      fullPath: '/reports/communication-analytics'
      preLoaderRoute: typeof ReportsCommunicationAnalyticsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/city-wise': {
      id: '/reports/city-wise'
      path: '/city-wise'
      fullPath: '/reports/city-wise'
      preLoaderRoute: typeof ReportsCityWiseRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/cash-flow': {
      id: '/reports/cash-flow'
      path: '/cash-flow'
      fullPath: '/reports/cash-flow'
      preLoaderRoute: typeof ReportsCashFlowRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/ca-pack': {
      id: '/reports/ca-pack'
      path: '/ca-pack'
      fullPath: '/reports/ca-pack'
      preLoaderRoute: typeof ReportsCaPackRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/bullion-ledger': {
      id: '/reports/bullion-ledger'
      path: '/bullion-ledger'
      fullPath: '/reports/bullion-ledger'
      preLoaderRoute: typeof ReportsBullionLedgerRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/branch': {
      id: '/reports/branch'
      path: '/branch'
      fullPath: '/reports/branch'
      preLoaderRoute: typeof ReportsBranchRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/barcode-stock': {
      id: '/reports/barcode-stock'
      path: '/barcode-stock'
      fullPath: '/reports/barcode-stock'
      preLoaderRoute: typeof ReportsBarcodeStockRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/bank-transactions': {
      id: '/reports/bank-transactions'
      path: '/bank-transactions'
      fullPath: '/reports/bank-transactions'
      preLoaderRoute: typeof ReportsBankTransactionsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/auditor': {
      id: '/reports/auditor'
      path: '/auditor'
      fullPath: '/reports/auditor'
      preLoaderRoute: typeof ReportsAuditorRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/audit-log': {
      id: '/reports/audit-log'
      path: '/audit-log'
      fullPath: '/reports/audit-log'
      preLoaderRoute: typeof ReportsAuditLogRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/approvals': {
      id: '/reports/approvals'
      path: '/approvals'
      fullPath: '/reports/approvals'
      preLoaderRoute: typeof ReportsApprovalsRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/account-balance': {
      id: '/reports/account-balance'
      path: '/account-balance'
      fullPath: '/reports/account-balance'
      preLoaderRoute: typeof ReportsAccountBalanceRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/repair/new': {
      id: '/repair/new'
      path: '/new'
      fullPath: '/repair/new'
      preLoaderRoute: typeof RepairNewRouteImport
      parentRoute: typeof RepairRoute
    }
    '/repair/$id': {
      id: '/repair/$id'
      path: '/$id'
      fullPath: '/repair/$id'
      preLoaderRoute: typeof RepairIdRouteImport
      parentRoute: typeof RepairRoute
    }
    '/platform/website': {
      id: '/platform/website'
      path: '/website'
      fullPath: '/platform/website'
      preLoaderRoute: typeof PlatformWebsiteRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/trials': {
      id: '/platform/trials'
      path: '/trials'
      fullPath: '/platform/trials'
      preLoaderRoute: typeof PlatformTrialsRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/plans': {
      id: '/platform/plans'
      path: '/plans'
      fullPath: '/platform/plans'
      preLoaderRoute: typeof PlatformPlansRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/meta-whatsapp': {
      id: '/platform/meta-whatsapp'
      path: '/meta-whatsapp'
      fullPath: '/platform/meta-whatsapp'
      preLoaderRoute: typeof PlatformMetaWhatsappRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/communication-providers': {
      id: '/platform/communication-providers'
      path: '/communication-providers'
      fullPath: '/platform/communication-providers'
      preLoaderRoute: typeof PlatformCommunicationProvidersRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/commercial-pricing': {
      id: '/platform/commercial-pricing'
      path: '/commercial-pricing'
      fullPath: '/platform/commercial-pricing'
      preLoaderRoute: typeof PlatformCommercialPricingRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/people/import': {
      id: '/people/import'
      path: '/people/import'
      fullPath: '/people/import'
      preLoaderRoute: typeof PeopleImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$id': {
      id: '/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof PeopleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/new': {
      id: '/orders/new'
      path: '/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof OrdersNewRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/orders/import': {
      id: '/orders/import'
      path: '/import'
      fullPath: '/orders/import'
      preLoaderRoute: typeof OrdersImportRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/orders/$id': {
      id: '/orders/$id'
      path: '/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof OrdersIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/mobile/work': {
      id: '/mobile/work'
      path: '/mobile/work'
      fullPath: '/mobile/work'
      preLoaderRoute: typeof MobileWorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/transactions': {
      id: '/mobile/transactions'
      path: '/mobile/transactions'
      fullPath: '/mobile/transactions'
      preLoaderRoute: typeof MobileTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/sync': {
      id: '/mobile/sync'
      path: '/mobile/sync'
      fullPath: '/mobile/sync'
      preLoaderRoute: typeof MobileSyncRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/stock-entry': {
      id: '/mobile/stock-entry'
      path: '/mobile/stock-entry'
      fullPath: '/mobile/stock-entry'
      preLoaderRoute: typeof MobileStockEntryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/reports': {
      id: '/mobile/reports'
      path: '/mobile/reports'
      fullPath: '/mobile/reports'
      preLoaderRoute: typeof MobileReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/more': {
      id: '/mobile/more'
      path: '/mobile/more'
      fullPath: '/mobile/more'
      preLoaderRoute: typeof MobileMoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/master': {
      id: '/mobile/master'
      path: '/mobile/master'
      fullPath: '/mobile/master'
      preLoaderRoute: typeof MobileMasterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/gold-stock': {
      id: '/mobile/gold-stock'
      path: '/mobile/gold-stock'
      fullPath: '/mobile/gold-stock'
      preLoaderRoute: typeof MobileGoldStockRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/business': {
      id: '/mobile/business'
      path: '/mobile/business'
      fullPath: '/mobile/business'
      preLoaderRoute: typeof MobileBusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile/assistant': {
      id: '/mobile/assistant'
      path: '/mobile/assistant'
      fullPath: '/mobile/assistant'
      preLoaderRoute: typeof MobileAssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manufacturing/owner-transactions': {
      id: '/manufacturing/owner-transactions'
      path: '/owner-transactions'
      fullPath: '/manufacturing/owner-transactions'
      preLoaderRoute: typeof ManufacturingOwnerTransactionsRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/invite/accept': {
      id: '/invite/accept'
      path: '/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof InviteAcceptRouteImport
      parentRoute: typeof InviteRoute
    }
    '/doc/$token': {
      id: '/doc/$token'
      path: '/doc/$token'
      fullPath: '/doc/$token'
      preLoaderRoute: typeof DocTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/ceo': {
      id: '/dashboard/ceo'
      path: '/ceo'
      fullPath: '/dashboard/ceo'
      preLoaderRoute: typeof DashboardCeoRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/crm/leads': {
      id: '/crm/leads'
      path: '/crm/leads'
      fullPath: '/crm/leads'
      preLoaderRoute: typeof CrmLeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/appointments': {
      id: '/crm/appointments'
      path: '/crm/appointments'
      fullPath: '/crm/appointments'
      preLoaderRoute: typeof CrmAppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/terminology': {
      id: '/control/terminology'
      path: '/control/terminology'
      fullPath: '/control/terminology'
      preLoaderRoute: typeof ControlTerminologyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/tally-export': {
      id: '/control/tally-export'
      path: '/control/tally-export'
      fullPath: '/control/tally-export'
      preLoaderRoute: typeof ControlTallyExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/shortcuts': {
      id: '/control/shortcuts'
      path: '/control/shortcuts'
      fullPath: '/control/shortcuts'
      preLoaderRoute: typeof ControlShortcutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/rates': {
      id: '/control/rates'
      path: '/control/rates'
      fullPath: '/control/rates'
      preLoaderRoute: typeof ControlRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/print-profiles': {
      id: '/control/print-profiles'
      path: '/control/print-profiles'
      fullPath: '/control/print-profiles'
      preLoaderRoute: typeof ControlPrintProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/migration': {
      id: '/control/migration'
      path: '/control/migration'
      fullPath: '/control/migration'
      preLoaderRoute: typeof ControlMigrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/customization': {
      id: '/control/customization'
      path: '/control/customization'
      fullPath: '/control/customization'
      preLoaderRoute: typeof ControlCustomizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control/accounts': {
      id: '/control/accounts'
      path: '/control/accounts'
      fullPath: '/control/accounts'
      preLoaderRoute: typeof ControlAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon/meena-book': {
      id: '/coming-soon/meena-book'
      path: '/coming-soon/meena-book'
      fullPath: '/coming-soon/meena-book'
      preLoaderRoute: typeof ComingSoonMeenaBookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon/barcode-scanner': {
      id: '/coming-soon/barcode-scanner'
      path: '/coming-soon/barcode-scanner'
      fullPath: '/coming-soon/barcode-scanner'
      preLoaderRoute: typeof ComingSoonBarcodeScannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon/barcode-printing': {
      id: '/coming-soon/barcode-printing'
      path: '/coming-soon/barcode-printing'
      fullPath: '/coming-soon/barcode-printing'
      preLoaderRoute: typeof ComingSoonBarcodePrintingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/templates': {
      id: '/catalog/templates'
      path: '/templates'
      fullPath: '/catalog/templates'
      preLoaderRoute: typeof CatalogTemplatesRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/masters': {
      id: '/catalog/masters'
      path: '/masters'
      fullPath: '/catalog/masters'
      preLoaderRoute: typeof CatalogMastersRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/designer': {
      id: '/catalog/designer'
      path: '/designer'
      fullPath: '/catalog/designer'
      preLoaderRoute: typeof CatalogDesignerRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/$id': {
      id: '/catalog/$id'
      path: '/$id'
      fullPath: '/catalog/$id'
      preLoaderRoute: typeof CatalogIdRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/billing/new': {
      id: '/billing/new'
      path: '/new'
      fullPath: '/billing/new'
      preLoaderRoute: typeof BillingNewRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/credit-note': {
      id: '/billing/credit-note'
      path: '/credit-note'
      fullPath: '/billing/credit-note'
      preLoaderRoute: typeof BillingCreditNoteRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/$id': {
      id: '/billing/$id'
      path: '/$id'
      fullPath: '/billing/$id'
      preLoaderRoute: typeof BillingIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/purchases/': {
      id: '/billing/purchases/'
      path: '/purchases'
      fullPath: '/billing/purchases/'
      preLoaderRoute: typeof BillingPurchasesIndexRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/estimates/': {
      id: '/billing/estimates/'
      path: '/estimates'
      fullPath: '/billing/estimates/'
      preLoaderRoute: typeof BillingEstimatesIndexRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/delivery-challans/': {
      id: '/billing/delivery-challans/'
      path: '/delivery-challans'
      fullPath: '/billing/delivery-challans/'
      preLoaderRoute: typeof BillingDeliveryChallansIndexRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/debit-notes/': {
      id: '/billing/debit-notes/'
      path: '/debit-notes'
      fullPath: '/billing/debit-notes/'
      preLoaderRoute: typeof BillingDebitNotesIndexRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/credit-notes/': {
      id: '/billing/credit-notes/'
      path: '/credit-notes'
      fullPath: '/billing/credit-notes/'
      preLoaderRoute: typeof BillingCreditNotesIndexRouteImport
      parentRoute: typeof BillingRoute
    }
    '/workshop/worker-book/$workerId': {
      id: '/workshop/worker-book/$workerId'
      path: '/worker-book/$workerId'
      fullPath: '/workshop/worker-book/$workerId'
      preLoaderRoute: typeof WorkshopWorkerBookWorkerIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/receive-slip/$id': {
      id: '/workshop/receive-slip/$id'
      path: '/receive-slip/$id'
      fullPath: '/workshop/receive-slip/$id'
      preLoaderRoute: typeof WorkshopReceiveSlipIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/process/$type': {
      id: '/workshop/process/$type'
      path: '/process/$type'
      fullPath: '/workshop/process/$type'
      preLoaderRoute: typeof WorkshopProcessTypeRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/polishing-book/$partyId': {
      id: '/workshop/polishing-book/$partyId'
      path: '/polishing-book/$partyId'
      fullPath: '/workshop/polishing-book/$partyId'
      preLoaderRoute: typeof WorkshopPolishingBookPartyIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/outside-worker-book/$partyId': {
      id: '/workshop/outside-worker-book/$partyId'
      path: '/outside-worker-book/$partyId'
      fullPath: '/workshop/outside-worker-book/$partyId'
      preLoaderRoute: typeof WorkshopOutsideWorkerBookPartyIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/job-card/$orderId': {
      id: '/workshop/job-card/$orderId'
      path: '/job-card/$orderId'
      fullPath: '/workshop/job-card/$orderId'
      preLoaderRoute: typeof WorkshopJobCardOrderIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/gold-book-print/$workerId': {
      id: '/workshop/gold-book-print/$workerId'
      path: '/gold-book-print/$workerId'
      fullPath: '/workshop/gold-book-print/$workerId'
      preLoaderRoute: typeof WorkshopGoldBookPrintWorkerIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/filings-slip/$id': {
      id: '/workshop/filings-slip/$id'
      path: '/filings-slip/$id'
      fullPath: '/workshop/filings-slip/$id'
      preLoaderRoute: typeof WorkshopFilingsSlipIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/book/$jewellerId': {
      id: '/workshop/book/$jewellerId'
      path: '/book/$jewellerId'
      fullPath: '/workshop/book/$jewellerId'
      preLoaderRoute: typeof WorkshopBookJewellerIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/verify/invoice/$token': {
      id: '/verify/invoice/$token'
      path: '/invoice/$token'
      fullPath: '/verify/invoice/$token'
      preLoaderRoute: typeof VerifyInvoiceTokenRouteImport
      parentRoute: typeof VerifyRoute
    }
    '/stock/print/$id': {
      id: '/stock/print/$id'
      path: '/print/$id'
      fullPath: '/stock/print/$id'
      preLoaderRoute: typeof StockPrintIdRouteImport
      parentRoute: typeof StockRoute
    }
    '/settlement/draft-print/$id': {
      id: '/settlement/draft-print/$id'
      path: '/settlement/draft-print/$id'
      fullPath: '/settlement/draft-print/$id'
      preLoaderRoute: typeof SettlementDraftPrintIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/whatsapp': {
      id: '/settings/integrations/whatsapp'
      path: '/integrations/whatsapp'
      fullPath: '/settings/integrations/whatsapp'
      preLoaderRoute: typeof SettingsIntegrationsWhatsappRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/communications/meta-callback': {
      id: '/settings/communications/meta-callback'
      path: '/meta-callback'
      fullPath: '/settings/communications/meta-callback'
      preLoaderRoute: typeof SettingsCommunicationsMetaCallbackRouteImport
      parentRoute: typeof SettingsCommunicationsRoute
    }
    '/reports/dailyclose-print/$id': {
      id: '/reports/dailyclose-print/$id'
      path: '/dailyclose-print/$id'
      fullPath: '/reports/dailyclose-print/$id'
      preLoaderRoute: typeof ReportsDailyclosePrintIdRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/book-print/$docType': {
      id: '/reports/book-print/$docType'
      path: '/book-print/$docType'
      fullPath: '/reports/book-print/$docType'
      preLoaderRoute: typeof ReportsBookPrintDocTypeRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/account-balance-print/$variant': {
      id: '/reports/account-balance-print/$variant'
      path: '/account-balance-print/$variant'
      fullPath: '/reports/account-balance-print/$variant'
      preLoaderRoute: typeof ReportsAccountBalancePrintVariantRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/repair/polishing/new': {
      id: '/repair/polishing/new'
      path: '/polishing/new'
      fullPath: '/repair/polishing/new'
      preLoaderRoute: typeof RepairPolishingNewRouteImport
      parentRoute: typeof RepairRoute
    }
    '/platform/billing-print/$id': {
      id: '/platform/billing-print/$id'
      path: '/billing-print/$id'
      fullPath: '/platform/billing-print/$id'
      preLoaderRoute: typeof PlatformBillingPrintIdRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/people/print/$id': {
      id: '/people/print/$id'
      path: '/people/print/$id'
      fullPath: '/people/print/$id'
      preLoaderRoute: typeof PeoplePrintIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/ledger-print/$id': {
      id: '/people/ledger-print/$id'
      path: '/people/ledger-print/$id'
      fullPath: '/people/ledger-print/$id'
      preLoaderRoute: typeof PeopleLedgerPrintIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manufacturing/bill/$id': {
      id: '/manufacturing/bill/$id'
      path: '/bill/$id'
      fullPath: '/manufacturing/bill/$id'
      preLoaderRoute: typeof ManufacturingBillIdRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/crm/360/$id': {
      id: '/crm/360/$id'
      path: '/crm/360/$id'
      fullPath: '/crm/360/$id'
      preLoaderRoute: typeof Crm360IdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversion/slip/$id': {
      id: '/conversion/slip/$id'
      path: '/conversion/slip/$id'
      fullPath: '/conversion/slip/$id'
      preLoaderRoute: typeof ConversionSlipIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/settlement-slip/$id': {
      id: '/billing/settlement-slip/$id'
      path: '/settlement-slip/$id'
      fullPath: '/billing/settlement-slip/$id'
      preLoaderRoute: typeof BillingSettlementSlipIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/receipt/$id': {
      id: '/billing/receipt/$id'
      path: '/receipt/$id'
      fullPath: '/billing/receipt/$id'
      preLoaderRoute: typeof BillingReceiptIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/purchases/return': {
      id: '/billing/purchases/return'
      path: '/purchases/return'
      fullPath: '/billing/purchases/return'
      preLoaderRoute: typeof BillingPurchasesReturnRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/print/$id': {
      id: '/billing/print/$id'
      path: '/print/$id'
      fullPath: '/billing/print/$id'
      preLoaderRoute: typeof BillingPrintIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/gold-settlement-print/$id': {
      id: '/billing/gold-settlement-print/$id'
      path: '/gold-settlement-print/$id'
      fullPath: '/billing/gold-settlement-print/$id'
      preLoaderRoute: typeof BillingGoldSettlementPrintIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/estimates/$id': {
      id: '/billing/estimates/$id'
      path: '/estimates/$id'
      fullPath: '/billing/estimates/$id'
      preLoaderRoute: typeof BillingEstimatesIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/estimate/$id': {
      id: '/billing/estimate/$id'
      path: '/estimate/$id'
      fullPath: '/billing/estimate/$id'
      preLoaderRoute: typeof BillingEstimateIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/estimate-print/$id': {
      id: '/billing/estimate-print/$id'
      path: '/estimate-print/$id'
      fullPath: '/billing/estimate-print/$id'
      preLoaderRoute: typeof BillingEstimatePrintIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/delivery-challans/$id': {
      id: '/billing/delivery-challans/$id'
      path: '/delivery-challans/$id'
      fullPath: '/billing/delivery-challans/$id'
      preLoaderRoute: typeof BillingDeliveryChallansIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/delivery-challan-print/$id': {
      id: '/billing/delivery-challan-print/$id'
      path: '/delivery-challan-print/$id'
      fullPath: '/billing/delivery-challan-print/$id'
      preLoaderRoute: typeof BillingDeliveryChallanPrintIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/debit-notes/$id': {
      id: '/billing/debit-notes/$id'
      path: '/debit-notes/$id'
      fullPath: '/billing/debit-notes/$id'
      preLoaderRoute: typeof BillingDebitNotesIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/debit-note-print/$id': {
      id: '/billing/debit-note-print/$id'
      path: '/debit-note-print/$id'
      fullPath: '/billing/debit-note-print/$id'
      preLoaderRoute: typeof BillingDebitNotePrintIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/credit-notes/$id': {
      id: '/billing/credit-notes/$id'
      path: '/credit-notes/$id'
      fullPath: '/billing/credit-notes/$id'
      preLoaderRoute: typeof BillingCreditNotesIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/billing/credit-note-print/$id': {
      id: '/billing/credit-note-print/$id'
      path: '/credit-note-print/$id'
      fullPath: '/billing/credit-note-print/$id'
      preLoaderRoute: typeof BillingCreditNotePrintIdRouteImport
      parentRoute: typeof BillingRoute
    }
    '/workshop/print/job-card/$orderId': {
      id: '/workshop/print/job-card/$orderId'
      path: '/print/job-card/$orderId'
      fullPath: '/workshop/print/job-card/$orderId'
      preLoaderRoute: typeof WorkshopPrintJobCardOrderIdRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/workshop/material-slip/$workerId/$date': {
      id: '/workshop/material-slip/$workerId/$date'
      path: '/material-slip/$workerId/$date'
      fullPath: '/workshop/material-slip/$workerId/$date'
      preLoaderRoute: typeof WorkshopMaterialSlipWorkerIdDateRouteImport
      parentRoute: typeof WorkshopRoute
    }
    '/repair/print/$kind/$id': {
      id: '/repair/print/$kind/$id'
      path: '/print/$kind/$id'
      fullPath: '/repair/print/$kind/$id'
      preLoaderRoute: typeof RepairPrintKindIdRouteImport
      parentRoute: typeof RepairRoute
    }
    '/orders/print/$kind/$id': {
      id: '/orders/print/$kind/$id'
      path: '/print/$kind/$id'
      fullPath: '/orders/print/$kind/$id'
      preLoaderRoute: typeof OrdersPrintKindIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/manufacturing/bill/new/$jobId': {
      id: '/manufacturing/bill/new/$jobId'
      path: '/bill/new/$jobId'
      fullPath: '/manufacturing/bill/new/$jobId'
      preLoaderRoute: typeof ManufacturingBillNewJobIdRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/attendance/print/$kind/$id': {
      id: '/attendance/print/$kind/$id'
      path: '/print/$kind/$id'
      fullPath: '/attendance/print/$kind/$id'
      preLoaderRoute: typeof AttendancePrintKindIdRouteImport
      parentRoute: typeof AttendanceRoute
    }
  }
}

interface AdminRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AttendanceRouteChildren {
  AttendanceIndexRoute: typeof AttendanceIndexRoute
  AttendancePrintKindIdRoute: typeof AttendancePrintKindIdRoute
}

const AttendanceRouteChildren: AttendanceRouteChildren = {
  AttendanceIndexRoute: AttendanceIndexRoute,
  AttendancePrintKindIdRoute: AttendancePrintKindIdRoute,
}

const AttendanceRouteWithChildren = AttendanceRoute._addFileChildren(
  AttendanceRouteChildren,
)

interface BillingRouteChildren {
  BillingIdRoute: typeof BillingIdRoute
  BillingCreditNoteRoute: typeof BillingCreditNoteRoute
  BillingNewRoute: typeof BillingNewRoute
  BillingIndexRoute: typeof BillingIndexRoute
  BillingCreditNotePrintIdRoute: typeof BillingCreditNotePrintIdRoute
  BillingCreditNotesIdRoute: typeof BillingCreditNotesIdRoute
  BillingDebitNotePrintIdRoute: typeof BillingDebitNotePrintIdRoute
  BillingDebitNotesIdRoute: typeof BillingDebitNotesIdRoute
  BillingDeliveryChallanPrintIdRoute: typeof BillingDeliveryChallanPrintIdRoute
  BillingDeliveryChallansIdRoute: typeof BillingDeliveryChallansIdRoute
  BillingEstimatePrintIdRoute: typeof BillingEstimatePrintIdRoute
  BillingEstimateIdRoute: typeof BillingEstimateIdRoute
  BillingEstimatesIdRoute: typeof BillingEstimatesIdRoute
  BillingGoldSettlementPrintIdRoute: typeof BillingGoldSettlementPrintIdRoute
  BillingPrintIdRoute: typeof BillingPrintIdRoute
  BillingPurchasesReturnRoute: typeof BillingPurchasesReturnRoute
  BillingReceiptIdRoute: typeof BillingReceiptIdRoute
  BillingSettlementSlipIdRoute: typeof BillingSettlementSlipIdRoute
  BillingCreditNotesIndexRoute: typeof BillingCreditNotesIndexRoute
  BillingDebitNotesIndexRoute: typeof BillingDebitNotesIndexRoute
  BillingDeliveryChallansIndexRoute: typeof BillingDeliveryChallansIndexRoute
  BillingEstimatesIndexRoute: typeof BillingEstimatesIndexRoute
  BillingPurchasesIndexRoute: typeof BillingPurchasesIndexRoute
}

const BillingRouteChildren: BillingRouteChildren = {
  BillingIdRoute: BillingIdRoute,
  BillingCreditNoteRoute: BillingCreditNoteRoute,
  BillingNewRoute: BillingNewRoute,
  BillingIndexRoute: BillingIndexRoute,
  BillingCreditNotePrintIdRoute: BillingCreditNotePrintIdRoute,
  BillingCreditNotesIdRoute: BillingCreditNotesIdRoute,
  BillingDebitNotePrintIdRoute: BillingDebitNotePrintIdRoute,
  BillingDebitNotesIdRoute: BillingDebitNotesIdRoute,
  BillingDeliveryChallanPrintIdRoute: BillingDeliveryChallanPrintIdRoute,
  BillingDeliveryChallansIdRoute: BillingDeliveryChallansIdRoute,
  BillingEstimatePrintIdRoute: BillingEstimatePrintIdRoute,
  BillingEstimateIdRoute: BillingEstimateIdRoute,
  BillingEstimatesIdRoute: BillingEstimatesIdRoute,
  BillingGoldSettlementPrintIdRoute: BillingGoldSettlementPrintIdRoute,
  BillingPrintIdRoute: BillingPrintIdRoute,
  BillingPurchasesReturnRoute: BillingPurchasesReturnRoute,
  BillingReceiptIdRoute: BillingReceiptIdRoute,
  BillingSettlementSlipIdRoute: BillingSettlementSlipIdRoute,
  BillingCreditNotesIndexRoute: BillingCreditNotesIndexRoute,
  BillingDebitNotesIndexRoute: BillingDebitNotesIndexRoute,
  BillingDeliveryChallansIndexRoute: BillingDeliveryChallansIndexRoute,
  BillingEstimatesIndexRoute: BillingEstimatesIndexRoute,
  BillingPurchasesIndexRoute: BillingPurchasesIndexRoute,
}

const BillingRouteWithChildren =
  BillingRoute._addFileChildren(BillingRouteChildren)

interface CatalogRouteChildren {
  CatalogIdRoute: typeof CatalogIdRoute
  CatalogDesignerRoute: typeof CatalogDesignerRoute
  CatalogMastersRoute: typeof CatalogMastersRoute
  CatalogTemplatesRoute: typeof CatalogTemplatesRoute
  CatalogIndexRoute: typeof CatalogIndexRoute
}

const CatalogRouteChildren: CatalogRouteChildren = {
  CatalogIdRoute: CatalogIdRoute,
  CatalogDesignerRoute: CatalogDesignerRoute,
  CatalogMastersRoute: CatalogMastersRoute,
  CatalogTemplatesRoute: CatalogTemplatesRoute,
  CatalogIndexRoute: CatalogIndexRoute,
}

const CatalogRouteWithChildren =
  CatalogRoute._addFileChildren(CatalogRouteChildren)

interface CommunicationsRouteChildren {
  CommunicationsIndexRoute: typeof CommunicationsIndexRoute
}

const CommunicationsRouteChildren: CommunicationsRouteChildren = {
  CommunicationsIndexRoute: CommunicationsIndexRoute,
}

const CommunicationsRouteWithChildren = CommunicationsRoute._addFileChildren(
  CommunicationsRouteChildren,
)

interface DashboardRouteChildren {
  DashboardCeoRoute: typeof DashboardCeoRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardCeoRoute: DashboardCeoRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface InviteRouteChildren {
  InviteAcceptRoute: typeof InviteAcceptRoute
}

const InviteRouteChildren: InviteRouteChildren = {
  InviteAcceptRoute: InviteAcceptRoute,
}

const InviteRouteWithChildren =
  InviteRoute._addFileChildren(InviteRouteChildren)

interface ManufacturingRouteChildren {
  ManufacturingOwnerTransactionsRoute: typeof ManufacturingOwnerTransactionsRoute
  ManufacturingIndexRoute: typeof ManufacturingIndexRoute
  ManufacturingBillIdRoute: typeof ManufacturingBillIdRoute
  ManufacturingBillNewJobIdRoute: typeof ManufacturingBillNewJobIdRoute
}

const ManufacturingRouteChildren: ManufacturingRouteChildren = {
  ManufacturingOwnerTransactionsRoute: ManufacturingOwnerTransactionsRoute,
  ManufacturingIndexRoute: ManufacturingIndexRoute,
  ManufacturingBillIdRoute: ManufacturingBillIdRoute,
  ManufacturingBillNewJobIdRoute: ManufacturingBillNewJobIdRoute,
}

const ManufacturingRouteWithChildren = ManufacturingRoute._addFileChildren(
  ManufacturingRouteChildren,
)

interface MeltRouteChildren {
  MeltIndexRoute: typeof MeltIndexRoute
}

const MeltRouteChildren: MeltRouteChildren = {
  MeltIndexRoute: MeltIndexRoute,
}

const MeltRouteWithChildren = MeltRoute._addFileChildren(MeltRouteChildren)

interface MtgRouteChildren {
  MtgIndexRoute: typeof MtgIndexRoute
}

const MtgRouteChildren: MtgRouteChildren = {
  MtgIndexRoute: MtgIndexRoute,
}

const MtgRouteWithChildren = MtgRoute._addFileChildren(MtgRouteChildren)

interface OrdersRouteChildren {
  OrdersIdRoute: typeof OrdersIdRoute
  OrdersImportRoute: typeof OrdersImportRoute
  OrdersNewRoute: typeof OrdersNewRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  OrdersPrintKindIdRoute: typeof OrdersPrintKindIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersIdRoute: OrdersIdRoute,
  OrdersImportRoute: OrdersImportRoute,
  OrdersNewRoute: OrdersNewRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  OrdersPrintKindIdRoute: OrdersPrintKindIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

interface PlatformRouteChildren {
  PlatformCommercialPricingRoute: typeof PlatformCommercialPricingRoute
  PlatformCommunicationProvidersRoute: typeof PlatformCommunicationProvidersRoute
  PlatformMetaWhatsappRoute: typeof PlatformMetaWhatsappRoute
  PlatformPlansRoute: typeof PlatformPlansRoute
  PlatformTrialsRoute: typeof PlatformTrialsRoute
  PlatformWebsiteRoute: typeof PlatformWebsiteRoute
  PlatformBillingPrintIdRoute: typeof PlatformBillingPrintIdRoute
}

const PlatformRouteChildren: PlatformRouteChildren = {
  PlatformCommercialPricingRoute: PlatformCommercialPricingRoute,
  PlatformCommunicationProvidersRoute: PlatformCommunicationProvidersRoute,
  PlatformMetaWhatsappRoute: PlatformMetaWhatsappRoute,
  PlatformPlansRoute: PlatformPlansRoute,
  PlatformTrialsRoute: PlatformTrialsRoute,
  PlatformWebsiteRoute: PlatformWebsiteRoute,
  PlatformBillingPrintIdRoute: PlatformBillingPrintIdRoute,
}

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(
  PlatformRouteChildren,
)

interface RepairRouteChildren {
  RepairIdRoute: typeof RepairIdRoute
  RepairNewRoute: typeof RepairNewRoute
  RepairIndexRoute: typeof RepairIndexRoute
  RepairPolishingNewRoute: typeof RepairPolishingNewRoute
  RepairPrintKindIdRoute: typeof RepairPrintKindIdRoute
}

const RepairRouteChildren: RepairRouteChildren = {
  RepairIdRoute: RepairIdRoute,
  RepairNewRoute: RepairNewRoute,
  RepairIndexRoute: RepairIndexRoute,
  RepairPolishingNewRoute: RepairPolishingNewRoute,
  RepairPrintKindIdRoute: RepairPrintKindIdRoute,
}

const RepairRouteWithChildren =
  RepairRoute._addFileChildren(RepairRouteChildren)

interface ReportsRouteChildren {
  ReportsAccountBalanceRoute: typeof ReportsAccountBalanceRoute
  ReportsApprovalsRoute: typeof ReportsApprovalsRoute
  ReportsAuditLogRoute: typeof ReportsAuditLogRoute
  ReportsAuditorRoute: typeof ReportsAuditorRoute
  ReportsBankTransactionsRoute: typeof ReportsBankTransactionsRoute
  ReportsBarcodeStockRoute: typeof ReportsBarcodeStockRoute
  ReportsBranchRoute: typeof ReportsBranchRoute
  ReportsBullionLedgerRoute: typeof ReportsBullionLedgerRoute
  ReportsCaPackRoute: typeof ReportsCaPackRoute
  ReportsCashFlowRoute: typeof ReportsCashFlowRoute
  ReportsCityWiseRoute: typeof ReportsCityWiseRoute
  ReportsCommunicationAnalyticsRoute: typeof ReportsCommunicationAnalyticsRoute
  ReportsCustomerStatementRoute: typeof ReportsCustomerStatementRoute
  ReportsDailyCloseRoute: typeof ReportsDailyCloseRoute
  ReportsDailyGoldFlowRoute: typeof ReportsDailyGoldFlowRoute
  ReportsDailySummaryRoute: typeof ReportsDailySummaryRoute
  ReportsDarRojmelRoute: typeof ReportsDarRojmelRoute
  ReportsDayWiseRoute: typeof ReportsDayWiseRoute
  ReportsDealerRoute: typeof ReportsDealerRoute
  ReportsDeletedBillsRoute: typeof ReportsDeletedBillsRoute
  ReportsDeliverySummaryRoute: typeof ReportsDeliverySummaryRoute
  ReportsDhadiBookRoute: typeof ReportsDhadiBookRoute
  ReportsDiscountReportRoute: typeof ReportsDiscountReportRoute
  ReportsErpAuditRoute: typeof ReportsErpAuditRoute
  ReportsExceptionsRoute: typeof ReportsExceptionsRoute
  ReportsFinancialStatementsRoute: typeof ReportsFinancialStatementsRoute
  ReportsFineMarginRoute: typeof ReportsFineMarginRoute
  ReportsFineRojmelRoute: typeof ReportsFineRojmelRoute
  ReportsGoldLedgerRoute: typeof ReportsGoldLedgerRoute
  ReportsGoldLossRoute: typeof ReportsGoldLossRoute
  ReportsGoldOutstandingRoute: typeof ReportsGoldOutstandingRoute
  ReportsGoldPositionRoute: typeof ReportsGoldPositionRoute
  ReportsGoldReconciliationRoute: typeof ReportsGoldReconciliationRoute
  ReportsGoldStockRoute: typeof ReportsGoldStockRoute
  ReportsGoldSummaryRoute: typeof ReportsGoldSummaryRoute
  ReportsGstReturnsRoute: typeof ReportsGstReturnsRoute
  ReportsHsnSummaryRoute: typeof ReportsHsnSummaryRoute
  ReportsInventoryAgeingRoute: typeof ReportsInventoryAgeingRoute
  ReportsItc04Route: typeof ReportsItc04Route
  ReportsItemJamaNaveRoute: typeof ReportsItemJamaNaveRoute
  ReportsItemTransactionRoute: typeof ReportsItemTransactionRoute
  ReportsLedgersRoute: typeof ReportsLedgersRoute
  ReportsLedgersPrintAllRoute: typeof ReportsLedgersPrintAllRoute
  ReportsManufacturingRoute: typeof ReportsManufacturingRoute
  ReportsManufacturingReconciliationRoute: typeof ReportsManufacturingReconciliationRoute
  ReportsMetalPositionRoute: typeof ReportsMetalPositionRoute
  ReportsMonthEndCloseRoute: typeof ReportsMonthEndCloseRoute
  ReportsOutsideWorkRoute: typeof ReportsOutsideWorkRoute
  ReportsOwnerDrawingsRoute: typeof ReportsOwnerDrawingsRoute
  ReportsPurchaseRegisterRoute: typeof ReportsPurchaseRegisterRoute
  ReportsReconciliationCenterRoute: typeof ReportsReconciliationCenterRoute
  ReportsRemindersRoute: typeof ReportsRemindersRoute
  ReportsSalesRegisterRoute: typeof ReportsSalesRegisterRoute
  ReportsSchemeRoute: typeof ReportsSchemeRoute
  ReportsSettlementReconciliationRoute: typeof ReportsSettlementReconciliationRoute
  ReportsSettlementsRoute: typeof ReportsSettlementsRoute
  ReportsStockValuationRoute: typeof ReportsStockValuationRoute
  ReportsTallyExportRoute: typeof ReportsTallyExportRoute
  ReportsTanchHishobRoute: typeof ReportsTanchHishobRoute
  ReportsTotalProfitRoute: typeof ReportsTotalProfitRoute
  ReportsVaultReconciliationRoute: typeof ReportsVaultReconciliationRoute
  ReportsWorkerRoute: typeof ReportsWorkerRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  ReportsAccountBalancePrintVariantRoute: typeof ReportsAccountBalancePrintVariantRoute
  ReportsBookPrintDocTypeRoute: typeof ReportsBookPrintDocTypeRoute
  ReportsDailyclosePrintIdRoute: typeof ReportsDailyclosePrintIdRoute
}

const ReportsRouteChildren: ReportsRouteChildren = {
  ReportsAccountBalanceRoute: ReportsAccountBalanceRoute,
  ReportsApprovalsRoute: ReportsApprovalsRoute,
  ReportsAuditLogRoute: ReportsAuditLogRoute,
  ReportsAuditorRoute: ReportsAuditorRoute,
  ReportsBankTransactionsRoute: ReportsBankTransactionsRoute,
  ReportsBarcodeStockRoute: ReportsBarcodeStockRoute,
  ReportsBranchRoute: ReportsBranchRoute,
  ReportsBullionLedgerRoute: ReportsBullionLedgerRoute,
  ReportsCaPackRoute: ReportsCaPackRoute,
  ReportsCashFlowRoute: ReportsCashFlowRoute,
  ReportsCityWiseRoute: ReportsCityWiseRoute,
  ReportsCommunicationAnalyticsRoute: ReportsCommunicationAnalyticsRoute,
  ReportsCustomerStatementRoute: ReportsCustomerStatementRoute,
  ReportsDailyCloseRoute: ReportsDailyCloseRoute,
  ReportsDailyGoldFlowRoute: ReportsDailyGoldFlowRoute,
  ReportsDailySummaryRoute: ReportsDailySummaryRoute,
  ReportsDarRojmelRoute: ReportsDarRojmelRoute,
  ReportsDayWiseRoute: ReportsDayWiseRoute,
  ReportsDealerRoute: ReportsDealerRoute,
  ReportsDeletedBillsRoute: ReportsDeletedBillsRoute,
  ReportsDeliverySummaryRoute: ReportsDeliverySummaryRoute,
  ReportsDhadiBookRoute: ReportsDhadiBookRoute,
  ReportsDiscountReportRoute: ReportsDiscountReportRoute,
  ReportsErpAuditRoute: ReportsErpAuditRoute,
  ReportsExceptionsRoute: ReportsExceptionsRoute,
  ReportsFinancialStatementsRoute: ReportsFinancialStatementsRoute,
  ReportsFineMarginRoute: ReportsFineMarginRoute,
  ReportsFineRojmelRoute: ReportsFineRojmelRoute,
  ReportsGoldLedgerRoute: ReportsGoldLedgerRoute,
  ReportsGoldLossRoute: ReportsGoldLossRoute,
  ReportsGoldOutstandingRoute: ReportsGoldOutstandingRoute,
  ReportsGoldPositionRoute: ReportsGoldPositionRoute,
  ReportsGoldReconciliationRoute: ReportsGoldReconciliationRoute,
  ReportsGoldStockRoute: ReportsGoldStockRoute,
  ReportsGoldSummaryRoute: ReportsGoldSummaryRoute,
  ReportsGstReturnsRoute: ReportsGstReturnsRoute,
  ReportsHsnSummaryRoute: ReportsHsnSummaryRoute,
  ReportsInventoryAgeingRoute: ReportsInventoryAgeingRoute,
  ReportsItc04Route: ReportsItc04Route,
  ReportsItemJamaNaveRoute: ReportsItemJamaNaveRoute,
  ReportsItemTransactionRoute: ReportsItemTransactionRoute,
  ReportsLedgersRoute: ReportsLedgersRoute,
  ReportsLedgersPrintAllRoute: ReportsLedgersPrintAllRoute,
  ReportsManufacturingRoute: ReportsManufacturingRoute,
  ReportsManufacturingReconciliationRoute:
    ReportsManufacturingReconciliationRoute,
  ReportsMetalPositionRoute: ReportsMetalPositionRoute,
  ReportsMonthEndCloseRoute: ReportsMonthEndCloseRoute,
  ReportsOutsideWorkRoute: ReportsOutsideWorkRoute,
  ReportsOwnerDrawingsRoute: ReportsOwnerDrawingsRoute,
  ReportsPurchaseRegisterRoute: ReportsPurchaseRegisterRoute,
  ReportsReconciliationCenterRoute: ReportsReconciliationCenterRoute,
  ReportsRemindersRoute: ReportsRemindersRoute,
  ReportsSalesRegisterRoute: ReportsSalesRegisterRoute,
  ReportsSchemeRoute: ReportsSchemeRoute,
  ReportsSettlementReconciliationRoute: ReportsSettlementReconciliationRoute,
  ReportsSettlementsRoute: ReportsSettlementsRoute,
  ReportsStockValuationRoute: ReportsStockValuationRoute,
  ReportsTallyExportRoute: ReportsTallyExportRoute,
  ReportsTanchHishobRoute: ReportsTanchHishobRoute,
  ReportsTotalProfitRoute: ReportsTotalProfitRoute,
  ReportsVaultReconciliationRoute: ReportsVaultReconciliationRoute,
  ReportsWorkerRoute: ReportsWorkerRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  ReportsAccountBalancePrintVariantRoute:
    ReportsAccountBalancePrintVariantRoute,
  ReportsBookPrintDocTypeRoute: ReportsBookPrintDocTypeRoute,
  ReportsDailyclosePrintIdRoute: ReportsDailyclosePrintIdRoute,
}

const ReportsRouteWithChildren =
  ReportsRoute._addFileChildren(ReportsRouteChildren)

interface SchemeRouteChildren {
  SchemeAccountsRoute: typeof SchemeAccountsRoute
  SchemePlansRoute: typeof SchemePlansRoute
  SchemeReceiptsRoute: typeof SchemeReceiptsRoute
  SchemeIndexRoute: typeof SchemeIndexRoute
}

const SchemeRouteChildren: SchemeRouteChildren = {
  SchemeAccountsRoute: SchemeAccountsRoute,
  SchemePlansRoute: SchemePlansRoute,
  SchemeReceiptsRoute: SchemeReceiptsRoute,
  SchemeIndexRoute: SchemeIndexRoute,
}

const SchemeRouteWithChildren =
  SchemeRoute._addFileChildren(SchemeRouteChildren)

interface SettingsCommunicationsRouteChildren {
  SettingsCommunicationsMetaCallbackRoute: typeof SettingsCommunicationsMetaCallbackRoute
}

const SettingsCommunicationsRouteChildren: SettingsCommunicationsRouteChildren =
  {
    SettingsCommunicationsMetaCallbackRoute:
      SettingsCommunicationsMetaCallbackRoute,
  }

const SettingsCommunicationsRouteWithChildren =
  SettingsCommunicationsRoute._addFileChildren(
    SettingsCommunicationsRouteChildren,
  )

interface SettingsRouteChildren {
  SettingsAutomationRoute: typeof SettingsAutomationRoute
  SettingsBackupRecoveryRoute: typeof SettingsBackupRecoveryRoute
  SettingsBranchSettingsRoute: typeof SettingsBranchSettingsRoute
  SettingsCommunicationsRoute: typeof SettingsCommunicationsRouteWithChildren
  SettingsDocumentVaultRoute: typeof SettingsDocumentVaultRoute
  SettingsIntegrationsHubRoute: typeof SettingsIntegrationsHubRoute
  SettingsLicenseRoute: typeof SettingsLicenseRoute
  SettingsPrintTemplatesRoute: typeof SettingsPrintTemplatesRoute
  SettingsSecurityCenterRoute: typeof SettingsSecurityCenterRoute
  SettingsStorageDiagnosticsRoute: typeof SettingsStorageDiagnosticsRoute
  SettingsSupportRoute: typeof SettingsSupportRoute
  SettingsWhatsappRoute: typeof SettingsWhatsappRoute
  SettingsWhatsappTemplatesRoute: typeof SettingsWhatsappTemplatesRoute
  SettingsWorkflowRoute: typeof SettingsWorkflowRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SettingsIntegrationsWhatsappRoute: typeof SettingsIntegrationsWhatsappRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAutomationRoute: SettingsAutomationRoute,
  SettingsBackupRecoveryRoute: SettingsBackupRecoveryRoute,
  SettingsBranchSettingsRoute: SettingsBranchSettingsRoute,
  SettingsCommunicationsRoute: SettingsCommunicationsRouteWithChildren,
  SettingsDocumentVaultRoute: SettingsDocumentVaultRoute,
  SettingsIntegrationsHubRoute: SettingsIntegrationsHubRoute,
  SettingsLicenseRoute: SettingsLicenseRoute,
  SettingsPrintTemplatesRoute: SettingsPrintTemplatesRoute,
  SettingsSecurityCenterRoute: SettingsSecurityCenterRoute,
  SettingsStorageDiagnosticsRoute: SettingsStorageDiagnosticsRoute,
  SettingsSupportRoute: SettingsSupportRoute,
  SettingsWhatsappRoute: SettingsWhatsappRoute,
  SettingsWhatsappTemplatesRoute: SettingsWhatsappTemplatesRoute,
  SettingsWorkflowRoute: SettingsWorkflowRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsIntegrationsWhatsappRoute: SettingsIntegrationsWhatsappRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface StockRouteChildren {
  StockIdRoute: typeof StockIdRoute
  StockBoxesRoute: typeof StockBoxesRoute
  StockEntryRoute: typeof StockEntryRoute
  StockHallmarkRoute: typeof StockHallmarkRoute
  StockImportRoute: typeof StockImportRoute
  StockLotsRoute: typeof StockLotsRoute
  StockStonesRoute: typeof StockStonesRoute
  StockTransfersRoute: typeof StockTransfersRoute
  StockVerificationRoute: typeof StockVerificationRoute
  StockIndexRoute: typeof StockIndexRoute
  StockPrintIdRoute: typeof StockPrintIdRoute
}

const StockRouteChildren: StockRouteChildren = {
  StockIdRoute: StockIdRoute,
  StockBoxesRoute: StockBoxesRoute,
  StockEntryRoute: StockEntryRoute,
  StockHallmarkRoute: StockHallmarkRoute,
  StockImportRoute: StockImportRoute,
  StockLotsRoute: StockLotsRoute,
  StockStonesRoute: StockStonesRoute,
  StockTransfersRoute: StockTransfersRoute,
  StockVerificationRoute: StockVerificationRoute,
  StockIndexRoute: StockIndexRoute,
  StockPrintIdRoute: StockPrintIdRoute,
}

const StockRouteWithChildren = StockRoute._addFileChildren(StockRouteChildren)

interface UtilitiesRouteChildren {
  UtilitiesCashFineTransferRoute: typeof UtilitiesCashFineTransferRoute
  UtilitiesCounterSettingsRoute: typeof UtilitiesCounterSettingsRoute
  UtilitiesGstCalculatorRoute: typeof UtilitiesGstCalculatorRoute
  UtilitiesItemMastersRoute: typeof UtilitiesItemMastersRoute
  UtilitiesItemTransactionRoute: typeof UtilitiesItemTransactionRoute
  UtilitiesOpeningFineCashRoute: typeof UtilitiesOpeningFineCashRoute
  UtilitiesPatlaStockRoute: typeof UtilitiesPatlaStockRoute
  UtilitiesSaudaBookRoute: typeof UtilitiesSaudaBookRoute
  UtilitiesSubAccountsRoute: typeof UtilitiesSubAccountsRoute
  UtilitiesUrdPurchaseRoute: typeof UtilitiesUrdPurchaseRoute
  UtilitiesWipeoutRoute: typeof UtilitiesWipeoutRoute
  UtilitiesIndexRoute: typeof UtilitiesIndexRoute
}

const UtilitiesRouteChildren: UtilitiesRouteChildren = {
  UtilitiesCashFineTransferRoute: UtilitiesCashFineTransferRoute,
  UtilitiesCounterSettingsRoute: UtilitiesCounterSettingsRoute,
  UtilitiesGstCalculatorRoute: UtilitiesGstCalculatorRoute,
  UtilitiesItemMastersRoute: UtilitiesItemMastersRoute,
  UtilitiesItemTransactionRoute: UtilitiesItemTransactionRoute,
  UtilitiesOpeningFineCashRoute: UtilitiesOpeningFineCashRoute,
  UtilitiesPatlaStockRoute: UtilitiesPatlaStockRoute,
  UtilitiesSaudaBookRoute: UtilitiesSaudaBookRoute,
  UtilitiesSubAccountsRoute: UtilitiesSubAccountsRoute,
  UtilitiesUrdPurchaseRoute: UtilitiesUrdPurchaseRoute,
  UtilitiesWipeoutRoute: UtilitiesWipeoutRoute,
  UtilitiesIndexRoute: UtilitiesIndexRoute,
}

const UtilitiesRouteWithChildren = UtilitiesRoute._addFileChildren(
  UtilitiesRouteChildren,
)

interface VerifyRouteChildren {
  VerifyInvoiceTokenRoute: typeof VerifyInvoiceTokenRoute
}

const VerifyRouteChildren: VerifyRouteChildren = {
  VerifyInvoiceTokenRoute: VerifyInvoiceTokenRoute,
}

const VerifyRouteWithChildren =
  VerifyRoute._addFileChildren(VerifyRouteChildren)

interface WhatsappRouteChildren {
  WhatsappIndexRoute: typeof WhatsappIndexRoute
}

const WhatsappRouteChildren: WhatsappRouteChildren = {
  WhatsappIndexRoute: WhatsappIndexRoute,
}

const WhatsappRouteWithChildren = WhatsappRoute._addFileChildren(
  WhatsappRouteChildren,
)

interface WorkshopRouteChildren {
  WorkshopIdRoute: typeof WorkshopIdRoute
  WorkshopBarcodeScannerRoute: typeof WorkshopBarcodeScannerRoute
  WorkshopBenchCustodyRoute: typeof WorkshopBenchCustodyRoute
  WorkshopDhadiGroupsRoute: typeof WorkshopDhadiGroupsRoute
  WorkshopGoldBookRoute: typeof WorkshopGoldBookRoute
  WorkshopJamaRoute: typeof WorkshopJamaRoute
  WorkshopJangadRoute: typeof WorkshopJangadRoute
  WorkshopKarigarBookRoute: typeof WorkshopKarigarBookRoute
  WorkshopOutsideWorkRoute: typeof WorkshopOutsideWorkRoute
  WorkshopOutsideWorkerBooksRoute: typeof WorkshopOutsideWorkerBooksRoute
  WorkshopPolishingRoute: typeof WorkshopPolishingRoute
  WorkshopPolishingBooksRoute: typeof WorkshopPolishingBooksRoute
  WorkshopReconciliationRoute: typeof WorkshopReconciliationRoute
  WorkshopVibratorRoute: typeof WorkshopVibratorRoute
  WorkshopWorkerBooksRoute: typeof WorkshopWorkerBooksRoute
  WorkshopIndexRoute: typeof WorkshopIndexRoute
  WorkshopBookJewellerIdRoute: typeof WorkshopBookJewellerIdRoute
  WorkshopFilingsSlipIdRoute: typeof WorkshopFilingsSlipIdRoute
  WorkshopGoldBookPrintWorkerIdRoute: typeof WorkshopGoldBookPrintWorkerIdRoute
  WorkshopJobCardOrderIdRoute: typeof WorkshopJobCardOrderIdRoute
  WorkshopOutsideWorkerBookPartyIdRoute: typeof WorkshopOutsideWorkerBookPartyIdRoute
  WorkshopPolishingBookPartyIdRoute: typeof WorkshopPolishingBookPartyIdRoute
  WorkshopProcessTypeRoute: typeof WorkshopProcessTypeRoute
  WorkshopReceiveSlipIdRoute: typeof WorkshopReceiveSlipIdRoute
  WorkshopWorkerBookWorkerIdRoute: typeof WorkshopWorkerBookWorkerIdRoute
  WorkshopMaterialSlipWorkerIdDateRoute: typeof WorkshopMaterialSlipWorkerIdDateRoute
  WorkshopPrintJobCardOrderIdRoute: typeof WorkshopPrintJobCardOrderIdRoute
}

const WorkshopRouteChildren: WorkshopRouteChildren = {
  WorkshopIdRoute: WorkshopIdRoute,
  WorkshopBarcodeScannerRoute: WorkshopBarcodeScannerRoute,
  WorkshopBenchCustodyRoute: WorkshopBenchCustodyRoute,
  WorkshopDhadiGroupsRoute: WorkshopDhadiGroupsRoute,
  WorkshopGoldBookRoute: WorkshopGoldBookRoute,
  WorkshopJamaRoute: WorkshopJamaRoute,
  WorkshopJangadRoute: WorkshopJangadRoute,
  WorkshopKarigarBookRoute: WorkshopKarigarBookRoute,
  WorkshopOutsideWorkRoute: WorkshopOutsideWorkRoute,
  WorkshopOutsideWorkerBooksRoute: WorkshopOutsideWorkerBooksRoute,
  WorkshopPolishingRoute: WorkshopPolishingRoute,
  WorkshopPolishingBooksRoute: WorkshopPolishingBooksRoute,
  WorkshopReconciliationRoute: WorkshopReconciliationRoute,
  WorkshopVibratorRoute: WorkshopVibratorRoute,
  WorkshopWorkerBooksRoute: WorkshopWorkerBooksRoute,
  WorkshopIndexRoute: WorkshopIndexRoute,
  WorkshopBookJewellerIdRoute: WorkshopBookJewellerIdRoute,
  WorkshopFilingsSlipIdRoute: WorkshopFilingsSlipIdRoute,
  WorkshopGoldBookPrintWorkerIdRoute: WorkshopGoldBookPrintWorkerIdRoute,
  WorkshopJobCardOrderIdRoute: WorkshopJobCardOrderIdRoute,
  WorkshopOutsideWorkerBookPartyIdRoute: WorkshopOutsideWorkerBookPartyIdRoute,
  WorkshopPolishingBookPartyIdRoute: WorkshopPolishingBookPartyIdRoute,
  WorkshopProcessTypeRoute: WorkshopProcessTypeRoute,
  WorkshopReceiveSlipIdRoute: WorkshopReceiveSlipIdRoute,
  WorkshopWorkerBookWorkerIdRoute: WorkshopWorkerBookWorkerIdRoute,
  WorkshopMaterialSlipWorkerIdDateRoute: WorkshopMaterialSlipWorkerIdDateRoute,
  WorkshopPrintJobCardOrderIdRoute: WorkshopPrintJobCardOrderIdRoute,
}

const WorkshopRouteWithChildren = WorkshopRoute._addFileChildren(
  WorkshopRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInvitationRoute: AcceptInvitationRoute,
  AdminRoute: AdminRouteWithChildren,
  AiCenterRoute: AiCenterRoute,
  AppRoute: AppRoute,
  AssistantRoute: AssistantRoute,
  AttendanceRoute: AttendanceRouteWithChildren,
  BarcodeRoute: BarcodeRoute,
  BillingRoute: BillingRouteWithChildren,
  CatalogRoute: CatalogRouteWithChildren,
  CommunicationsRoute: CommunicationsRouteWithChildren,
  CompanyAdminRoute: CompanyAdminRoute,
  CustomerLoginRoute: CustomerLoginRoute,
  CustomerPortalRoute: CustomerPortalRoute,
  DashboardRoute: DashboardRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HelpRoute: HelpRoute,
  InviteRoute: InviteRouteWithChildren,
  KarigarLoginRoute: KarigarLoginRoute,
  KarigarPortalRoute: KarigarPortalRoute,
  LedgerRoute: LedgerRoute,
  LoginRoute: LoginRoute,
  ManufacturingRoute: ManufacturingRouteWithChildren,
  MasterRoute: MasterRoute,
  MeltRoute: MeltRouteWithChildren,
  MtgRoute: MtgRouteWithChildren,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  OrdersRoute: OrdersRouteWithChildren,
  OtpLoginRoute: OtpLoginRoute,
  PlatformRoute: PlatformRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  RepairRoute: RepairRouteWithChildren,
  ReportsRoute: ReportsRouteWithChildren,
  RequestAccessRoute: RequestAccessRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SaasAdminRoute: SaasAdminRoute,
  SchemeRoute: SchemeRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  SetupRoute: SetupRoute,
  SignupRoute: SignupRoute,
  StockRoute: StockRouteWithChildren,
  SupplierLoginRoute: SupplierLoginRoute,
  SupplierPortalRoute: SupplierPortalRoute,
  TermsRoute: TermsRoute,
  TransactionHubRoute: TransactionHubRoute,
  TransactionsRoute: TransactionsRoute,
  UtilitiesRoute: UtilitiesRouteWithChildren,
  VerifyRoute: VerifyRouteWithChildren,
  WhatsappRoute: WhatsappRouteWithChildren,
  WorkshopRoute: WorkshopRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  ComingSoonBarcodePrintingRoute: ComingSoonBarcodePrintingRoute,
  ComingSoonBarcodeScannerRoute: ComingSoonBarcodeScannerRoute,
  ComingSoonMeenaBookRoute: ComingSoonMeenaBookRoute,
  ControlAccountsRoute: ControlAccountsRoute,
  ControlCustomizationRoute: ControlCustomizationRoute,
  ControlMigrationRoute: ControlMigrationRoute,
  ControlPrintProfilesRoute: ControlPrintProfilesRoute,
  ControlRatesRoute: ControlRatesRoute,
  ControlShortcutsRoute: ControlShortcutsRoute,
  ControlTallyExportRoute: ControlTallyExportRoute,
  ControlTerminologyRoute: ControlTerminologyRoute,
  CrmAppointmentsRoute: CrmAppointmentsRoute,
  CrmLeadsRoute: CrmLeadsRoute,
  DocTokenRoute: DocTokenRoute,
  MobileAssistantRoute: MobileAssistantRoute,
  MobileBusinessRoute: MobileBusinessRoute,
  MobileGoldStockRoute: MobileGoldStockRoute,
  MobileMasterRoute: MobileMasterRoute,
  MobileMoreRoute: MobileMoreRoute,
  MobileReportsRoute: MobileReportsRoute,
  MobileStockEntryRoute: MobileStockEntryRoute,
  MobileSyncRoute: MobileSyncRoute,
  MobileTransactionsRoute: MobileTransactionsRoute,
  MobileWorkRoute: MobileWorkRoute,
  PeopleIdRoute: PeopleIdRoute,
  PeopleImportRoute: PeopleImportRoute,
  SettlementIdRoute: SettlementIdRoute,
  SettlementNewRoute: SettlementNewRoute,
  TreasuryBankReconciliationRoute: TreasuryBankReconciliationRoute,
  TreasuryCashBookRoute: TreasuryCashBookRoute,
  TreasuryVouchersRoute: TreasuryVouchersRoute,
  TrialStartRoute: TrialStartRoute,
  UiCatalogRoute: UiCatalogRoute,
  UnsubscribeTokenRoute: UnsubscribeTokenRoute,
  AccountsIndexRoute: AccountsIndexRoute,
  BranchesIndexRoute: BranchesIndexRoute,
  ConversionIndexRoute: ConversionIndexRoute,
  ExpensesIndexRoute: ExpensesIndexRoute,
  HardwareIndexRoute: HardwareIndexRoute,
  MobileIndexRoute: MobileIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  RefineryIndexRoute: RefineryIndexRoute,
  ConversionSlipIdRoute: ConversionSlipIdRoute,
  Crm360IdRoute: Crm360IdRoute,
  PeopleLedgerPrintIdRoute: PeopleLedgerPrintIdRoute,
  PeoplePrintIdRoute: PeoplePrintIdRoute,
  SettlementDraftPrintIdRoute: SettlementDraftPrintIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
